import i18n from "../locales/config";

import ConstData from "./ConstData";
import ConstCode from "./ConstCode";
import { enBrowserType, enRbmqError, enWebPage } from "./ConstCommand";
import { enTokenCMD, ctRcvKind, enP2PMode, enTabStatus } from "./classTalk/CodeEnum";
import { getSendToEncodeBytes, getSendToMQBytes } from "./classTalk/EncodeDecode";
import { isDevVersion, isEmptyObj, isUsableArrayObj, isWindowsWebView, sendToStudentApp } from "./func/ExportFunction";
import { saveLoginRecoveryPath, scheduleLoginRecoveryPath } from "./LoginRecoveryPath";

import {
    getDefaultDirectKey,
    getHandsUpDirectKey,
    getHandsUpSendKey,
    getHandsUpBindKey,
    getOtherDirectKey,
    getLocalServerKey
} from "./rbmq/rbmqKey";

import {
    rawDataWithRoutingKey,
    rcvCmd_AndroidCaptureStatus,
    rcvCmd_AndroidLogin,
    rcvCmd_AndroidLoginResp,
    rcvCmd_AndroidLogout,
    rcvCmd_AndroidLogoutResp,
    rcvCmd_AndroidReconnResp,
    rcvCmd_AndroidMicStatus,
} from "./rbmq/rcvMsgFromRbmq";

import {
    androidHandsUpInitDone,
    getIsAndroidDevice,
    sendMicStatus,
    getMicStatusEnabled,
    setIsForPblModeBrowser,
    isIOSWebView,
    isAndroidWebView,
    setScreenModeImage,
    setUpVideoStream,
    getHandsUpLiveSeq,
    getHandsUpUserSeq,
    getViewKind,
    getLocalStreamingMode,
    getIsForPblModeBrowser,
    setIsMixedClassMember
} from "./HandsUpClient";

import {
    initClientInfo,
    initClientInfoForClassMonitor,
    initClientInfoForGroupSmartTV,
    initClientInfoForSmartTV,
    initLiveInfo,
    sendJoinConsume,
    unsubscribe,
    sendAppCreateProducerTransport,
    producerTransportStateFromNative,
    rbmqRevivedFromNative,
} from "./MediaSoupClient";

import {
    logOut,
    rbmqServerConnected,
    rbmqServerDisconnected,
    rbmqServerError,
} from "../modules/user";

import {
    changeHandsUpStatusInfo, 
    requestJoinMixedClassLive,
    toggleReadyLiveConsume
} from "../modules/live";

import {
    connectedOnScreenApp,
    connectedOnScreenAppArr,
    disconnectedOnScreenApp,
    disconnectedOnScreenAppArr
} from "../modules/hiclasstv";
import { relayLive } from "./relay/PentalkRelayCamera"; // 20261022 web-relay 끊김 복구 재입장

let rbmqInfo = null;

let rbmqClient = null;
let rbmqClientID = null;

let rcvUserSeq;
let rcvTeacherInfo = {
    userSeq: -1,
    userNickname: "",
    userProfile: "",
    profileImgUrl: "",
    userGateWay: ""
};

let myUserSeq = -1;
let myGroupSeq = -1;
let myLiveSeq = -1;                     // 20260106 ... 

let handsUpRoutingIdx = -1;
let groupRoutingIdx = -1;
let routingIdx = -1;

let myRoutingKey = "";
let myRoutingKeyArr = [];
let myPenCamServiceKey = null;
let myPenCamServiceKeyArr = [];

// let isDevVer = false;                   // 20250509 ... 임시 for commit 시 주석 처리 실수 방지용 ... 테스트 기간 동안 주석 처리 방식 대신 사용하도록 변수 추가 ... by hjkim
let isMediaSoupVersion = true;          // 20250320 ... mediasoup 지원 버전 체크 변수 추가 ... by hjkim
let isGuestMember = false;
let isMixedClassMember = false;         // 20251224 ... 믹스드클래스 멤버인지 여부용 체크 변수 ... by hjkim
let isNeedSendUnsubscribe = true;
let isNeedSendSubscribe = false;
let isNeedCleanUp = false;
let classExitSafetyTimer = null;         // 260804 RabbitMQ 종료 콜백 유실 시 로그인 화면 이동을 보장한다.
let classExitNavigationTarget = "";
let isClassExitFinalized = false;
let isAlivePenCamService = false;
let isRunForSmartPen = false;
let isClickConnAppBtn = false;

let isSmartTVMode = false;
let smartTVTempKey = null;
let smartTVInfo = {
    seq: -1,
    liveSeq: -1,
    teacherSeq: -1,
    teacher_info: {
        userSeq: -1,
        userNickname: "",
        userProfile: "",
        profileImgUrl: "",
        userGateWay: ""
    },
    groupSeq: -1,
    userSeq: -1,
    userNickname: null,
    list_member: [],
    bindKey: null,
    bindKeyArr: [],
    teacherKey: null,
    isSend: false,
};

let currentBrowserType = enBrowserType.None;    // 20250709 ... 기본값 = enBrowserType.None ... by hjkim
let currentPageType = enWebPage.Home;

let myHandsUpSendKey = null;
let myHandsUpBindKeyArr = [];
let myTeacherDirectKey = null;

let mySmallGroupSendKey = null;
let mySmallGroupBindKeyArr = [];
let mySmallGroupImageSendKey = null;
let mySmallGroupImageBindKey = null;

let myTempBindKey = null;
let myLocalServerBindKey = null;

let localServerSendData = null;

let routingKey = "soup.server";

let consumeInfo = {
    imgSrc: null,
    startButton: null,
    smartTVImageProcess: null
};

let connectTimeoutTime = 30;                // 20260420 ... RabbitMQ 서버와 최초로 연결을 시도하는 제한 시간(ms)을 관리하는 변수 추가(단위는 밀리초(ms), 기본값은 30초 (30000ms)) ... by hjkim
let reconnectPeriodTime = 5;                // 20260408 ... RabbitMQ 서버와 연결이 끊어졌을 때 자동으로 재연결을 시도하는 간격(ms)을 관리하는 변수 추가(단위는 밀리초(ms), 수동 재연결 원하면 0 (자동 재연결 비활성화)) ... by hjkim
// let keepAliveIntervalTime = 5;              // 20250807 ... 일정 시간(keepalive)동안 아무 메시지도 안 오면 RabbitMQ 서버와 연결이 살아있는지 확인을 위한 간격(s)을 관리하는 변수 추가(단위는 초(s), 기본값은 60초 [** 권장값 - PC: 30초, 모바일: 20~30초 **]) ... by hjkim
let keepAliveIntervalTime = 30;             // 20250807 ... 일정 시간(keepalive)동안 아무 메시지도 안 오면 RabbitMQ 서버와 연결이 살아있는지 확인을 위한 간격(s)을 관리하는 변수 추가(단위는 초(s), 기본값은 60초 [** 권장값 - PC: 30초, 모바일: 20~30초 **]) ... by hjkim
// let keepAliveIntervalTime = 60;             // 20250807 ... RabbitMQ 서버와 연결이 끊기지 않도록 관리하는 변수 추가. keepAliveInterval 시간을 기존 30분에서 60초로 수정 ... by hjkim
// let keepAliveIntervalTime = 30 * 60;        // 20250807 ... RabbitMQ 서버와 연결이 끊기지 않도록 관리하는 변수 추가. keepAliveInterval 시간을 기존 30초에서 30분으로 늘림 ... by hjkim
// let keepAliveIntervalTimeForTest = 30;      // 20250911 ... RabbitMQ 서버와 연결이 끊기지 않도록 관리하는 변수 추가 for 테스트 서버. keepAliveInterval 시간을 기존 30초로 유지 ... by hjkim
// let keepAliveIntervalTimeForOther = 30;     // 20250808 & 20251030 ... RabbitMQ 서버와 연결이 끊기지 않도록 관리하는 변수 추가 for 스마트TV & Temp키. keepAliveInterval 시간을 기존 30초로 유지 ... by hjkim

let pingInterval = null;

let isIntentionalDisconnect = false;        // 20260406 ... 정상 종료를 구분하기 위한 변수 추가 ... by hjkim
let isDisconnecting = false;                // 20260406 ... 정상 종료를 구분하기 위한 변수 추가 ... by hjkim

/**
 * RabbitMQ 클라이언트 변수 상태값 초기화 함수
 * 
 * @since 2025-08-05.
 */
const initStateValue = () => {
    console.log("==================================================");
    console.log("initStateValue started...");
    console.log("- isDevVersion[", isDevVersion(), "]");
    console.log("- isMediaSoupVersion[", isMediaSoupVersion, "]");
    console.log("==================================================");

    myUserSeq = -1;
    myGroupSeq = -1;
    myLiveSeq = -1;

    handsUpRoutingIdx = -1;
    groupRoutingIdx = -1;
    routingIdx = -1;

    myRoutingKey = "";
    myRoutingKeyArr = [];
    myPenCamServiceKey = null;
    myPenCamServiceKeyArr = [];

    isGuestMember = false;
    isMixedClassMember = false;
    isNeedSendUnsubscribe = true;
    isNeedSendSubscribe = false;
    isNeedCleanUp = false;
    clearTimeout(classExitSafetyTimer);
    classExitSafetyTimer = null;
    classExitNavigationTarget = "";
    isClassExitFinalized = false;
    isAlivePenCamService = false;
    isRunForSmartPen = false;
    isClickConnAppBtn = false;

    isSmartTVMode = false;
    smartTVTempKey = null;
    smartTVInfo = {
        seq: -1,
        liveSeq: -1,
        teacherSeq: -1,
        teacher_info: {
            userSeq: -1,
            userNickname: "",
            userProfile: "",
            profileImgUrl: "",
            userGateWay: ""
        },
        groupSeq: -1,
        userSeq: -1,
        userNickname: null,
        list_member: [],
        bindKey: null,
        bindKeyArr: [],
        teacherKey: null,
        isSend: false,
    };

    currentBrowserType = enBrowserType.None;
    currentPageType = enWebPage.Home;

    myHandsUpSendKey = null;
    myHandsUpBindKeyArr = [];
    myTeacherDirectKey = null;
    syncIOSAudioSourceContext(); // 261015 iOS 앱 소리 설정 회신 키 해제

    mySmallGroupSendKey = null;
    mySmallGroupBindKeyArr = [];
    mySmallGroupImageSendKey = null;
    mySmallGroupImageBindKey = null;

    console.log("case 1:) initStateValue - myTempBindKey = null");
    myTempBindKey = null;
    myLocalServerBindKey = null;

    localServerSendData = null;

    routingKey = getServerDefaultRoutingKey();

    consumeInfo = {
        imgSrc: null,
        startButton: null,
        smartTVImageProcess: null
    };

    if (pingInterval) {
        clearInterval(pingInterval);
        pingInterval = null;
    }

    console.log("==================================================");
    console.log("initStateValue finished...");
    console.log("==================================================");
}

export const setRbmqInfo = async (userSeq, rbmq_info, userLoginPageType) => {
    console.log("========================================");
    console.log("setRbmqInfo 호출");
    console.log("========================================");
    console.log("userSeq:", userSeq);
    console.log("rbmq_info:", rbmq_info);
    console.log("userLoginPageType:", userLoginPageType);
    console.log("========================================");

    initStateValue();
    // initAvailableApp();
    isAlivePenCamService = false;
    isGuestMember = false;
    isMixedClassMember = false;
    myUserSeq = userSeq;
    myPenCamServiceKey = getDefaultDirectKey(userSeq, 3);
    myRoutingKey = getDefaultDirectKey(userSeq, 0);
    initClientInfo(userSeq, myRoutingKey);
    rbmqInfo = rbmq_info;

    currentPageType = userLoginPageType;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    setIsForPblModeBrowser(
        currentPageType === enWebPage.LiveQRLoginPbl || 
        currentPageType === enWebPage.LiveClassTalkPbl || 
        currentPageType === enWebPage.Pbl
    );

    try {
        // 연결 설정 생성
        let config = {
            // 사용자 정보
            userSeq: userSeq || -1,
            teacherSeq: rbmq_info.teacherSeq || 0,
            liveSeq: rbmq_info.liveSeq || -1,
            chatRoomSeq: rbmq_info.liveSeq || -1,

            // RabbitMQ 서버 정보
            ...rbmq_info,   // rbmq_info 정보 전체를 전달하도록 추가 ... by hjkim 20260422
            rbmqHost: rbmq_info.wsIp || rbmq_info.host || "",   // 기존 버전과 호환성을 위해 남겨둠
            rbmqPort: rbmq_info.port || 5672,                   // 기존 버전과 호환성을 위해 남겨둠

            // MixedClass 정보 (필요시)
            isMixedClassMember: false,
            localTeacherSeq: 0,
            localLiveSeq: 0,

            // Guest 정보 (필요시)
            isGuestMember,
            groupSendKey: "",

            // MediaSoup 관련 (필요시 ... 클래스 입장시에 전달하는데 필요한가...? ... by hjkim 20260413)
            userGateWay: rbmq_info.userGateWay || ""
        };

        console.log("RabbitMQ 설정 정보: ", config);

        if (isIOSWebView()) {
            console.log("setRbmqInfo - iOS WebView Native 연결 모드");

            config = {
                ...config,
                webBindKey: myRoutingKey
            };

            const message = {
                action: "pro-connectRbmq",
                data: config
            };

            window.webkit.messageHandlers.screenShareHandler.postMessage(message);
        } else if (isAndroidWebView()) {
            console.log("setRbmqInfo - Android WebView Native 연결 모드");

            try {
                window.startRabbitMQ(config);
            } catch (e) {
                console.error("setRbmqInfo (Android) - Exception:", e);
            }
        } else {
            console.log("setRbmqInfo - 기본 Web Browser 연결 모드");

            await connectRbmq();
        }
    } catch (err) {
        console.log("setRbmqInfo-connectRbmq() error => ", err);
    }
}

export const setRbmqInfoForGuest = async (userSeq, liveSeq, rbmq_info) => {
    console.log("========================================");
    console.log("setRbmqInfoForGuest 호출");
    console.log("========================================");
    console.log("userSeq:", userSeq);
    console.log("liveSeq:", liveSeq);
    console.log("rbmq_info:", rbmq_info);
    console.log("currentPageType:", enWebPage.Home);
    console.log("========================================");

    initStateValue();
    // initAvailableApp();
    isAlivePenCamService = false;
    isGuestMember = true;
    isMixedClassMember = false;
    myUserSeq = userSeq;
    myPenCamServiceKey = null;
    myRoutingKey = getOtherDirectKey(userSeq, "G", liveSeq);
    initClientInfo(userSeq, myRoutingKey);
    rbmqInfo = rbmq_info;

    currentPageType = enWebPage.Home;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    try {
        // 연결 설정 생성
        const config = {
            // 사용자 정보
            userSeq: userSeq || -1,
            teacherSeq: rbmq_info.teacherSeq || 0,
            liveSeq: rbmq_info.liveSeq || -1,
            chatRoomSeq: rbmq_info.liveSeq || -1,

            // RabbitMQ 서버 정보
            ...rbmq_info,   // rbmq_info 정보 전체를 전달하도록 추가 ... by hjkim 20260422
            rbmqHost: rbmq_info.wsIp || rbmq_info.host || "",   // 기존 버전과 호환성을 위해 남겨둠
            rbmqPort: rbmq_info.port || 5672,                   // 기존 버전과 호환성을 위해 남겨둠

            // MixedClass 정보 (필요시)
            isMixedClassMember: false,
            localTeacherSeq: 0,
            localLiveSeq: 0,

            // Guest 정보 (필요시)
            isGuestMember,
            groupSendKey: "",

            // MediaSoup 관련 (필요시 ... 클래스 입장시에 전달하는데 필요한가...? ... by hjkim 20260413)
            userGateWay: rbmq_info.userGateWay || ""
        };

        console.log("RabbitMQ 설정 정보:", config);

        if (isIOSWebView()) {
            // 여기에 iOS WebView용 코드 넣으면 됨 ... by hjkim 20251224
            console.log("setRbmqInfoForGuest - iOS Native WebView 연결 모드");
        } else if (isAndroidWebView()) {
            console.log("setRbmqInfoForGuest - Android WebView Native 연결 모드");

            try {
                window.startRabbitMQ(config);
            } catch (e) {
                console.error("setRbmqInfoForGuest (Android WebView) - Exception: ", e);
            }
        } else {
            console.log("setRbmqInfoForGuest - 기본 Web Browser 연결 모드");

            await connectRbmq();
        }
    } catch (err) {
        console.log("setRbmqInfoForGuest-connectRbmq() error => ", err);
    }
}

export const setRbmqInfoForMixedClass = async ({ tempBindKey, rbmq_info, mixedClass_info, userLoginPageType }) => {
    console.log("========================================");
    console.log("setRbmqInfoForMixedClass 호출");
    console.log("========================================");
    console.log("tempBindKey:" + tempBindKey);
    console.log("rbmq_info:" + rbmq_info);
    console.log("mixedClass_info:" + mixedClass_info);
    console.log("userLoginPageType:" + userLoginPageType);
    console.log("========================================");

    initStateValue();
    // initAvailableApp();
    isAlivePenCamService = false;
    isGuestMember = false;
    // myUserSeq = userSeq;
    myPenCamServiceKey = null;
    myTempBindKey = tempBindKey;
    myLocalServerBindKey = getLocalServerKey(mixedClass_info.localServerSeq);
    localServerSendData = mixedClass_info;
    rbmqInfo = rbmq_info;

    // currentPageType = enWebPage.MixedClassLogin;
    currentPageType = userLoginPageType;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    isMixedClassMember = true;
    setIsMixedClassMember(true);

    setIsForPblModeBrowser(
        currentPageType === enWebPage.MixedClassQRLoginPbl || 
        currentPageType === enWebPage.MixedClassLiveClassTalkPbl || 
        currentPageType === enWebPage.MixedClassPbl
    );

    console.log("========================================");
    console.log("myTempBindKey:", myTempBindKey);
    console.log("rbmqInfo:", rbmqInfo);
    console.log("localServerSendData:", localServerSendData);
    console.log("currentPageType:", currentPageType);
    console.log("========================================");

    try {
        // 연결 설정 생성
        const config = {
            // 사용자 정보
            // userSeq: userSeq || -1,
            // teacherSeq: rbmq_info.teacherSeq || 0,
            // liveSeq: rbmq_info.liveSeq || -1,
            // chatRoomSeq: rbmq_info.liveSeq || -1,

            // MixedClass 로그인 사용자 정보
            tempBindKey: myTempBindKey,

            // RabbitMQ 서버 정보
            ...rbmq_info,   // rbmq_info 정보 전체를 전달하도록 추가 ... by hjkim 20260422
            rbmqHost: rbmq_info.wsIp || rbmq_info.host || "",   // 기존 버전과 호환성을 위해 남겨둠
            rbmqPort: rbmq_info.port || 5672,                   // 기존 버전과 호환성을 위해 남겨둠

            // MixedClass 정보 (필요시)
            isMixedClassMember,
            localTeacherSeq: mixedClass_info.localTeacherSeq,
            localLiveSeq: mixedClass_info.localLiveSeq,

            // Guest 정보 (필요시)
            isGuestMember,
            groupSendKey: "",

            // MediaSoup 관련 (필요시 ... 클래스 입장시에 전달하는데 필요한가...? ... by hjkim 20260413)
            userGateWay: rbmq_info.userGateWay || ""
        };

        console.log("RabbitMQ 설정 정보:", config);
        
        if (isIOSWebView()) {
            // 여기에 iOS WebView용 코드 넣으면 됨 ... by hjkim 20251224
            console.log("setRbmqInfoForMixedClass - iOS Native WebView 연결 모드");

            const message = {
                action: "pro-connectRbmq",
                data: config
            };

            window.webkit.messageHandlers.screenShareHandler.postMessage(message);
        } else if (isAndroidWebView()) {
            console.log("setRbmqInfoForMixedClass - Android WebView Native 연결 모드");

            try {
                window.startRabbitMQ(config);
            } catch (e) {
                console.error("setRbmqInfo (Android) - Exception:", e);
            }
        } else {
            console.log("setRbmqInfoForMixedClass - 기본 Web Browser 연결 모드");

            await connectRbmqForMixedClass();
        }
    } catch (err) {
        console.log("setRbmqInfoForMixedClass-connectRbmqForMixedClass() error => ", err);
    }
}

export const setRbmqInfoForSmartTV = async (userSeq, userNickname, rbmq_info, tempKey, live_info) => {
    initStateValue();
    // initAvailableApp();
    isSmartTVMode = true;
    isAlivePenCamService = false;
    isGuestMember = false;
    smartTVTempKey = tempKey;
    smartTVInfo.liveSeq = live_info.liveSeq;
    smartTVInfo.teacherSeq = live_info.teacher_info.userSeq;
    smartTVInfo.teacher_info = live_info.teacher_info;
    smartTVInfo.groupSeq = -1;
    smartTVInfo.userSeq = userSeq;
    smartTVInfo.userNickname = userNickname;
    smartTVInfo.list_member = [
        { userSeq, userNickname }
    ];
    smartTVInfo.isSend = false;
    myUserSeq = userSeq;
    myGroupSeq = -1;
    myPenCamServiceKey = getDefaultDirectKey(userSeq, 3);
    myRoutingKey = getDefaultDirectKey(userSeq, 4);
    initClientInfoForSmartTV(userSeq, myRoutingKey);
    rbmqInfo = rbmq_info;

    currentPageType = enWebPage.SmartTV;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    try {
        await connectRbmqForSmartTV();
    } catch (err) {
        console.log("setRbmqInfoForSmartTV-connectRbmq() error => ", err);
    }
}

export const setRbmqInfoForGroupSmartTV = async (group_info, rbmq_info, tempKey, live_info) => {
    initStateValue();
    // initAvailableApp();
    isSmartTVMode = true;
    isAlivePenCamService = false;
    isGuestMember = false;
    smartTVTempKey = tempKey;
    smartTVInfo.liveSeq = live_info.liveSeq;
    smartTVInfo.teacherSeq = live_info.teacher_info.userSeq;
    smartTVInfo.teacher_info = live_info.teacher_info;
    smartTVInfo.groupSeq = group_info.groupSeq;
    smartTVInfo.userSeq = group_info.groupSeq;
    smartTVInfo.userNickname = group_info.groupName;
    smartTVInfo.list_member = group_info.list_member ? group_info.list_member : [];
    smartTVInfo.isSend = false;
    myUserSeq = group_info.groupSeq;
    myGroupSeq = group_info.groupSeq;
    routingIdx = -1;
    rbmqInfo = rbmq_info;

    currentPageType = enWebPage.GroupSmartTV;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    // console.log(group_info);

    if (group_info.list_member) {
        for (let i = 0; i < group_info.list_member.length; i++) {
            let myPenCamServiceKey = getDefaultDirectKey(group_info.list_member[i].userSeq, 3);
            let myRoutingKey = getDefaultDirectKey(group_info.list_member[i].userSeq, 4);

            // console.log(`i[${i}], myRoutingKey[${myRoutingKey}], myPenCamServiceKey[${myPenCamServiceKey}]`);

            myPenCamServiceKeyArr.push(myPenCamServiceKey);
            myRoutingKeyArr.push(myRoutingKey);
        }
    }

    // console.log("myRoutingKeyArr => ", myRoutingKeyArr);
    // myPenCamServiceKey = getDefaultDirectKey(group_info.groupSeq, 3);
    // myRoutingKey = getDefaultDirectKey(group_info.groupSeq, 4);
    initClientInfoForGroupSmartTV(group_info.groupSeq, group_info.list_member, myRoutingKeyArr);

    try {
        await connectRbmqForGroupSmartTV();
    } catch (err) {
        console.log("setRbmqInfoForGroupSmartTV-connectRbmq() error => ", err);
    }
}

/**
 * 새 정보로 스마트TV 그룹 정보 설정하는 메서드.
 * 
 * @param {JSON} group_info - 다시 구독할 스마트TV 그룹 정보
 * @since 2025-11-20.
 */
export const setRbmqInfoForGroupSmartTVNewInfo = async (group_info) => {
    if (!group_info) {
        console.log("setRbmqInfoForGroupSmartTVNewInfo() - error ... group_info => ", group_info);
        return;
    }

    smartTVInfo.groupSeq = group_info.groupSeq;
    smartTVInfo.userSeq = group_info.groupSeq;
    smartTVInfo.userNickname = group_info.groupName;
    smartTVInfo.list_member = group_info.list_member ? group_info.list_member : [];
    smartTVInfo.isSend = false;

    myUserSeq = group_info.groupSeq;
    myGroupSeq = group_info.groupSeq;

    currentPageType = enWebPage.GroupSmartTV;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    // 기존 구독 중인 routing key 목록 백업
    const prevRoutingKeys = Array.isArray(myRoutingKeyArr) ? [...myRoutingKeyArr] : [];

    // 새 배열 초기화
    myPenCamServiceKeyArr = [];
    myRoutingKeyArr = [];

    if (group_info.list_member) {
        for (let i = 0; i < group_info.list_member.length; i++) {
            let penCamServiceKey = getDefaultDirectKey(group_info.list_member[i].userSeq, 3);
            let routingKey = getDefaultDirectKey(group_info.list_member[i].userSeq, 4);

            myPenCamServiceKeyArr.push(penCamServiceKey);
            myRoutingKeyArr.push(routingKey);
        }
    }

    initClientInfoForGroupSmartTV(group_info.groupSeq, group_info.list_member, myRoutingKeyArr);

    try {
        if (!rbmqClient) {
            console.log("setRbmqInfoForGroupSmartTVNewInfo() - rbmqClient is null");
            return;
        }

        if (pingInterval === null) {
            pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
        }

        console.log("prevRoutingKeys => ", prevRoutingKeys);
        console.log("new myRoutingKeyArr => ", myRoutingKeyArr);

        const newTopics = Array.isArray(myRoutingKeyArr)
            ? myRoutingKeyArr.filter(key => key && key !== "")
            : [];

        const unsubscribePrevTopics = () => {
            if (prevRoutingKeys.length > 0) {
                unsubscribeTopics(prevRoutingKeys, {
                    timeoutSec: 3,
                    onSuccess: function (msg) {
                        console.log("setRbmqInfoForGroupSmartTVNewInfo - previous unsubscribe success => ", msg);
                    },
                    onFailure: function (res) {
                        console.log("setRbmqInfoForGroupSmartTVNewInfo-unsubscribe() err => ", res);
                        onFailureUnsubscribeLiveForSmartTV(res);
                    },
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            }
        };

        if (newTopics.length > 0) {
            // 기존 것 먼저 정리
            unsubscribePrevTopics();

            // 새 토픽 구독
            subscribeTopics(newTopics, {
                qos: 1,
                timeoutSec: 3,
                onSuccess: function (msg) {
                    console.log("setRbmqInfoForGroupSmartTVNewInfo - subscribe success => ", msg);
                    onSuccessSubscribeForGroupSmartTV(msg);
                },
                onFailure: function (res) {
                    console.log("setRbmqInfoForGroupSmartTVNewInfo-subscribe() err => ", res);
                    onFailureSubscribe(res);
                },
                failureCode: enRbmqError.INTERNAL_ERROR
            });
        } else {
            console.log("setRbmqInfoForGroupSmartTVNewInfo() - myRoutingKeyArr is empty => ", myRoutingKeyArr);

            // 새 토픽이 없어도 예전 토픽은 정리
            unsubscribePrevTopics();
        }
    } catch (err) {
        console.log("setRbmqInfoForGroupSmartTVNewInfo() err => ", err);
    }
}

export const initSmartTVInfo = (live_info) => {
    // console.log("initSmartTVInfo - ", live_info);
    if (live_info) {
        smartTVInfo.liveSeq = live_info.liveSeq;
        smartTVInfo.teacherSeq = live_info.teacher_info.userSeq;
        smartTVInfo.teacher_info = live_info.teacher_info;
    }
}

export const subscribeLoginForMixedClass = async (userSeq, liveSeq) => {
    console.log("========================================");
    console.log("subscribeLoginForMixedClass 호출");
    console.log("========================================");
    console.log("userSeq: ", userSeq);
    console.log("liveSeq: ", liveSeq);
    console.log("rbmq_info: ", rbmqInfo);
    console.log("localServerSendData: ", localServerSendData);
    console.log("========================================");

    // let store = window.hiclasstv.store;
    // const { user } = store.getState();
    // const { isRbmqServerConnected } = user;

    // initAvailableApp();
    isAlivePenCamService = false;
    myUserSeq = userSeq;
    // myPenCamServiceKey = getDefaultDirectKey(userSeq, 3);
    myPenCamServiceKey = getOtherDirectKey(userSeq, 3, liveSeq); // cloud 의 기존 user 와 겹치기 않기 위해 수정 by hjkim 20230404
    myRoutingKey = getOtherDirectKey(userSeq, "M", liveSeq);
    initClientInfo(userSeq, myRoutingKey);

    try {
        if (isIOSWebView()) {
            // 여기에 iOS WebView용 코드 넣으면 됨 ... by hjkim 20251224
            console.log("subscribeLoginForMixedClass - iOS Native WebView 구독 모드");
        
            if (myTempBindKey && myTempBindKey !== "") {
                const message = {
                    action: "pro-unsubscribeTempKey",
                    data: { bindKey: myTempBindKey }
                }

                window.webkit.messageHandlers.screenShareHandler.postMessage(message);
            }
        } else if (isAndroidWebView()) {
            console.log("subscribeLoginForMixedClass - Android WebView Native 구독 모드");

            console.log(`subscribeLoginForMixedClass - myTempBindKey => ` + myTempBindKey);
            if (myTempBindKey && myTempBindKey !== "") {
                // ✅ 로그인 정보와 함께 전달
                console.log("Android - unsubscribeTempKey 호출:");
                console.log("  - tempKey:", myTempBindKey);
                console.log("  - userSeq:", userSeq);
                console.log("  - liveSeq:", liveSeq);
                let teacherSeq = localServerSendData.teacher_info ? localServerSendData.teacher_info.userSeq : -1;
                let chatRoomSeq = localServerSendData.teacher_info ? localServerSendData.teacher_info.chatRoomSeq : -1;
                console.log("  - teacherSeq:", teacherSeq);
                console.log("  - chatRoomSeq:", chatRoomSeq);

                window.unsubscribeTempKey(myTempBindKey, userSeq, liveSeq, teacherSeq, chatRoomSeq);
            } else {
                console.log("subscribeLoginForMixedClass() - myTempBindKey => ", myTempBindKey);
                window.alert("subscribeLoginForMixedClass() - myTempBindKey => " + myTempBindKey);
            }
        } else { // 기존 코드대로 동작
            console.log("subscribeLoginForMixedClass - 기본 Web Browser 구독 모드");

            if (rbmqClient) {
                try {
                    console.log(`subscribeLoginForMixedClass - myTempBindKey => ` + myTempBindKey);
                    if (myTempBindKey && myTempBindKey !== "") {
                        unsubscribeTopics([myTempBindKey], {
                            timeoutSec: 3,
                            onSuccess: onSuccessUnsubscribeTempKeyForMixedClass,
                            onFailure: onFailureUnsubscribe,
                            failureCode: enRbmqError.INTERNAL_ERROR
                        });
                    } else {
                        console.log("subscribeLoginForMixedClass() - myTempBindKey => " + myTempBindKey);
                        window.alert("subscribeLoginForMixedClass() - myTempBindKey => " + myTempBindKey);
                    }
                } catch (err) {
                    console.log("------subscribeLoginForMixedClass unsubscribe------ error => ", err);
                }
            }
        }
    } catch(err) {
        console.log("subscribeLoginForMixedClass-subscribe() error => ", err);
    }
}

/**
 * 스몰 그룹(= 모둠 수업) 멤버 정보 저장 및 그룹 키 구독 요청을 하고,
 * 각 멤버에게 joinConsume 요청을 처리한다.
 * 
 * @param {String} sendKey - 스몰 그룹 멤버들에게 메시지를 보낼 때 사용할 SendKey
 * @param {Array} bindKeyArr - 구독할 스몰 그룹 멤버 BindKey 배열
 * @modify 2025-12-24. (메서드명 변경)
 */
export const subscribeSmallGroup = (sendKey, bindKeyArr) => {
    console.log(`subscribeSmallGroup - sendKey[${sendKey}], bindKeyArr[${bindKeyArr}]`);

    try {
        groupRoutingIdx = -1;
        setMySmallGroupInfo(sendKey, bindKeyArr);
        joinSmallGroupRoom(bindKeyArr);
    } catch (err) {
        console.log("subscribeSmallGroup-joinSmallGroup() error => ", err);
    } finally {
        // console.log("subscribeSmallGroup-joinSmallGroup() finish");
    }
}

/**
 * 스몰 그룹(= 모둠 수업) 정보 초기화 및 구독 정리 요청을 처리한다.
 * 
 * @modify 2025-12-24. (메서드명 변경)
 */
export const unsubscribeSmallGroup = () => {
    if (!isUsableArrayObj(mySmallGroupBindKeyArr)) return;  // 스몰 그룹 바인드 키 배열 정보가 유효하지 않을 경우 리턴하도록 수정 ... by hjkim 20251113

    try {
        leaveSmallGroupRoom(mySmallGroupBindKeyArr);    // 위에서 스몰 그룹 바인드 키 배열 유효성 확인했으니 다시 확인하지 않음 ... by hjkim 20251113
    } catch (err) {
        console.log("unsubscribeSmallGroup-leaveSmallGroupRoom() error => ", err);
    } finally {
        setMySmallGroupInfo(null, []);
    }
}

// teacher_info : { userSeq, userNickname, userProfile, profileImgUrl, userGateWay }
export const reconnectLive = () => {
    // try {
    //     isNeedSendSubscribe = true;
    //     joinRoom(bindKeyArr, liveSeq);
    // } catch (err) {
    //     console.log("reconnectLive-joinRoom() error => ", err);
    // } finally {
    //     // console.log("reconnectLive-joinRoom() finish");
    // }
    isNeedSendSubscribe = true;
    onSuccessSubscribeLive();
}

export const connectLive = (liveSeq, rcvSeq, teacher_info) => {
    console.log("connectLive - liveSeq, rcvSeq, teacher_info => ", liveSeq, rcvSeq, teacher_info);

    try {
        rcvUserSeq = rcvSeq;
        myLiveSeq = liveSeq;
        myTeacherDirectKey = getHandsUpDirectKey(rcvUserSeq, liveSeq, myUserSeq, 0);
        syncIOSAudioSourceContext(); // 261015 iOS 앱에 소리 설정 회신 키 등록

        let userGateWay = teacher_info.userGateWay;
        if (userGateWay && userGateWay !== "") {
            routingKey = userGateWay;
        } else {
            routingKey = getServerDefaultRoutingKey();
        }
        console.log("connectLive - userGateWay[", userGateWay, "], routingKey[", routingKey, "]");

        handsUpRoutingIdx = -1;

        let sendKey = getHandsUpSendKey(rcvUserSeq, liveSeq, myUserSeq);
        let bindKeyArr = getHandsUpBindKey(rcvUserSeq, myUserSeq);

        initLiveInfo(liveSeq, rcvUserSeq, teacher_info);
        setMyLiveInfo(sendKey, bindKeyArr);

        isNeedSendSubscribe = true;
        joinRoom(bindKeyArr, liveSeq);
    } catch (err) {
        console.log("connectLive-joinRoom() error => ", err);
    } finally {
        // console.log("connectLive-joinRoom() finish");
    }
}

export const disconnectLive = () => {
    if (!isUsableArrayObj(myHandsUpBindKeyArr)) return; // 핸즈업 바인드 키 배열 정보가 유효하지 않을 경우 리턴하도록 수정 ... by hjkim 20251113

    try {
        console.log("disconnectLive - (before) isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");
        isNeedSendUnsubscribe = false;
        isNeedCleanUp = false;
        console.log("disconnectLive - (after) isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");

        leaveRoom(myHandsUpBindKeyArr); // 위에서 핸즈업 바인드 키 배열 유효성 확인했으니 다시 확인하지 않음 ... by hjkim 20251113
    } catch (err) {
        console.log("disconnectLive-leaveRoom() error => ", err);
    } finally {
        setMyLiveInfo(null, []);
    }
}

export const disconnectLiveForQRLogin = () => {
    try {
        console.log("disconnectLiveForQRLogin - (before) isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");
        isNeedSendUnsubscribe = true;
        isNeedCleanUp = true;
        console.log("disconnectLiveForQRLogin - (after) isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");

        // 260804 정상 종료 콜백은 그대로 우선하고, 콜백 유실 시에만 5초 후 안전 이동한다.
        startClassExitSafetyTimer();

        if (isUsableArrayObj(myHandsUpBindKeyArr)) {
            leaveRoom(myHandsUpBindKeyArr);
        } else {
            // 260804 Live 바인드 키가 없어도 전체 RabbitMQ 연결 정리는 계속한다.
            console.log("disconnectLiveForQRLogin - no live bind key. disconnect RabbitMQ directly.");
            disconnectRbmq("exit-without-live-bind-key");
        }
    } catch (err) {
        console.log("disconnectLiveForQRLogin-leaveRoom() error => ", err);
    } finally {
        setMyLiveInfo(null, []);
    }
}

export const disconnectLiveForMixedLogin = () => {
    try {
        console.log("disconnectLiveForMixedLogin - (before) isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");
        isNeedSendUnsubscribe = true;
        isNeedCleanUp = true;
        console.log("disconnectLiveForMixedLogin - (after) isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");

        // 260804 정상 종료 콜백은 그대로 우선하고, 콜백 유실 시에만 5초 후 안전 이동한다.
        startClassExitSafetyTimer();

        if (isUsableArrayObj(myHandsUpBindKeyArr)) {
            leaveRoom(myHandsUpBindKeyArr);
        } else {
            // 260804 Live 바인드 키가 없어도 전체 RabbitMQ 연결 정리는 계속한다.
            console.log("disconnectLiveForMixedLogin - no live bind key. disconnect RabbitMQ directly.");
            disconnectRbmq("exit-without-live-bind-key");
        }
    } catch (err) {
        console.log("disconnectLiveForMixedLogin-leaveRoom() error => ", err);
    } finally {
        setMyLiveInfo(null, []);
    }
}

export const connectLiveForSmartTV = (bindKeyArr, startSeqOfSmartTV, userGateWay) => {
    console.log(`connectLiveForSmartTV => `, bindKeyArr, startSeqOfSmartTV, userGateWay);
    try {
        smartTVInfo.seq = startSeqOfSmartTV;
        smartTVInfo.bindKeyArr = bindKeyArr;
        smartTVInfo.bindKey = bindKeyArr[1];

        // 스마트TV는 sendKey 이슈로 인해 클래스에 참여 후인 지금 PING을 보내도록 처리 ... by hjkim 20260413
        if (pingInterval === null) {
            pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
        }

        if (userGateWay && userGateWay !== "") {
            routingKey = userGateWay;
        } else {
            routingKey = getServerDefaultRoutingKey();
        }
        console.log("connectLiveForSmartTV - userGateWay[", userGateWay, "], routingKey[", routingKey, "]");

        initClientInfo(smartTVInfo.seq, smartTVInfo.bindKeyArr[1]);
        initLiveInfo(smartTVInfo.liveSeq, smartTVInfo.teacherSeq, smartTVInfo.teacher_info);

        if (rbmqClient) {
            if (smartTVTempKey && smartTVTempKey !== "") {
                unsubscribeTopics([smartTVTempKey], {
                    timeoutSec: 3,
                    onSuccess: onSuccessUnsubscribeTempKeyForSmartTV,
                    onFailure: onFailureUnsubscribeTempKeyForSmartTV,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("connectLiveForSmartTV() - smartTVTempKey => ", smartTVTempKey);
                window.alert("connectLiveForSmartTV() - smartTVTempKey => " + smartTVTempKey);
            }
        }
    } catch (err) {
        console.log("connectLiveForSmartTV error => ", err);
    }
}

export const disconnectLiveForSmartTV = () => {
    if (!isUsableArrayObj(smartTVInfo.bindKeyArr)) return;  // 스마트TV 바인드 키 배열 정보가 유효하지 않을 경우 리턴하도록 수정 ... by hjkim 20251113

    try {
        // unsubscribe(false, true, true);

        if (rbmqClient) {
            const topics = Array.isArray(smartTVInfo.bindKeyArr)
                ? smartTVInfo.bindKeyArr.filter(key => key && key !== "")
                : [];

            if (topics.length > 0) {
                unsubscribeTopics(topics, {
                    timeoutSec: 3,
                    onSuccess: onSuccessUnsubscribeLiveForSmartTV,
                    onFailure: onFailureUnsubscribeLiveForSmartTV,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("disconnectLiveForSmartTV() - smartTVInfo.bindKeyArr[0] => ", smartTVInfo.bindKeyArr[0]);
                window.alert("disconnectLiveForSmartTV() - smartTVInfo.bindKeyArr[0] => " + smartTVInfo.bindKeyArr[0]);
            }
        }
    } catch (err) {
        console.log("disconnectLiveForSmartTV error => ", err);
    } finally {
        if (pingInterval) {
            clearInterval(pingInterval);
            pingInterval = null;
        }

        smartTVInfo.bindKey = null;
        smartTVInfo.bindKeyArr = [];
        smartTVInfo.list_member = [];
    }
}

export const rcvClose = () => {
    // myTeacherDirectKey = null;
    // exitConsume("live", rcvUserSeq);
}

const setMyLiveInfo = (sendKey, bindKeyArr) => {
    myHandsUpSendKey = sendKey;
    myHandsUpBindKeyArr = bindKeyArr;
    console.log("setMyLiveInfo - myHandsUpSendKey[", myHandsUpSendKey, "]");
}

export const initMyLiveInfo = (liveInfo) => {
    console.log("initMyLiveInfo - liveInfo => ", liveInfo);
    if (liveInfo && liveInfo.teacher_info) {
        let rcvSeq = liveInfo.teacher_info.userSeq;
        let liveSeq = liveInfo.liveSeq;
        let userGateWay = liveInfo.teacher_info.userGateWay;

        rcvUserSeq = rcvSeq;
        rcvTeacherInfo = liveInfo.teacher_info;
        myLiveSeq = liveSeq;
        myTeacherDirectKey = getHandsUpDirectKey(rcvSeq, liveSeq, myUserSeq, 0);
        syncIOSAudioSourceContext(); // 261015 iOS 앱에 소리 설정 회신 키 등록

        let sendKey = getHandsUpSendKey(rcvUserSeq, liveSeq, myUserSeq);
        let bindKeyArr = getHandsUpBindKey(rcvUserSeq, myUserSeq);

        myHandsUpSendKey = sendKey;
        myHandsUpBindKeyArr = bindKeyArr;

        if (userGateWay && userGateWay !== "") {
            routingKey = userGateWay;
        } else {
            routingKey = getServerDefaultRoutingKey();
        }
        console.log("initMyLiveInfo - userGateWay[", userGateWay, "], routingKey[", routingKey, "]");
    } else { // liveInfo가 없는 경우 기존 정보 초기화하도록 수정
        console.log("initMyLiveInfo - liveInfo 없음! 기존 정보 초기화해야 함");

        rcvUserSeq = -1;
        rcvTeacherInfo = {
            userSeq: -1,
            userNickname: "",
            userProfile: "",
            profileImgUrl: "",
            userGateWay: ""
        };
        myLiveSeq = -1;
        myTeacherDirectKey = null;
        syncIOSAudioSourceContext(); // 261015 iOS 앱 소리 설정 회신 키 해제

        myHandsUpSendKey = null;
        myHandsUpBindKeyArr = [];

        routingKey = getServerDefaultRoutingKey();
        routingIdx = -1;
    }
}

const setMySmallGroupInfo = (sendKey, bindKeyArr) => {
    mySmallGroupSendKey = sendKey;
    mySmallGroupBindKeyArr = bindKeyArr;

    // 여기부터 기존 코드 ... by hjkim
    /* if (sendKey && sendKey !== "" && bindKey && bindKey !== "") {
        mySmallGroupImageSendKey = sendKey + ".i";
        mySmallGroupImageBindKey = bindKey + ".i";
        mySmallGroupImageSendKey = sendKey.replace("G.", "I.");
        mySmallGroupImageBindKey = bindKey.replace("G.", "I.");
    } */
    // 여기까지 기존 코드 ... by hjkim

    if (sendKey && sendKey !== "" && isUsableArrayObj(bindKeyArr)) {
        mySmallGroupImageSendKey = sendKey;
        mySmallGroupImageBindKey = bindKeyArr;
    } else {
        mySmallGroupImageSendKey = null;
        mySmallGroupImageBindKey = [];
    }
}

export const initImageSrc = (imgSrc) => {
    console.log("initImageSrc ------ ", imgSrc.width, imgSrc.height);
    consumeInfo.imgSrc = imgSrc;
}

export const setImageSrc = (img) => {
    console.log("setImageSrc - ", img.width, img.height);
    if (consumeInfo.imgSrc && consumeInfo.imgSrc !== "") {
        consumeInfo.imgSrc(img);
    } else {
        console.log("setImageSrc() - consumeInfo.imgSrc => ", consumeInfo.imgSrc);
    }
}

export const initSmartTVImageProc = (imageProc) => {
    consumeInfo.smartTVImageProcess = imageProc;
}

export const updateSmartTVImage = (imageData) => {
    if (consumeInfo.smartTVImageProcess && consumeInfo.smartTVImageProcess !== "") {
        consumeInfo.smartTVImageProcess("update", imageData);
    } else {
        console.log("updateSmartTVImage() - consumeInfo.updateSmartTVImage => ", consumeInfo.updateSmartTVImage);
    }
}

export const getTeacherSeq = () => {
    return rcvUserSeq;
}

export const getMyUserSeq = () => {
    return myUserSeq;
}

/**
 * 저장된 클래스 번호를 반환하는 메서드.
 * 
 * @returns {Number} 클래스(= 라이브) 번호 반환
 * @since 2026-01-06.
 */
export const getMyLiveSeq = () => {
    return myLiveSeq;
}

/**
 * 현재 참여 중인 클래스의 번호를 반환하는 메서드.
 * 
 * @returns {Number} 클래스(= 라이브) 번호 반환
 * @since 2026-01-06.
 */
export const getPerformLiveSeq = () => {
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;
    const liveSeq = performLiveInfo.liveSeq;
    console.log("getPerformLiveSeq - liveSeq[" + liveSeq + "]");

    return liveSeq;
}

/**
 * 미디어 수프 서버 라우팅 키 기본값을 반환한다.
 * 
 * @returns {String} 미디어 수프 서버 라우팅 키 기본값
 * @since 2026-04-13.
 */
export const getServerDefaultRoutingKey = () => {
    if (ConstData.IS_LOCAL_VERSION || isDevVersion()) {
        return "soup.server";
    } else {
        return "soup.server.1";
    }
}

export const getMyRoutingKey = () => {
    return myRoutingKey;
}

export const getMyHandsUpSendKey = () => {
    return myHandsUpSendKey;
}

export const getMySmallGroupSendKey = () => {
    return mySmallGroupSendKey;
}

export const getMySmallGroupImageSendKey = () => {
    return mySmallGroupImageSendKey;
}

export const getRabbitMQTokenKey = () => {
    let key = {
        webBindKey: myRoutingKey, // 로그인 하자마자
        handsupBindKeyArr: myHandsUpBindKeyArr, // 라이브 
        sendKey: myTeacherDirectKey, //tKey
        sgKey: mySmallGroupImageSendKey
    };

    return key;
}

/**
 * RabbitMQ를 의도적으로 종료하고 있는지(disconnectRbmq 흐름)
 * 여부의 값을 설정하는 메서드.
 * 
 * @param {Boolean} isIntentional - 의도적 종료인지 여부
 * @since 2026-04-13.
 */
export const setIsIntentionalDisconnect = (isIntentional) => {
    isIntentionalDisconnect = isIntentional;
}

export const getIsAlivePenCamService = (userSeq) => {
    let store = window.hiclasstv.store;
    const { hiclasstv } = store.getState();

    if (currentPageType === enWebPage.GroupSmartTV) {
        const { list_isConnectedOnScreenApp } = hiclasstv;

        const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find(info => info.userSeq === userSeq);
        // console.log("getIsAlivePenCamService (for group) - ", connectedOnScreenApp_info);
        if (connectedOnScreenApp_info) {
            return connectedOnScreenApp_info.isConnectedOnScreenApp;
        } else {
            return false;
        }
    } else {
        const { isConnectedOnScreenApp } = hiclasstv;
        // console.log("getIsAlivePenCamService (for default) - ", isConnectedOnScreenApp);

        return isConnectedOnScreenApp;
        // return isAlivePenCamService;
    }
}

export const setIsAlivePenCamService = (isAlive, userSeq) => {
    isAlivePenCamService = isAlive;
    if (window.hiclasstv) {
        let store = window.hiclasstv.store;

        if (currentPageType === enWebPage.GroupSmartTV) {
            if (isAlive) {
                store.dispatch(connectedOnScreenAppArr({ userSeq }));
            } else {
                store.dispatch(disconnectedOnScreenAppArr({ userSeq }));
            }
        } else {
            if (isAlive) {
                store.dispatch(connectedOnScreenApp());
                store.dispatch(connectedOnScreenAppArr({ userSeq }));
            } else {
                store.dispatch(disconnectedOnScreenApp());
                store.dispatch(disconnectedOnScreenAppArr({ userSeq }));
            }
        }

        /* if (isAlive) {
            store.dispatch(connectedOnScreenAppArr({ userSeq }));
        } else {
            store.dispatch(disconnectedOnScreenAppArr({ userSeq }));
        } */
    }
}

export const getIsAlivePenCamServiceForGroupSmartTV = (userSeq) => {
    let store = window.hiclasstv.store;
    const { hiclasstv } = store.getState();
    const { list_isConnectedOnScreenApp } = hiclasstv;

    const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find(info => info.userSeq === userSeq);
    console.log("getIsAlivePenCamServiceForGroup - ", connectedOnScreenApp_info);
    if (connectedOnScreenApp_info) {
        return connectedOnScreenApp_info.isConnectedOnScreenApp;
    } else {
        return false;
    }
}

export const setIsAlivePenCamServiceForGroupSmartTV = (userSeq, isAlive) => {
    console.log("setIsAlivePenCamServiceForGroupSmartTV - ", userSeq, isAlive);
    isAlivePenCamService = isAlive;
    if (window.hiclasstv) {
        let store = window.hiclasstv.store;
        if (isAlive) {
            store.dispatch(connectedOnScreenAppArr({ userSeq }));
        } else {
            store.dispatch(disconnectedOnScreenAppArr({ userSeq }));
        }
    }
}

/**
 * 현재 브라우저 타입을 반환합니다.
 * 
 * @returns {enBrowserType}
 * @since 2025-07-09.
 */
export const getCurrentBrowserType = () => {
    console.log("getCurrentBrowserType => currentBrowserType[", currentBrowserType, "]");
    return currentBrowserType;
}

/**
 * 현재 브라우저 타입을 설정합니다.
 * 
 * @param {enBrowserType} browserType - 설정할 브라우저 타입
 * @since 2025-07-09.
 */
export const setCurrentBrowserType = (browserType) => {
    console.log("(1) setCurrentBrowserType => browserType[", browserType, "], currentBrowserType[", currentBrowserType, "]");
    currentBrowserType = browserType;
    console.log("(2) setCurrentBrowserType => currentBrowserType[", currentBrowserType, "]");
}

/**
 * 현재 페이지 타입을 반환합니다.
 * 
 * @returns {enWebPage}
 */
export const getCurrentPageType = () => {
    console.log("getCurrentPageType => currentPageType[", currentPageType, "]");
    return currentPageType;
}

/**
 * 현재 페이지 타입을 설정합니다.
 * 
 * @param {enWebPage} pageType - 설정할 페이지 타입
 * @since 2025-07-09.
 */
export const setCurrentPageType = (pageType) => {
    console.log("(1) setCurrentPageType - pageType[", pageType, "], currentPageType[", currentPageType, "]");
    currentPageType = pageType;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장
    console.log("(2) setCurrentPageType - currentPageType[", currentPageType, "]");
}

/**
 * 현재 페이지 타입이 스마트TV 페이지인지 여부를 반환합니다.
 * 
 * @returns {Boolean} 스마트TV 페이지 여부
 * @since 2025-08-11.
 */
export const getIsSmartTVCurrentPage = () => {
    console.log("getIsSmartTVCurrentPage - currentPageType[", currentPageType, "]");

    if (currentPageType === enWebPage.SmartTV ||
        currentPageType === enWebPage.SmartTVQRLogin ||
        currentPageType === enWebPage.GroupSmartTV ||
        currentPageType === enWebPage.GroupSmartTVQRLogin
    ) {
        return true;
    } else {
        return false;
    }
}

/**
 * 현재 페이지 타입이 pbl 페이지인지 여부를 반환합니다.
 * 
 * @returns {Boolean} pbl 페이지 여부
 * @since 2025-07-14.
 */
export const getIsPblCurrentPage = () => {
    if (currentPageType === enWebPage.LiveClassTalkPbl ||
        currentPageType === enWebPage.LiveQRLoginPbl ||
        currentPageType === enWebPage.Pbl ||
        currentPageType === enWebPage.MixedClassLiveClassTalkPbl ||
        currentPageType === enWebPage.MixedClassQRLoginPbl ||
        currentPageType === enWebPage.MixedClassPbl
    ) {
        return true;
    } else {
        return false;
    }
}

export const getIndexForGroupSmartTV = (userSeq) => {
    let store = window.hiclasstv.store;
    const { hiclasstv } = store.getState();
    const { list_isConnectedOnScreenApp } = hiclasstv;

    const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find(info => info.userSeq === userSeq);
    // console.log("getIndexForGroupSmartTV - ", connectedOnScreenApp_info);
    if (connectedOnScreenApp_info) {
        let idx = list_isConnectedOnScreenApp.indexOf(connectedOnScreenApp_info);
        return idx;
    } else {
        return -1;
    }
}

export const getConnectedOnScreenAppInfo = (userSeq) => {
    let store = window.hiclasstv.store;
    const { hiclasstv } = store.getState();
    const { list_isConnectedOnScreenApp } = hiclasstv;

    const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find(info => info.userSeq === userSeq);
    // console.log("getConnectedOnScreenAppInfo - ", connectedOnScreenApp_info);
    if (connectedOnScreenApp_info) {
        let idx = list_isConnectedOnScreenApp.indexOf(connectedOnScreenApp_info);
        return { idx, connectedOnScreenApp_info };
    } else {
        return { idx: -1, connectedOnScreenApp_info: null };
    }
}

export const getConnectedOnScreenAppInfoWithIndex = (idx) => {
    let store = window.hiclasstv.store;
    const { hiclasstv } = store.getState();
    const { list_isConnectedOnScreenApp } = hiclasstv;

    if (currentPageType === enWebPage.GroupSmartTV) {
        const connectedOnScreenApp_info = list_isConnectedOnScreenApp.find((info, index) => index === idx);
        console.log("getConnectedOnScreenAppInfoWithIndex - ", connectedOnScreenApp_info);
        if (connectedOnScreenApp_info) {
            //let idx = list_isConnectedOnScreenApp.indexOf(connectedOnScreenApp_info);
            return { idx, connectedOnScreenApp_info };
        } else {
            return { idx: -1, connectedOnScreenApp_info: null };
        }
    } else {
        const { isConnectedOnScreenApp } = hiclasstv;

        return {
            idx: -1,
            connectedOnScreenApp_info: {
                userSeq: smartTVInfo.userSeq,
                userNickname: smartTVInfo.userNickname,
                isConnectedOnScreenApp
            }
        };
    }
}

export const getIsNeedCleanUp = () => {
    console.log("getIsNeedCleanUp - isNeedCleanUp => ", isNeedCleanUp);
    return isNeedCleanUp;
}

export const setIsNeedCleanUp = (needCleanUp) => {
    console.log("setIsNeedCleanUp - needCleanUp => " + needCleanUp + ", isNeedCleanUp => " + isNeedCleanUp);
    isNeedCleanUp = needCleanUp;
    console.log("setIsNeedCleanUp - isNeedCleanUp => ", isNeedCleanUp);
}

/**
 * 핸즈업이 시작되었는지 여부를 반환
 * 
 * @returns {Boolean} - 핸즈업이 시작되었는지 여부
 */
export const getIsHandsUpStarted = () => {
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    if (performLiveInfo.liveSeq >= 0) {
        if (performLiveInfo.handsUpYN === "Y") {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

/**
 * 핸즈업이 액티브 모드인지 여부를 반환
 * 
 * @returns {Boolean} - 핸즈업이 액티브 모드인지 여부 (true: 액티브 모드, false: 액티브 모드 아님)
 * @since 2026-02-04.
 */
export const getIsActiveHandsUp = () => {
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    if (performLiveInfo.liveSeq >= 0) {
        if (performLiveInfo.handsUpSelectYN === "Y") {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const getIsRunForSmartPen = () => {
    return isRunForSmartPen;
}

export const setIsRunForSmartPen = (isForSmartPen) => {
    isRunForSmartPen = isForSmartPen;
}

export const getIsClickConnAppBtn = () => {
    return isClickConnAppBtn;
}

export const setIsClickConnAppBtn = (isForConnAppBtn) => {
    isClickConnAppBtn = isForConnAppBtn;
}

export const getIsSmartTVMode = () => {
    return isSmartTVMode;
}

/**
 * RabbitMQ subscribe 요청 함수
 * 
 * subscribeOptions = {
 *     qos,
 *     invocationContext: { nextKey },
 *     onSuccess,
 *     onFailure
 * };
 * 
 * @param {Array} bindKeyArr - 바인드 키 배열
 * @param {Number} liveSeq - 라이브(= 클래스) 시퀀스 번호
 */
const joinRoom = (bindKeyArr, liveSeq) => {
    console.log("joinRoom bindKeyArr, liveSeq => ", bindKeyArr, liveSeq);
    if (isIOSWebView()) {
        let store = window.hiclasstv.store;
        const { live } = store.getState();
        const { performLiveInfo, isMixedClassMember } = live;
        let performLiveSeq = performLiveInfo.liveSeq;
        let performLiveTeacherSeq = -1;
        let performLiveTeacherRoomSeq = -1;
        if (performLiveInfo.teacher_info) {
            let performLiveTeacherInfo = performLiveInfo.teacher_info;
            if (performLiveTeacherInfo.userSeq !== undefined && performLiveTeacherInfo.userSeq !== null) {
                performLiveTeacherSeq = performLiveTeacherInfo.userSeq;
            }

            if (performLiveTeacherInfo.teamUpSeq !== undefined && performLiveTeacherInfo.teamUpSeq !== null) {
                performLiveTeacherRoomSeq = performLiveTeacherInfo.teamUpSeq;
            }
        }

        let iosConfig = {
            bindKeys: bindKeyArr,
            userSeq: myUserSeq,
            teacherSeq: performLiveTeacherSeq,
            liveSeq: performLiveSeq,
            chatRoomSeq: performLiveTeacherRoomSeq,
            // host: rbmqInfo.wsIp,
            // port: rbmqInfo.port,    // 20250321 ...  rbmqPort 바뀐 버전인지 판단하는 값 ... by hjkim
            // isP2PMode,
            isMixedClassMember,
            isGuestMember,
            // configFPSKind,
            isMediaSoupVersion,
            isSupportedWebRtcAudio: isMediaSoupVersion,     // 20250320 ... mediasoup 지원 버전 여부에 따라 값 바뀌도록 수정 ... by hjkim
            isAudioEnabled: getMicStatusEnabled(),            // 20251114 ... 현재 마이크와 시스템 오디오를 사용할 수 있는 모드인지 값 전달하도록 수정 ... by hjkim
            isSupportedAccessibilityService: true,
            userGateWay: routingKey ? routingKey : getServerDefaultRoutingKey()
        };

        if (isMixedClassMember) {
            const { mixedClassInfo } = live;

            iosConfig = {
                ...iosConfig,
                localTeacherSeq: mixedClassInfo.localTeacherSeq,
                localLiveSeq: mixedClassInfo.localLiveSeq
            };
        }

        const message = {
            action: "pro-subscribeLive",
            data: { 
                ...iosConfig
            }
        }

        window.webkit.messageHandlers.screenShareHandler.postMessage(message);
    } else if (isAndroidWebView()) {
        console.log("joinRoom - Android WebView Native 구독 모드");
        console.log("joinRoom - userGateWay[" + routingKey + "]");

        let store = window.hiclasstv.store;
        const { live } = store.getState();
        const { performLiveInfo, isMixedClassMember } = live;
        let performLiveSeq = performLiveInfo.liveSeq;
        let performLiveTeacherSeq = -1;
        let performLiveTeacherRoomSeq = -1;
        if (performLiveInfo.teacher_info) {
            let performLiveTeacherInfo = performLiveInfo.teacher_info;
            if (performLiveTeacherInfo.userSeq !== undefined && performLiveTeacherInfo.userSeq !== null) {
                performLiveTeacherSeq = performLiveTeacherInfo.userSeq;
            }

            if (performLiveTeacherInfo.teamUpSeq !== undefined && performLiveTeacherInfo.teamUpSeq !== null) {
                performLiveTeacherRoomSeq = performLiveTeacherInfo.teamUpSeq;
            }
        }

        let androidConfig = {
            bindKeys: bindKeyArr,
            userSeq: myUserSeq,
            teacherSeq: performLiveTeacherSeq,
            liveSeq: performLiveSeq,
            chatRoomSeq: performLiveTeacherRoomSeq,
            // host: rbmqInfo.wsIp,
            // port: rbmqInfo.port,    // 20250321 ...  rbmqPort 바뀐 버전인지 판단하는 값 ... by hjkim
            // isP2PMode,
            isMixedClassMember,
            isGuestMember,
            // configFPSKind,
            isMediaSoupVersion,
            isSupportedWebRtcAudio: isMediaSoupVersion,     // 20250320 ... mediasoup 지원 버전 여부에 따라 값 바뀌도록 수정 ... by hjkim
            isAudioEnabled: getMicStatusEnabled(),            // 20251114 ... 현재 마이크와 시스템 오디오를 사용할 수 있는 모드인지 값 전달하도록 수정 ... by hjkim
            isSupportedAccessibilityService: true,
            userGateWay: routingKey ? routingKey : getServerDefaultRoutingKey()
        };

        if (isMixedClassMember) {
            const { mixedClassInfo } = live;

            androidConfig = {
                ...androidConfig,
                localTeacherSeq: mixedClassInfo.localTeacherSeq,
                localLiveSeq: mixedClassInfo.localLiveSeq
            };
        }

        window.subscribeLive(androidConfig);
    } else {
        if (rbmqClient) {
            const topics = (bindKeyArr || []).filter(key => key && key !== "");
            console.log("joinRoom topics => ", topics);

            if (topics.length > 0) {
                subscribeTopics(topics, {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribeLive,
                    onFailure: onFailureSubscribeLive,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("joinRoom() - bindKeyArr => ", bindKeyArr);
                window.alert("joinRoom() - bindKeyArr is empty");
            }
        }
    }
}

/**
 * RabbitMQ unsubsribe 요청 함수
 * 
 * unsubsribeOptions = {
 *     timeout,
 *     invocationContext: { nextKey },
 *     onSuccess,
 *     onFailure
 * };
 * 
 * @param {Array} bindKeyArr - 바인드 키 배열
 */
const leaveRoom = (bindKeyArr) => {
    if (isIOSWebView()) {
        const message = {
            action: "pro-unsubscribeLive",
            data: { bindKeyArr }
        }

        window.webkit.messageHandlers.screenShareHandler.postMessage(message);
    } else if (isAndroidWebView()) {
        console.log("leaveRoom - Android WebView Native 구독 해제 모드");

        if (isUsableArrayObj(bindKeyArr)) {
            window.unsubscribeLive(bindKeyArr);
        }
    } else {
        if (rbmqClient) {
            const topics = (bindKeyArr || []).filter(key => key && key !== "");
            console.log("leaveRoom topics => ", topics);

            if (topics.length > 0) {
                unsubscribeTopics(topics, {
                    timeoutSec: 3,
                    onSuccess: onSuccessUnsubscribeLive,
                    onFailure: onFailureUnsubscribeLive,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("leaveRoom() - bindKeyArr => ", bindKeyArr);
                window.alert("leaveRoom() - bindKeyArr is empty");
            }
        }
    }
}

const joinSmallGroupRoom = (bindKeyArr) => {
    if (isIOSWebView()) {
        const message = {
            action: "pro-smallGroupSubscribe",
            data: { bindKeyArr }
        }

        window.webkit.messageHandlers.screenShareHandler.postMessage(message);
    } else if (isAndroidWebView()) {
        console.log("joinSmallGroupRoom - Android WebView Native 구독 모드");

        window.subscribeSmallGroup(bindKeyArr);
    } else {
        if (rbmqClient) {
            const topics = (bindKeyArr || []).filter(key => key && key !== "");
            console.log("joinSmallGroupRoom topics => ", topics);

            if (topics.length > 0) {
                subscribeTopics(topics, {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribeSmallGroup,
                    onFailure: onFailureSubscribeSmallGroup,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("joinSmallGroupRoom() - bindKeyArr => ", bindKeyArr);
                window.alert("joinSmallGroupRoom() - bindKeyArr is empty");
            }
        }
    }
}

const leaveSmallGroupRoom = (bindKeyArr) => {
    if (isIOSWebView()) {
        const message = {
            action: "pro-smallGroupUnsubscribe",
            data: { bindKeyArr }
        }

        window.webkit.messageHandlers.screenShareHandler.postMessage(message);
    } else if (isAndroidWebView()) {
        console.log("leaveSmallGroupRoom - Android WebView Native 구독 해제 모드");

        window.unsubscribeSmallGroup(bindKeyArr);
    } else {
        if (rbmqClient) {
            const topics = (bindKeyArr || []).filter(key => key && key !== "");
            console.log("leaveSmallGroupRoom topics => ", topics);

            if (topics.length > 0) {
                unsubscribeTopics(topics, {
                    timeoutSec: 3,
                    onSuccess: onSuccessUnsubscribeSmallGroup,
                    onFailure: onFailureUnsubscribeSmallGroup,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("leaveSmallGroupRoom() - bindKeyArr => ", bindKeyArr);
                window.alert("leaveSmallGroupRoom() - bindKeyArr is empty");
            }
        }
    }
}

export const getRcvKind = (routingKey, myHandsUpSendKey) => {
    let selRcvKind = ctRcvKind.Team;
    // let sKeyArr = null;
    // let strIdx = routingKey.indexOf("L.");

    if (typeof routingKey === "string") { // 20250807 ... 먼저 routingKey가 'string' 타입인지 체크 ... by hjkim
        const rKeyArr = routingKey.split(".");
        if (isUsableArrayObj(rKeyArr)) {
            if (rKeyArr[0] === "L" || rKeyArr[0] === "LM") {        // for class hands up
                if (typeof myHandsUpSendKey === "string") { // 20250807 ... myHandsUpSendKey가 'string' 타입인지 체크하도록 수정 ... by hjkim
                    const sKeyArr = myHandsUpSendKey.split(".");
                    if (isUsableArrayObj(sKeyArr)) { // 20250807 ... sKeyArr 값 체크하도록 수정 ... by hjkim
                        if (rKeyArr[1] === sKeyArr[1]) {
                            if (rKeyArr[3] === "0") {
                                selRcvKind = ctRcvKind.Teacher;
                            } else {
                                selRcvKind = ctRcvKind.Student;
                            }
                        }
                    }
                }
            } else if (rKeyArr[0] === "G" || rKeyArr[0] === "GM") { // small group
                selRcvKind = ctRcvKind.Student;                     // group 추가할지 고민..
            }
        }
    }

    return selRcvKind;
}

export const getProfileImgUrl = (selRcvKind, routingKey) => {
    let profileImgUrl = "1";    // profile image '1' 이 기본값이기 때문에 변경 ... by hjkim 20240215
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    if (selRcvKind === ctRcvKind.Teacher) {
        if (performLiveInfo.teacher_info) {
            // console.log("Teacher - profileImgUrl => ", performLiveInfo.teacher_info.profileImgUrl);
            profileImgUrl = performLiveInfo.teacher_info.profileImgUrl;
        }
    } else if (selRcvKind === ctRcvKind.Student) {
        if (typeof routingKey === "string") { // 20250807 ... 먼저 routingKey가 'string' 타입인지 체크 ... by hjkim
            const rKeyArr = routingKey.split(".");
            if (isUsableArrayObj(rKeyArr)) {
                if (rKeyArr[0] === "G" || rKeyArr[0] === "GM") { // 스몰그룹 시, 전송자 프로필 이미지 get
                    if (performLiveInfo && isUsableArrayObj(performLiveInfo.list_member)) {
                        const member_info = performLiveInfo.list_member.find(info => Number(info.userSeq) === Number(rKeyArr[rKeyArr.length - 2]));
                        if (member_info) {
                            // console.log("[", rKeyArr[1] + "] Student - profileImgUrl => ", member_info.profileImgUrl);
                            profileImgUrl = member_info.profileImgUrl;
                        }
                    }
                } else {
                    if (performLiveInfo && isUsableArrayObj(performLiveInfo.list_member)) {
                        // const member_info = performLiveInfo.list_member.find(info => info.userSeq == rKeyArr[rKeyArr.length - 1]);
                        const member_info = performLiveInfo.list_member.find(info => Number(info.userSeq) === Number(rKeyArr[rKeyArr.length - 1]));
                        if (member_info) {
                            // console.log("[", rKeyArr[rKeyArr.length - 1] + "] Student - profileImgUrl => ", member_info.profileImgUrl);
                            profileImgUrl = member_info.profileImgUrl;
                        }
                    }
                }
            }
        }
    }

    return profileImgUrl;
}

export const getRcvLiveSeq = (routingKey) => {
    // 20250807 ... typeof로 routingKey가 'string' 타입인지 체크하도록 처리했기 때문에 주석 처리 ... by hjkim
    // if (routingKey === undefined || routingKey === null) return -1;

    if (typeof routingKey === "string") { // 20250807 ... 먼저 routingKey가 'string' 타입인지 체크 ... by hjkim
        const rKeyArr = routingKey.split(".");
        if (isUsableArrayObj(rKeyArr)) {
            if (rKeyArr[0] === "L" || rKeyArr[0] === "LM") {
                if (rKeyArr.length > 3) {
                    let liveSeq = rKeyArr[2];
                    return Number(liveSeq);
                } else {
                    return -1;
                }
            }
        }
    }

    return -1;
}

/**
 * 메시지를 수신한 라우팅 키를 통해 기본 메시지/귓속말 메시지 여부를 판단
 * 
 * @param {String} routingKey - 라우팅 키
 * @returns {Boolean} 귓속말 메시지 여부
 * @since 2026-01-07.
 */
export const getRcvWhisperChat = (routingKey) => {
    let isWhisper = false;  // 기본값

    if (typeof routingKey === "string") {
        const rKeyArr = routingKey.split(".");
        if (isUsableArrayObj(rKeyArr)) {
            if ((rKeyArr[0] === "L" || rKeyArr[0] === "LM") && rKeyArr.length > 4) {
                isWhisper = true;
            }
        }
    }

    console.log("getRcvWhisperChat - isWhisper[" + isWhisper + "] from routingKey[" + routingKey + "]");

    return isWhisper;
}

/**
 * RabbitMQ 클라이언트 ID를 생성하여 반환
 * 
 * @param {String} prefixStr - 생성할 클라이언트 ID에 사용할 접두사
 * @returns 생성된 RabbitMQ 클라이언트 ID 반환
 * @since 2025-08-08.
 */
const getRbmqClientID = (prefixStr) => {
    // const id = prefixStr + parseInt(Math.random() * 1000, 10) + "-";
    const id = prefixStr + makeRandomCode(16) + "-";
    console.log("created rbmq client id[", id, "]");
    return id;
}

/**
 * 랜덤 문자열 코드를 생성 후 반환
 * 
 * @param {Number} limit - 생성할 랜덤 문자열의 최대 길이
 * @returns {String} 랜덤 코드 문자열
 * @since 2026-04-14.
 */
const makeRandomCode = (limit) => {
    let str = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < limit; i++) {
        str += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return str;
}

/**
 * mqtt url을 생성 후 반환
 * 
 * @param {Boolean} useSSL - SSL 사용 여부
 * @returns 생성된 mqtt url을 반환
 * @since 2026-04-06.
 */
const createMqttWsUrl = (useSSL = true) => {
    const protocol = useSSL ? "wss" : "ws";
    return `${protocol}://${rbmqInfo.wsIp}:${rbmqInfo.wsPort}${rbmqInfo.wsPath}`;
}

/**
 * 공통 헬퍼 함수
 * 
 * @param {String} prefixStr - 생성할 클라이언트 ID에 사용할 접두사
 * @param {Boolean} keepAliveIntervalSec - 활성 네트워크 연결을 유지하기 위한 시간
 * @param {Function} onConnectSuccess - 콜백
 * @returns rabbitMQ 클라이언트
 * @since 2026-04-06.
 */
const createMqttClient = ({ clientIdPrefix, keepAliveIntervalSec, onConnectSuccess }) => {
    if (!rbmqInfo || rbmqInfo === "") {
        return null;
    }

    rbmqClientID = getRbmqClientID(clientIdPrefix);

    // const useSSL = isDevVersion() ? true : window.location.protocol === "https:" ? true : false;
    // 260728 SmartTV와 ClassMonitor는 접속 프로토콜에 맞춰 HTTP=WS, HTTPS=WSS로 연결한다.
    const useSSL = isSmartTVMode && window.location.protocol === "http:" ? false : true;
    const wsUrl = createMqttWsUrl(useSSL);

    console.log("createMqttClient - wsUrl => ", wsUrl);
    console.log("createMqttClient - clientId => ", rbmqClientID);
    console.log("createMqttClient - keepAliveIntervalSec => ", keepAliveIntervalSec);
    console.log("createMqttClient - connectTimeout => ", connectTimeoutTime * 1000);
    console.log("createMqttClient - reconnectPeriod => ", reconnectPeriodTime * 1000);

    rbmqClient = window.mqtt.connect(wsUrl, {
        clientId: rbmqClientID,
        username: rbmqInfo.vHost + ":" + rbmqInfo.userID,
        password: rbmqInfo.userPW,
        keepalive: keepAliveIntervalSec,
        clean: true,
        connectTimeout: connectTimeoutTime * 1000,
        // connectTimeout: 5 * 1000,
        // RabbitMQ 서버와 연결이 끊어졌을 때 자동으로 재연결을 시도하는 간격을 설정
        // -> 자동 재연결 안함 = reconnectPeriod: 0
        // -> n초마다 재연결 시도 = reconnectPeriod: n * 1000
        reconnectPeriod: reconnectPeriodTime * 1000,
    });

    rbmqClient.on("connect", (connack) => {
        console.log("MQTT connect success => ", connack);

        // 기존 onSuccessConnect 계열 함수가 msg 객체를 기대할 수 있으니 맞춰서 전달
        if (typeof onConnectSuccess === "function") {
            onConnectSuccess({
                errorCode: enRbmqError.OK,
                errorMessage: "Connection succeeded",
                connack
            });
        }
    });

    rbmqClient.on("message", (topic, message) => {
        onMessageArrived(topic, message);
    });

    rbmqClient.on("error", (err) => {
        console.log("MQTT error => ", err);

        if (typeof onFailureConnect === "function") {
            onFailureConnect(normalizeMqttError(err, enRbmqError.CONNACK_RETURNCODE));
        }
    });

    rbmqClient.on("close", () => {
        console.log("MQTT close");

        // ★ 핵심 수정:
        // 의도적 종료(disconnectRbmq 흐름)이면 close 이벤트를 무시한다.
        // 페이지 이동은 onSuccessUnsubscribe / end() 콜백에서 직접 처리한다.
        if (isIntentionalDisconnect) {
            console.log("MQTT close ignored - intentional disconnect, page navigation handled elsewhere");
            return;
        }

        // 비정상 종료(서버 강제 끊김, 네트워크 오류 등)만 onConnectionLost 호출
        if (typeof onConnectionLost === "function") {
            onConnectionLost({
                errorCode: enRbmqError.SOCKET_CLOSE,  // OK가 아닌 비정상 코드
                errorMessage: "Socket closed unexpectedly"
            });
        }
    });

    return rbmqClient;
}

/** rbmq */
const connectRbmq = async () => {
    if (rbmqInfo && rbmqInfo !== "") {
        createMqttClient({
            clientIdPrefix: "myclientid-",
            keepAliveIntervalSec: keepAliveIntervalTime,
            onConnectSuccess: onSuccessConnect
        });
    } else {
        console.log("connectRbmq - rbmqInfo => ", rbmqInfo);
    }
}

const connectRbmqForMixedClass = async () => {
    if (rbmqInfo && rbmqInfo !== "") {
        createMqttClient({
            clientIdPrefix: "myclientid-mixed-",
            keepAliveIntervalSec: keepAliveIntervalTime,
            onConnectSuccess: onSuccessConnectForMixedClass
        });
    } else {
        console.log("connectRbmqForMixedClass - rbmqInfo => ", rbmqInfo);
    }
}

const connectRbmqForSmartTV = async () => {
    if (rbmqInfo && rbmqInfo !== "") {
        createMqttClient({
            clientIdPrefix: "myclientid-smarttv-",
            keepAliveIntervalSec: keepAliveIntervalTime,
            onConnectSuccess: onSuccessConnectForSmartTV
        });
    } else {
        console.log("connectRbmqForSmartTV - rbmqInfo => ", rbmqInfo);
    }
}

const connectRbmqForGroupSmartTV = async () => {
    if (rbmqInfo && rbmqInfo !== "") {
        createMqttClient({
            clientIdPrefix: "myclientid-group-smarttv-",
            keepAliveIntervalSec: keepAliveIntervalTime,
            onConnectSuccess: onSuccessConnectForGroupSmartTV
        });
    } else {
        console.log("connectRbmqForGroupSmartTV - rbmqInfo => ", rbmqInfo);
    }
}

// 260728 ClassMonitor MQTT 연결은 GroupSmartTV 콜백만 공유하고 고유 client ID를 사용한다.
const connectRbmqForClassMonitor = async () => {
    if (rbmqInfo && rbmqInfo !== "") {
        createMqttClient({
            clientIdPrefix: "myclientid-class-monitor-",
            keepAliveIntervalSec: keepAliveIntervalTime,
            onConnectSuccess: onSuccessConnectForGroupSmartTV
        });
    } else {
        console.log("connectRbmqForClassMonitor - rbmqInfo => ", rbmqInfo);
    }
}

const reconnectRbmq = () => {
    if (rbmqInfo) {
        if (isIOSWebView()) {
            console.log("reconnectRbmq - iOS Native WebView 연결 모드");
        } else if (isAndroidWebView()) {
            console.log("reconnectRbmq - Android WebView Native 연결 모드");
        } else {
            createMqttClient({
                clientIdPrefix: "myclientid-",
                keepAliveIntervalSec: keepAliveIntervalTime,
                onConnectSuccess: onSuccessConnect
            });
        }
    }
}

export const disconnectRbmq = (value) => {
    console.log("disconnectRbmq - value => ", value);

    if (isDisconnecting) {
        console.log("disconnectRbmq skipped - already disconnecting");
        return;
    }

    isDisconnecting = true;
    isIntentionalDisconnect = true;

    if (isIOSWebView()) {
        const message = {
            action: "pro-unsubscribe",
            data: { webBindKey: myRoutingKey }
        }

        window.webkit.messageHandlers.screenShareHandler.postMessage(message);
    } else if (isAndroidWebView()) {
        console.log("disconnectRbmq - Android WebView Native 구독 모드");

        window.doInitialUnsubscribe();
    } else {
        if (rbmqClient) {
            try {
                if (myRoutingKey && myRoutingKey !== "") {
                    unsubscribeTopics([myRoutingKey], {
                        timeoutSec: 3,
                        onSuccess: onSuccessUnsubscribe,
                        onFailure: onFailureUnsubscribe,
                        failureCode: enRbmqError.INTERNAL_ERROR
                    });
                } else {
                    console.log("disconnectRbmq() - myRoutingKey => ", myRoutingKey);
                    window.alert("disconnectRbmq() - myRoutingKey => " + myRoutingKey);
                }
            } catch (err) {
                console.log("------disconnectRbmq------ error => ", err);
                isDisconnecting = false;
            }
        } else {
            isDisconnecting = false;
        }
    }
}

export const disconnectRbmqForMixed = () => {
    console.log("disconnectRbmqForMixed called...");

    if (isDisconnecting) {
        console.log("disconnectRbmqForMixed skipped - already disconnecting");
        return;
    }

    isDisconnecting = true;
    isIntentionalDisconnect = true;

    if (isIOSWebView()) {
        // 여기에 iOS WebView용 코드 넣으면 됨 ... by hjkim 20251224
        console.log("disconnectRbmqForMixed - iOS Native WebView 연결 모드");
    } else if (isAndroidWebView()) {
        console.log("disconnectRbmqForMixed - Android WebView Native 구독 모드");

        window.doInitialUnsubscribe();
    } else {
        if (rbmqClient) {
            try {
                if (myRoutingKey && myRoutingKey !== "") {
                    unsubscribeTopics([myRoutingKey], {
                        timeoutSec: 3,
                        onSuccess: onSuccessUnsubscribe,
                        onFailure: onFailureUnsubscribe,
                        failureCode: enRbmqError.INTERNAL_ERROR
                    });
                } else {
                    console.log("disconnectRbmqForMixed() - myRoutingKey => ", myRoutingKey);
                    window.alert("disconnectRbmqForMixed() - myRoutingKey => " + myRoutingKey);
                }
            } catch (err) {
                console.log("------disconnectRbmqForMixed------ error => ", err);
                isDisconnecting = false;
            }
        } else {
            isDisconnecting = false;
        }
    }
}

export const disconnectRbmqForSmartTV = () => {
    if (isDisconnecting) {
        console.log("disconnectRbmqForSmartTV skipped - already disconnecting");
        return;
    }

    isDisconnecting = true;
    isIntentionalDisconnect = true;

    if (rbmqClient) {
        try {
            let topics = [];

            /* if (isUsableArrayObj(smartTVInfo.bindKeyArr)) {
                topics = [...smartTVInfo.bindKeyArr];
            } else if (myRoutingKey && myRoutingKey !== "") {
                topics = [myRoutingKey];
            } else if (isUsableArrayObj(myRoutingKeyArr)) {
                topics = [...myRoutingKeyArr];

                if (smartTVTempKey && smartTVTempKey !== "") {
                    topics.push(smartTVTempKey);
                }
            } else {
                console.log("disconnectRbmqForSmartTV---myRoutingKey => ", myRoutingKey, ", myRoutingKeyArr => ", myRoutingKeyArr);
            } */

            if (isUsableArrayObj(smartTVInfo.bindKeyArr)) {
                topics = [...smartTVInfo.bindKeyArr];
            }

            if (myRoutingKey && myRoutingKey !== "") {
                topics.push(myRoutingKey);
            }

            if (isUsableArrayObj(myRoutingKeyArr)) {
                topics = [...myRoutingKeyArr];
            }

            if (smartTVTempKey && smartTVTempKey !== "") {
                topics.push(smartTVTempKey);
            }

            if (topics.length > 0) {
                unsubscribeTopics(topics, {
                    timeoutSec: 3,
                    onSuccess: () => {
                        console.log("disconnectRbmqForSmartTV - unsubscribe success => ", topics);

                        // 기존 성공 콜백이 필요하면 여기서 직접 후처리
                        if (typeof onSuccessUnsubscribe === "function") {
                            onSuccessUnsubscribe({ topics });
                        }
                    },
                    onFailure: (res) => {
                        if (isUsableArrayObj(smartTVInfo.bindKeyArr)) {
                            onFailureUnsubscribeLiveForSmartTV(res);
                        } else {
                            onFailureUnsubscribe(res);
                        }
                    },
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            }
        } catch (err) {
            console.log("------disconnectRbmqForSmartTV------ error => ", err);
            isDisconnecting = false;
        } finally {
            smartTVInfo.bindKey = null;
            smartTVInfo.bindKeyArr = [];
        }
    } else {
        isDisconnecting = false;
    }
}

export const disconnectTempRbmq = () => {
    if (isDisconnecting) {
        console.log("disconnectTempRbmq skipped - already disconnecting");
        return;
    }

    isDisconnecting = true;
    isIntentionalDisconnect = true;

    if (isIOSWebView()) {
        // 여기에 iOS WebView용 코드 넣으면 됨 ... by hjkim 20251224
        console.log("disconnectTempRbmq - iOS Native WebView 연결 모드");
    } else if (isAndroidWebView()) {
        console.log("disconnectTempRbmq - Android WebView Native 연결 모드");

        if (myTempBindKey && myTempBindKey !== "") {
            window.unsubscribeTempKey(myTempBindKey);
        } else {
            console.log("disconnectTempRbmq() - myTempBindKey => " + myTempBindKey);
            window.alert("disconnectTempRbmq() - myTempBindKey => " + myTempBindKey);
        }
    } else {
        if (rbmqClient) {
            try {
                if (myTempBindKey && myTempBindKey !== "") {
                    unsubscribeTopics([myTempBindKey], {
                        timeoutSec: 3,
                        onSuccess: onSuccessUnsubscribe,
                        onFailure: onFailureUnsubscribe,
                        failureCode: enRbmqError.INTERNAL_ERROR
                    });
                } else {
                    console.log("disconnectTempRbmq() - myTempBindKey => " + myTempBindKey);
                    window.alert("disconnectTempRbmq() - myTempBindKey => " + myTempBindKey);
                }
            } catch (err) {
                console.log("------disconnectTempRbmq------ error => ", err);
                isDisconnecting = false;
            }
        } else {
            isDisconnecting = false;
        }
    }
}

/********************************/

/********************************/
/**
 * RabbitMQ 구독을 처리하는 메서드
 * 
 * @param {Array} topics - 바인드 키 배열
 * @param {Object} options - 구독 옵션
 * @since 2026-04-06.
 */
const subscribeTopics = (topics, options = {}) => {
    const {
        qos = 1,
        timeoutSec = 3,
        onSuccess,
        onFailure,
        failureCode = enRbmqError.INTERNAL_ERROR
    } = options;

    if (!rbmqClient) {
        if (typeof onFailure === "function") {
            onFailure({
                errorCode: enRbmqError.INVALID_STATE,
                errorMessage: "rbmqClient is null"
            });
        }
        return;
    }

    const validTopics = (topics || []).filter(topic => topic && topic !== "");
    if (validTopics.length === 0) {
        if (typeof onFailure === "function") {
            onFailure({
                errorCode: enRbmqError.INVALID_ARGUMENT,
                errorMessage: "No valid subscribe topics"
            });
        }
        return;
    }

    let done = false;

    const timer = setTimeout(() => {
        if (done) return;
        done = true;

        if (typeof onFailure === "function") {
            onFailure({
                errorCode: enRbmqError.SUBSCRIBE_TIMEOUT,
                errorMessage: `Subscribe timeout: ${validTopics.join(", ")}`
            });
        }
    }, timeoutSec * 1000);

    rbmqClient.subscribe(validTopics, { qos: qos }, (err, granted) => {
        if (done) return;
        done = true;
        clearTimeout(timer);

        if (err) {
            if (typeof onFailure === "function") {
                onFailure(normalizeMqttError(err, failureCode));
            }
            return;
        }

        if (typeof onSuccess === "function") {
            onSuccess({
                errorCode: enRbmqError.OK,
                errorMessage: "Subscribe succeeded",
                topics: validTopics,
                granted: granted
            });
        }
    });
}

/**
 * RabbitMQ 구독 해제를 처리하는 메서드
 * 
 * @param {Array} topics - 언바인드 키 배열
 * @param {Object} options - 구독 해제 옵션
 * @since 2026-04-06.
 */
const unsubscribeTopics = (topics, options = {}) => {
    const {
        timeoutSec = 3,
        onSuccess,
        onFailure,
        failureCode = enRbmqError.INTERNAL_ERROR
    } = options;

    if (!rbmqClient) {
        if (typeof onFailure === "function") {
            onFailure({
                errorCode: enRbmqError.INVALID_STATE,
                errorMessage: "rbmqClient is null"
            });
        }
        return;
    }

    const validTopics = (topics || []).filter(topic => topic && topic !== "");
    if (validTopics.length === 0) {
        if (typeof onFailure === "function") {
            onFailure({
                errorCode: enRbmqError.INVALID_ARGUMENT,
                errorMessage: "No valid unsubscribe topics"
            });
        }
        return;
    }

    let done = false;

    const timer = setTimeout(() => {
        if (done) return;
        done = true;

        if (typeof onFailure === "function") {
            onFailure({
                errorCode: enRbmqError.UNSUBSCRIBE_TIMEOUT,
                errorMessage: `Unsubscribe timeout: ${validTopics.join(", ")}`
            });
        }
    }, timeoutSec * 1000);

    rbmqClient.unsubscribe(validTopics, (err) => {
        if (done) return;
        done = true;
        clearTimeout(timer);

        if (err) {
            if (typeof onFailure === "function") {
                onFailure(normalizeMqttError(err, failureCode));
            }
            return;
        }

        if (typeof onSuccess === "function") {
            onSuccess({
                errorCode: enRbmqError.OK,
                errorMessage: "Unsubscribe succeeded",
                topics: validTopics
            });
        }
    });
}
/********************************/

/** rbmq callback 처리 */
export const onSuccessConnect = (msg) => {
    if (pingInterval === null) {
        pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
    }

    if (isIOSWebView()) {
        // 여기에 iOS WebView용 코드 넣으면 됨 ... by hjkim 20251224
        console.log("onSuccessConnect - iOS Native WebView 연결 모드");
        
        let store = window.hiclasstv.store;
        store.dispatch(rbmqServerConnected());

        // ios는 connectRbmq 할 때 subscribe까지 해버림!
        // 믹스드클래스가 아닌 경우, pro-subscribe 명령을 전하는 것은 joinRoom 때만 유일함
        // 20260318 by ykhan
    } else if (isAndroidWebView()) {
        console.log("onSuccessConnect - Android WebView Native 연결 모드");

        let store = window.hiclasstv.store;
        store.dispatch(rbmqServerConnected());

        // 연결에 성공하면 즉시 앱용 & 웹용 subscribe 실행
        window.doInitialSubscribe();
    } else {
        if (rbmqClient) {
            if (myRoutingKey && myRoutingKey !== "") {
                subscribeTopics([myRoutingKey], {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribe,
                    onFailure: onFailureSubscribe,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("onSuccessConnect() - myRoutingKey => ", myRoutingKey);
                window.alert("onSuccessConnect() - myRoutingKey => " + myRoutingKey);
            }

            let store = window.hiclasstv.store;
            store.dispatch(rbmqServerConnected());
        }
    }
}

const onFailureConnect = async (res) => {
    if (rbmqClient) {
        rbmqClient = null;
        rbmqClientID = null;
    }

    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { isLoginYn, userSeq } = user;
    console.log("onFailureConnect - isLoginYn[", isLoginYn, "], userSeq[", userSeq, "]");
    if (isLoginYn === "Y") {
        if (isMixedClassMember) {
            // 애초에 믹스드 클래스 멤버는 RabbitMQ에 연결이 되어야만 로그인에도 성공하는 구조임
            console.log("onFailureConnect - RabbitMQ 연결 실패 믹스드 클래스 멤버 로그아웃 요청 해당없음");
        } else {
            console.log("onFailureConnect - RabbitMQ 연결 실패 일반 클래스 멤버 로그아웃 요청");
            try {
                console.log(`onFailureConnect - call store.dispatch(logOut({ userSeq: ${userSeq} , mode: 'web', isClickLogout: true }))`);
                await store.dispatch(logOut({
                    userSeq,
                    mode: "web",
                    isClickLogout: true
                }));
            } catch (err) {
                // 네트워크 오류 등으로 logout API 자체가 실패해도 이후 처리는 계속 진행
                console.log("onFailureConnect - logOut REST API 실패 (무시하고 계속): ", err);
            }
        }
    }

    // 로그아웃 요청 완료 후 에러 상태 업데이트 & 페이지 이동
    store.dispatch(rbmqServerError({ message: "fail_connect" }));
    writeRbmqErrorMessage("onFailureConnect", res);
}

export const onConnectionLost = (res) => {
    console.log("onConnectionLost called - isIntentionalDisconnect:", isIntentionalDisconnect, ", res:", res);

    if (pingInterval) {
        clearInterval(pingInterval);
        pingInterval = null;
    }

    if (rbmqClient) {
        // 260903 참조만 버리면 내부 클라이언트가 살아남아 혼자 재연결을 계속한다.
        // 그러면 나중에 만드는 클라이언트와 둘이 되므로, 버리기 전에 확실히 닫는다.
        // 이미 닫혀 있으면 throw될 수 있어 catch한다.
        try {
            rbmqClient.end(true);
        } catch (err) {
            console.log("onConnectionLost - rbmqClient.end() error => ", err);
        }
        rbmqClient = null;
        rbmqClientID = null;
    }

    if (isIntentionalDisconnect) {
        // ★ Android/iOS에서 pro-disconnectedRbmq 콜백으로 이 함수가 호출됨
        //   = 네이티브 측 cleanup 완료 신호 → 공통 완료 처리 함수로 위임
        console.log("onConnectionLost - intentional disconnect done → handleIntentionalDisconnectDone()");
        handleIntentionalDisconnectDone();
    } else {
        // 비정상 종료 (서버 강제 끊김, 네트워크 오류 등)
        isDisconnecting = false;

        // 260901 학생 앱(Windows Pentalk Browser / Android AndWebnote2606)에 비정상 퇴장을 알린다.
        // ⚠ writeRbmqErrorMessage()보다 반드시 앞이어야 한다 — 그 안의 alert()가 JS 스레드를 막고,
        // 못 닿는 망에서는 그 창이 계속 다시 떠서 alert 뒤에 둔 코드는 영영 실행되지 않는다.
        // (연결 Agent 통지 39 §2 — 절전 회차에서 사슬 호출·alert 차단 둘 다 실측 2/2)
        // 의도적 종료는 위 갈래에서 이미 user-exit이 나가므로 여기는 비정상 종료 전용이다.
        // reason은 conn-lost다 — socket-closed는 WiFi(webnote.html) 것이라 쓰면 제품 판별이 깨진다.
        // 계약: PentalkAgent\docs\external\web-to-student-app-disconnect-contract.md §3-3
        console.log("onConnectionLost - call sendToStudentApp({ kind: 'disconnect', reason: 'conn-lost' }).");
        sendToStudentApp({ kind: "disconnect", reason: "conn-lost" });

        // 260903 Windows(Pentalk Browser) 학생 앱에서는 alert을 띄우지 않는다.
        // 260922 Android(AndWebnote2606) 학생 앱도 같다 — AndroidLogin 브리지 유무로 판별한다.
        //   isAndroidWebView()/isPentalkAndr()는 ProcessComm 유무라 그 앱에서는 false다.
        //   그 앱은 onJsAlert를 덮어쓰지 않아 기본 대화상자가 JS 스레드를 잡는다 — Windows와 같은 조건.
        //   sendToStudentApp과 달리 onWebMessage 함수까지 보지 않는다 — 억제 조건은
        //   「몰아줄 앱이 있다」이지 「메시지가 닿는다」가 아니다. (Android 답 20260918 §3-2)
        // alert()은 JS 스레드를 잡아 mqtt 재연결 타이머도, 앱이 몰아주는 자동 로그인도 막는다.
        // 실제로 끊김 뒤 [web] connect가 20분간 0건이었고, 그동안 [bridge]가 계속 응답 없음이었다.
        // (Pro 회신 184 §1 · 연결 Agent 통지 51 §1)
        // 화면 대신 로그인 화면 자체가 사유를 말한다 — 수업이 없으면 "해당 클래스가 시작되지
        // 않았습니다"가 뜨고, 살아 있으면 앱이 [참여]로 다시 로그인시킨다.
        // 일반 웹 브라우저는 몰아줄 앱이 없으므로 기존대로 alert을 띄운다.
        const isSilentExit = isWindowsWebView() || Boolean(window.AndroidLogin);
        console.log("onConnectionLost - isSilentExit[", isSilentExit, "]");
        writeRbmqErrorMessage("onConnectionLost", isSilentExit ? { ...res, isNoAlert: true } : res);
    }
}

export const onSuccessSubscribe = (msg) => {
    console.log("------onSuccessSubscribe------", msg);
    // let store = window.hiclasstv.store;
    // store.dispatch(rbmqServerConnected());
}

const onFailureSubscribe = (res) => {
    writeRbmqErrorMessage("onFailureSubscribe", res);
}

export const onSuccessUnsubscribe = (msg) => {
    console.log("onSuccessUnsubscribe => ", msg);
    try {
        if (pingInterval) {
            clearInterval(pingInterval);
            pingInterval = null;
        }

        if (isIOSWebView()) {
            // iOS: 네이티브에 disconnect 지시만 전달
            //      완료 신호(pro-disconnectedRbmq)가 오면 onConnectionLost → handleIntentionalDisconnectDone 호출됨
            console.log("onSuccessUnsubscribe - iOS Native WebView 연결 모드");

            const message = {
                action: "pro-disconnectRbmq"
            };

            window.webkit.messageHandlers.screenShareHandler.postMessage(message);
            // ★ 여기서 handleIntentionalDisconnectDone() 직접 호출하지 않음
            //   iOS 네이티브 완료 콜백이 올 때 처리됨
        } else if (isAndroidWebView()) {
            // Android: 네이티브에 stop 지시만 전달
            //          완료 신호(pro-disconnectedRbmq)가 오면 onConnectionLost → handleIntentionalDisconnectDone 호출됨
            console.log("onSuccessUnsubscribe - Android Native WebView: stopRabbitMQ 호출");
            window.stopRabbitMQ();
            // ★ 여기서 handleIntentionalDisconnectDone() 직접 호출하지 않음
            //   Android 네이티브 완료 콜백이 올 때 처리됨
        } else {
            // PC: end() 완료 콜백에서 직접 처리
            if (rbmqClient) {
                try {
                    // force=false → MQTT DISCONNECT 패킷 전송 후 정상 종료
                    // 완료 콜백에서 handleIntentionalDisconnectDone() 호출
                    rbmqClient.end(false, {}, () => {
                        console.log("rbmqClient.end() callback - MQTT 정상 종료 완료");
                        handleIntentionalDisconnectDone();
                    });
                } catch (err) {
                    console.log("onSuccessUnsubscribe - end() error:", err);
                    // end() 실패해도 반드시 처리
                    handleIntentionalDisconnectDone();
                }
            } else {
                // rbmqClient가 이미 null이어도 처리
                handleIntentionalDisconnectDone();
            }
        }
    } catch (err) {
        console.log("------onSuccessUnsubscribe-disconnect------ error => ", err);
    }
}

const onFailureUnsubscribe = (res) => {
    if (isIOSWebView()) {
        console.log("onFailureUnsubscribe - iOS Native WebView 연결 모드");
    } else if (isAndroidWebView()) {
        console.log("onFailureUnsubscribe - Android WebView Native 연결 모드");
        window.stopRabbitMQ();
    } else {
        if (rbmqClient) {
            try {
                rbmqClient.end(true);
            } catch (err) {
                console.log("------onFailureUnsubscribe-disconnect------ error => ", err);
            } finally {
                rbmqClient = null;
                rbmqClientID = null;

                // ★ 플래그 리셋 추가
                isIntentionalDisconnect = false;
                isDisconnecting = false;

                writeRbmqErrorMessage("onFailureUnsubscribe", res);
            }
        }
    }
}
/********************************/

/** rbmq live callback 처리 */
export const onSuccessSubscribeLive = (msg) => {
    console.log("onSuccessSubscribeLive - msg => ", msg);
    if (isNeedSendSubscribe) {
        console.log("isNeedSendSubscribe is true!");
        console.log("sendJoinConsume call - case Student(default)");
        sendJoinConsume("live", rcvUserSeq);
        isNeedSendSubscribe = false;
        console.log("isNeedSendSubscribe = false");
    } else {
        console.log("isNeedSendSubscribe is false!");
    }
}

const onFailureSubscribeLive = (res) => {
    writeRbmqErrorMessage("onFailureSubscribeLive", res);
}

export const onSuccessUnsubscribeLive = (msg) => {
    console.log("------onSuccessUnsubscribeLive------ msg => ", msg);
    console.log("before unsubscribe - isNeedSendUnsubscribe[", isNeedSendUnsubscribe, "], isNeedCleanUp[", isNeedCleanUp, "]");

    unsubscribe(false, true);
}

const onFailureUnsubscribeLive = (res) => {
    writeRbmqErrorMessage("onFailureUnsubscribeLive", res);
}
/********************************/

/** rbmq small group callback 처리 */
export const onSuccessSubscribeSmallGroup = (msg) => {
    console.log("------onSuccessSubscribeSmallGroup------ msg => ", msg);
}

const onFailureSubscribeSmallGroup = (res) => {
    // console.log("------onFailureSubscribeSmallGroup------ res => ", res);
    writeRbmqErrorMessage("onFailureSubscribeSmallGroup", res);
}

export const onSuccessUnsubscribeSmallGroup = (msg) => {
    console.log("------onSuccessUnsubscribeSmallGroup------ msg => ", msg);
}

const onFailureUnsubscribeSmallGroup = (res) => {
    writeRbmqErrorMessage("onFailureUnsubscribeSmallGroup", res);
}
/********************************/

/** rbmq mixed class callback 처리 */
export const onSuccessConnectForMixedClass = (msg) => {
    if (pingInterval === null) {
        pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
    }

    if (isIOSWebView()) {
        console.log("onSuccessConnectForMixedClass - iOS Native WebView 연결 모드");

        let store = window.hiclasstv.store;
        store.dispatch(rbmqServerConnected());

        if (myTempBindKey && myTempBindKey !== "") {
            const message = {
                action: "pro-subscribeTempKey",
                data: { tempBindKey: myTempBindKey }
            };

            window.webkit.messageHandlers.screenShareHandler.postMessage(message);
        } else {
            console.log("onSuccessConnectForMixedClass() - myTempBindKey => " + myTempBindKey);
            window.alert("onSuccessConnectForMixedClass() - myTempBindKey => " + myTempBindKey);
        }
    } else if (isAndroidWebView()) {
        console.log("onSuccessConnectForMixedClass - Android WebView Native 연결 모드");

        let store = window.hiclasstv.store;
        store.dispatch(rbmqServerConnected());

        if (myTempBindKey && myTempBindKey !== "") {
            window.subscribeTempKey(myTempBindKey);
        } else {
            console.log("onSuccessConnectForMixedClass() - myTempBindKey => " + myTempBindKey);
            window.alert("onSuccessConnectForMixedClass() - myTempBindKey => " + myTempBindKey);
        }
    } else {
        if (rbmqClient) {
            if (myTempBindKey && myTempBindKey !== "") {
                subscribeTopics([myTempBindKey], {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribeTempKeyForMixedClass,
                    onFailure: onFailureSubscribe,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("onSuccessConnectForMixedClass() - myTempBindKey => " + myTempBindKey);
                window.alert("onSuccessConnectForMixedClass() - myTempBindKey => " + myTempBindKey);
            }

            let store = window.hiclasstv.store;
            store.dispatch(rbmqServerConnected());
        }
    }
}

export const onSuccessSubscribeTempKeyForMixedClass = (res) => {
    console.log("onSuccessSubscribeTempKeyForMixedClass - myLocalServerBindKey[", myLocalServerBindKey, "]");
    console.log("onSuccessSubscribeTempKeyForMixedClass - localServerSendData[", localServerSendData, "]");

    if (myLocalServerBindKey && myLocalServerBindKey !== "" && localServerSendData && localServerSendData !== "") {
        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({ kind: "local", action: "live-member-list", information: localServerSendData })
        }, "event_exchange");

        sendDataToRbmq(myLocalServerBindKey, sendData.forWeb);
    }
}

export const onSuccessUnsubscribeTempKeyForMixedClass = (msg) => {
    try {
        if (isIOSWebView()) {
            console.log("onSuccessUnsubscribeTempKeyForMixedClass - iOS Native WebView 연결 모드");

            if (myRoutingKey && myRoutingKey !== "") {
                console.log("myRoutingKey ------ ", myRoutingKey);
                const message = {
                    action: "pro-subscribe",
                    data: { bindKey: myRoutingKey }
                };

                window.webkit.messageHandlers.screenShareHandler.postMessage(message);
            }
        } else if (isAndroidWebView()) {
            console.log("onSuccessUnsubscribeTempKeyForMixedClass - Android WebView Native 연결 모드");
            window.doInitialSubscribe();
        } else {
            console.log("onSuccessUnsubscribeTempKeyForMixedClass - myRoutingKey => ", myRoutingKey);

            if (myRoutingKey && myRoutingKey !== "") {
                subscribeTopics([myRoutingKey], {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribeForMixedClass,
                    onFailure: onFailureSubscribe,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("onSuccessUnsubscribeTempKeyForMixedClass() - myRoutingKey => ", myRoutingKey);
                window.alert("onSuccessUnsubscribeTempKeyForMixedClass() - myRoutingKey => " + myRoutingKey);
            }
        }
    } catch (err) {
        console.log("------onSuccessUnsubscribeTempKeyForMixedClass unsubscribe------ error => ", err);
    } finally {
        console.log("case 3:) onSuccessUnsubscribeTempKeyForMixedClass - myTempBindKey = null");
        myTempBindKey = null;
    }
}

export const onSuccessSubscribeForMixedClass = (msg) => {
    console.log("onSuccessSubscribeForMixedClass => ", msg);
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userNickname, userSeq } = user;
    const { mixedClassInfo } = live;

    store.dispatch(requestJoinMixedClassLive({
        liveSeq: mixedClassInfo.liveSeq,
        liveName: mixedClassInfo.liveName,
        userSeq,
        userNickname,
        mixedClassSeq: mixedClassInfo.mixedClassSeq
    }));
}

const onSuccessUnsubscribeForMixedClass = (msg) => {
    console.log("onSuccessUnsubscribeForMixedClass => ", msg);
}
/********************************/

/** rbmq smart tv callback 처리 */
const onSuccessConnectForSmartTV = (msg) => {
    console.log("onSuccessConnectForSmartTV => ", msg);

    if (rbmqClient) {
        // 스마트TV는 sendKey 이슈로 인해 클래스에 참여 후 PING을 보내도록 주석 처리 ... by hjkim 20260413
        /* if (pingInterval === null) {
            pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
        } */

        const topics = [];
        if (myRoutingKey && myRoutingKey !== "") {
            topics.push(myRoutingKey);
        }
        if (smartTVTempKey && smartTVTempKey !== "") {
            topics.push(smartTVTempKey);
        }

        if (topics.length > 0) {
            subscribeTopics(topics, {
                qos: 1,
                timeoutSec: 3,
                onSuccess: onSuccessSubscribeForSmartTV,
                onFailure: onFailureSubscribe,
                failureCode: enRbmqError.INTERNAL_ERROR
            });
        } else {
            console.log("onSuccessConnectForSmartTV() - topics => ", topics);
            window.alert("onSuccessConnectForSmartTV() - topics is empty");
        }

        let store = window.hiclasstv.store;
        store.dispatch(rbmqServerConnected());
    }
}

const onSuccessSubscribeForSmartTV = (msg) => {
    console.log("onSuccessSubscribeForSmartTV => ", msg);

    console.log("onSuccessSubscribeForSmartTV - isSend => ", smartTVInfo.isSend);
    if (smartTVInfo.isSend === false) {
        smartTVInfo.isSend = true;
        console.log("onSuccessSubscribeForSmartTV - sendGetSmartTVBindInfo called");
        sendGetSmartTVBindInfo();
    }
}

const onFailureUnsubscribeTempKeyForSmartTV = (res) => {
    writeRbmqErrorMessage("onFailureUnsubscribeTempKeyForSmartTV", res);
}

const onSuccessUnsubscribeTempKeyForSmartTV = (msg) => {
    console.log("onSuccessUnsubscribeTempKeyForSmartTV => ", msg);

    try {
        if (rbmqClient) {
            const topics = isUsableArrayObj(smartTVInfo.bindKeyArr) ? [...smartTVInfo.bindKeyArr] : [];

            if (topics.length > 0) {
                subscribeTopics(topics, {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribeLiveForSmartTV,
                    onFailure: onFailureSubscribeLiveForSmartTV,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("onSuccessUnsubscribeTempKeyForSmartTV() - smartTVInfo.bindKeyArr => ", smartTVInfo.bindKeyArr);
                window.alert("onSuccessUnsubscribeTempKeyForSmartTV() - smartTVInfo.bindKeyArr is empty");
            }
        }
    } catch (err) {
        console.log("onSuccessUnsubscribeTempKeyForSmartTV error => ", err);
    }
}

const onFailureSubscribeLiveForSmartTV = (res) => {
    writeRbmqErrorMessage("onFailureSubscribeLiveForSmartTV => ", res);
}

const onSuccessSubscribeLiveForSmartTV = (msg) => {
    console.log("onSuccessSubscribeLiveForSmartTV => ", msg);
    console.log("sendJoinConsume call - case SmartTV");
    sendJoinConsume("live", smartTVInfo.teacherSeq);
}

const onFailureUnsubscribeLiveForSmartTV = (res) => {
    writeRbmqErrorMessage("onFailureUnsubscribeLiveForSmartTV => ", res);
}

const onSuccessUnsubscribeLiveForSmartTV = (msg) => {
    console.log("onSuccessUnsubscribeLiveForSmartTV => ", msg);

    const topics = [];
    if (myRoutingKey && myRoutingKey !== "") {
        topics.push(myRoutingKey);
    } else if (isUsableArrayObj(myRoutingKeyArr)) {
        topics.push(...myRoutingKeyArr);
        if (smartTVTempKey && smartTVTempKey !== "") {
            topics.push(smartTVTempKey);
        }
    }

    if (topics.length > 0) {
        unsubscribeTopics(topics, {
            timeoutSec: 3,
            onSuccess: onSuccessUnsubscribe,
            onFailure: onFailureUnsubscribe,
            failureCode: enRbmqError.INTERNAL_ERROR
        });
    } else {
        console.log("onSuccessUnsubscribeLiveForSmartTV() - myRoutingKey => ", myRoutingKey, ", myRoutingKeyArr => ", myRoutingKeyArr);
        window.alert("onSuccessUnsubscribeLiveForSmartTV() - unsubscribe topics empty");
    }
}

const onSuccessUnsubscribeLiveForSmartTVWithLog = (msg) => {
    console.log("onSuccessUnsubscribeLiveForSmartTVWithLog - msg => ", msg);
}

/********************************/

/** rbmq group smart tv callback 처리 */
const onSuccessConnectForGroupSmartTV = (msg) => {
    console.log("onSuccessConnectForGroupSmartTV => ", msg);

    if (rbmqClient) {
        // 스마트TV는 sendKey 이슈로 인해 클래스에 참여 후 PING을 보내도록 주석 처리 ... by hjkim 20260413
        /* if (pingInterval === null) {
            pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
        } */

        const topics = isUsableArrayObj(myRoutingKeyArr) ? [...myRoutingKeyArr] : [];
        if (smartTVTempKey && smartTVTempKey !== "") {
            topics.push(smartTVTempKey);
        }

        console.log("myRoutingKeyArr => ", myRoutingKeyArr);
        console.log("GroupSmartTV subscribe topics => ", topics);

        if (topics.length > 0) {
            subscribeTopics(topics, {
                qos: 1,
                timeoutSec: 3,
                onSuccess: onSuccessSubscribeForGroupSmartTV,
                onFailure: onFailureSubscribe,
                failureCode: enRbmqError.INTERNAL_ERROR
            });
        } else {
            console.log("onSuccessConnectForGroupSmartTV() - topics => ", topics);
            window.alert("onSuccessConnectForGroupSmartTV() - topics is empty");
        }

        let store = window.hiclasstv.store;
        store.dispatch(rbmqServerConnected());
    }
}

const onSuccessSubscribeForGroupSmartTV = (msg) => {
    console.log("onSuccessSubscribeForGroupSmartTV => ", msg);

    console.log("onSuccessSubscribeForGroupSmartTV - isSend => ", smartTVInfo.isSend);
    if (smartTVInfo.isSend === false) {
        smartTVInfo.isSend = true;
        console.log("onSuccessSubscribeForSmartTV - sendGetSmartTVBindInfo called");
        sendGetSmartTVBindInfo();
    }
}

const onFailureUnsubscribeTempKeyForGroupSmartTV = (res) => {
    writeRbmqErrorMessage("onFailureUnsubscribeTempKeyForGroupSmartTV => ", res);
}

const onSuccessUnsubscribeTempKeyForGroupSmartTV = (msg) => {
    console.log("onSuccessUnsubscribeTempKeyForGroupSmartTV => ", msg);

    try {
        if (rbmqClient) {
            const topics = isUsableArrayObj(smartTVInfo.bindKeyArr) ? [...smartTVInfo.bindKeyArr] : [];

            if (topics.length > 0) {
                subscribeTopics(topics, {
                    qos: 1,
                    timeoutSec: 3,
                    onSuccess: onSuccessSubscribeLiveForGroupSmartTV,
                    onFailure: onFailureSubscribeLiveForGroupSmartTV,
                    failureCode: enRbmqError.INTERNAL_ERROR
                });
            } else {
                console.log("onSuccessUnsubscribeTempKeyForGroupSmartTV() - smartTVInfo.bindKeyArr => ", smartTVInfo.bindKeyArr);
                window.alert("onSuccessUnsubscribeTempKeyForGroupSmartTV() - smartTVInfo.bindKeyArr is empty");
            }
        }
    } catch (err) {
        console.log("onSuccessUnsubscribeTempKeyForGroupSmartTV error => ", err);
    }
}

const onFailureSubscribeLiveForGroupSmartTV = (res) => {
    writeRbmqErrorMessage("onFailureSubscribeLiveForGroupSmartTV => ", res);
}

const onSuccessSubscribeLiveForGroupSmartTV = (msg) => {
    console.log("onSuccessSubscribeLiveForGroupSmartTV => ", msg);
    console.log("sendJoinConsume call - case GroupSmartTV");
    sendJoinConsume("live", smartTVInfo.teacherSeq);
}

const onFailureUnsubscribeLiveForGroupSmartTV = (res) => {
    writeRbmqErrorMessage("onFailureUnsubscribeLiveForGroupSmartTV => ", res);
}

const onSuccessUnsubscribeLiveForGroupSmartTV = (msg) => {
    console.log("onSuccessUnsubscribeLiveForGroupSmartTV => ", msg);

    const topics = [];
    if (myRoutingKey && myRoutingKey !== "") {
        topics.push(myRoutingKey);
    }

    if (topics.length > 0) {
        unsubscribeTopics(topics, {
            timeoutSec: 3,
            onSuccess: onSuccessUnsubscribe,
            onFailure: onFailureUnsubscribe,
            failureCode: enRbmqError.INTERNAL_ERROR
        });
    } else {
        console.log("onSuccessUnsubscribeLiveForGroupSmartTV() - myRoutingKey => ", myRoutingKey);
        window.alert("onSuccessUnsubscribeLiveForGroupSmartTV() - myRoutingKey => " + myRoutingKey);
    }
}
/********************************/

/** rbmq data receive 처리 */
export const onMessageArrivedFromIOSWebView = (msg) => {
    //console.log("onMessageArrivedFromIOSWebView - ", msg);
    const { routingKey, bodyBase64, bodyBytes, bodySize } = msg;

    try {
        if (myHandsUpSendKey === routingKey || 
            mySmallGroupSendKey === routingKey || 
            mySmallGroupImageSendKey === routingKey) {
            return;
        }

        let arrayBuffer;

        if (bodyBytes && Array.isArray(bodyBytes)) {
            const uint8Array = new Uint8Array(bodyBytes);
            arrayBuffer = uint8Array.buffer;
        } else if (bodyBase64) {
            try {
                const binaryString = atob(bodyBase64);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                arrayBuffer = bytes.buffer;
            } catch (base64Error) {
                console.error("Base64 decode error:", base64Error);
                console.log("Base64 string sample:", bodyBase64.substring(0, 50));
                return;
            }
        } else {
            console.error("No data field found");
            return;
        }

        console.log("ArrayBuffer created:", arrayBuffer.byteLength, "bytes");
        console.log("Calling rawDataWithRoutingKey...");

        rawDataWithRoutingKey(arrayBuffer, routingKey);

        console.log("rawDataWithRoutingKey completed");
    } catch (err) {
        console.log("onMessageArrivedFromIOSWebView err => ", err);
    }
}

/* const onMessageArrived = (msg) => {
    try {
        // console.log(msg);
        let regEx = new RegExp("/", "gi");
        let routingKey = msg.destinationName.replace(regEx, ".");
        if (myHandsUpSendKey === routingKey || mySmallGroupSendKey === routingKey || mySmallGroupImageSendKey === routingKey) return;
        // console.log("msg.destinationName => ", msg.destinationName);

        rawDataWithRoutingKey(msg.payloadBytes, routingKey);
    } catch (err) {
        console.log("onMessageArrived err => ", err);
    }
} */

const onMessageArrived = (topic, message) => {
    try {
        const routingKey = topic.replace(/\//g, ".");

        if (
            myHandsUpSendKey === routingKey ||
            mySmallGroupSendKey === routingKey ||
            mySmallGroupImageSendKey === routingKey
        ) {
            return;
        }

        // mqtt.js의 message는 Buffer
        rawDataWithRoutingKey(message, routingKey);
    } catch (err) {
        console.log("onMessageArrived err => ", err);
    }
}

/**
 * 의도적 연결 해제(= 정상 퇴장)가 완료되었을 때 공통으로 호출하는 함수.
 * PC에서는 rbmqClient.end() 완료 콜백에서,
 * Android에서는 pro-disconnectedRbmq에서,
 * iOS에서는 pro-disconnectRbmq (또는 동등한 콜백)에서 호출한다.
 * 
 * @since 2026-04-13.
 */
const handleIntentionalDisconnectDone = () => {
    console.log("handleIntentionalDisconnectDone called");

    // 260804 정상 완료와 5초 안전 타임아웃이 동시에 페이지를 이동하지 않도록 한다.
    if (isClassExitFinalized) {
        console.log("handleIntentionalDisconnectDone skipped - already finalized");
        return;
    }
    isClassExitFinalized = true;

    if (classExitSafetyTimer) {
        clearTimeout(classExitSafetyTimer);
        classExitSafetyTimer = null;
    }

    // pingInterval 정리
    if (pingInterval) {
        clearInterval(pingInterval);
        pingInterval = null;
    }

    // 이동할 페이지를 cleanup 전에 미리 계산
    // (cleanup 후에는 currentPageType 등이 초기화될 수 있음)
    const navigationTarget = classExitNavigationTarget || resolveNavigationTarget(true);
    classExitNavigationTarget = "";
    saveLoginRecoveryPath(navigationTarget || "/main"); // 20261020 R-127 직접 나간 뒤에는 사고 복구 쿼리를 재사용하지 않는다

    // ── 상태 초기화 ──
    rbmqClient = null;
    rbmqClientID = null;
    rbmqInfo = null;
    myRoutingKey = null;
    myRoutingKeyArr = [];
    smartTVTempKey = null;
    myTempBindKey = null;
    routingIdx = -1;
    isGuestMember = false;
    isMixedClassMember = false;

    // 다음 연결 세션을 위해 플래그 리셋
    isIntentionalDisconnect = false;
    isDisconnecting = false;

    // Redux 상태 업데이트
    const store = window.hiclasstv.store;
    store.dispatch(rbmqServerDisconnected());
    store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));

    // 페이지 이동
    if (navigationTarget && navigationTarget !== "") {
        console.log("handleIntentionalDisconnectDone - navigate to:", navigationTarget);
        window.location = navigationTarget;
    } else {
        console.log("handleIntentionalDisconnectDone - no navigation target");
    }
}

/**
 * 클래스 종료 중 RabbitMQ 완료 콜백이 유실되어도 로그인 화면 이동을 보장합니다.
 * 정상 완료 시 [handleIntentionalDisconnectDone]에서 즉시 타이머를 해제합니다.
 *
 * @since 2026-08-04.
 */
const startClassExitSafetyTimer = () => {
    if (classExitSafetyTimer) return;

    // 260804 RabbitMQ 상태 초기화 전에 이동할 페이지를 보관한다.
    classExitNavigationTarget = resolveNavigationTarget(true);
    isClassExitFinalized = false;
    classExitSafetyTimer = setTimeout(() => {
        console.warn("class exit RabbitMQ cleanup timeout - finalize after 5 seconds");
        handleIntentionalDisconnectDone();
    }, 5000);
}

/**
 * 현재 페이지 종류의 "연결 끊김 시 이동 위치"를 새로고침 복귀 경로로 쿠키에 저장한다. (R-126, Q-019)
 * 새로고침·재기동으로 /live 를 새 문서로 열면 WebLivePage 가 /main 대신 이 경로로 보낸다.
 * 연결 끊김 이동과 같은 규칙(resolveNavigationTarget, 비의도 종료 기준)을 그대로 쓴다. 저장 시점은 LoginRecoveryPath 참고.
 *
 * @author hjkim.
 * @since 2026-10-20.
 */
const rememberLoginRecoveryPath = () => scheduleLoginRecoveryPath(() => resolveNavigationTarget(false), currentPageType === enWebPage.Home, () => window.hiclasstv.store.getState().user.isLoginYn === "Y"); // 20261020 R-127·R-133·R-134

/**
 * 현재 pageType과 URL에 기반하여 이동할 위치(location)를 계산합니다.
 * onSuccessUnsubscribe에서 cleanup 전에 미리 호출해야 합니다.
 * 
 * @param {Boolean} [isIntentional=false] - 의도적 종료 여부
 * @returns {String} 이동할 URL 경로를 반환(이동 불필요 시 빈 문자열("")을 반환)
 * @since 2026-04-13.
 */
const resolveNavigationTarget = (isIntentional = false) => {
    console.log("resolveNavigationTarget - currentPageType[", currentPageType, "]");

    let location = "";

    if (currentPageType === enWebPage.Home) {
        // Home 페이지에서 연결이 끊긴 경우 → /main으로
        location = "/main";
    } else {
        // URL에서 마지막 seq 추출
        const pathname = window.location.pathname;
        const pathnameArr = pathname.split("/");
        const seq = pathnameArr.length > 0 ? pathnameArr[pathnameArr.length - 1] : "";

        if (currentPageType === enWebPage.ClassMonitor || currentPageType === enWebPage.ClassMonitorLogin) {
            location = "/class-monitor/login"; // 260728 재연결하지 않고 정리 후 클래스 선택 화면으로 이동한다.
        } else if (currentPageType === enWebPage.SmartTV) {
            location = `/smarttv-login/${seq}`;
        } else if (currentPageType === enWebPage.GroupSmartTV) {
            location = `/group-smarttv-login/${seq}`;
        } else if (currentPageType === enWebPage.LiveQRLogin) {
            location = `/main-qrLogin/${seq}`;

            // 260904 사고로 끊긴 학생만 조용히 되돌린다.
            // 자동 로그인 종료(END_AUTO_LOGIN)는 retained를 지우므로 앱 쪽 자동 복귀의 방아쇠가
            // 없어진다. 그런데 자동 로그인 종료는 "안 들어와 있는 학생을 자동으로 들이는 것"을
            // 그만두는 것이지 수업을 끝내는 것이 아니고, 실제로 학생을 수업 밖으로 내보내지도
            // 않는다. 그 학생은 나간 적이 없으므로 되돌리는 것이 맞다.
            //   의지로 나간 경우(user-exit)는 isIntentional이 true라 쿼리가 안 붙는다.
            //   수업이 이미 끝났으면 명단이 비어(list_qrLoginMember: []) 매칭에 실패하므로
            //   저절로 걸러진다 — 별도 판정을 두지 않는다.
            // 받는 쪽: QRLogInContainer 의 조용한 재로그인 갈래.
            if (!isIntentional && isWindowsWebView()) {
                const store = window.hiclasstv.store;
                const { user } = store.getState();
                const userID = user.userID || "";
                const userNickname = user.userNickname || "";

                if (userID !== "") {
                    location += `?userID=${encodeURIComponent(userID)}&userNickname=${encodeURIComponent(userNickname)}`;
                    console.log("resolveNavigationTarget - 조용한 재로그인 쿼리를 붙였다. userID[", userID, "]");
                }
            }
        } else if (currentPageType === enWebPage.LiveQRLoginPbl ||
            currentPageType === enWebPage.LiveClassTalkPbl ||
            currentPageType === enWebPage.Pbl) {
            const store = window.hiclasstv.store;
            const { user } = store.getState();
            const { userID, userNickname } = user;
            location = `/pbl-login/${seq}?userID=${userID}&userNickname=${userNickname}`;
        } else if (currentPageType === enWebPage.MixedClassLogin ||
            currentPageType === enWebPage.MixedClassLiveClassTalk ||
            currentPageType === enWebPage.MixedClassQRLoginPbl ||
            currentPageType === enWebPage.MixedClassLiveClassTalkPbl ||
            currentPageType === enWebPage.MixedClassPbl) {

            const isPbl = getIsForPblModeBrowser();
            const path = isPbl ? "/pbl-mixed-login/" : "/mixed-login/";
            let mixedSeq = 0;
            if (localServerSendData && localServerSendData.mixedClassSeq > 0) {
                mixedSeq = localServerSendData.mixedClassSeq;
            } else {
                const store = window.hiclasstv.store;
                const { live } = store.getState();
                mixedSeq = live?.mixedClassInfo?.mixedClassSeq || 0;
            }

            if (mixedSeq > 0) {
                if (isPbl) {
                    const store = window.hiclasstv.store;
                    const { user } = store.getState();
                    // const { userID, userNickname } = user;
                    // userID/userNickname이 비어있으면 URL 쿼리에서 추출 시도
                    let userID = user.userID || "";
                    let userNickname = user.userNickname || "";

                    if (!userID || !userNickname) {
                        // URL 쿼리스트링에서 복원 시도
                        const params = new URLSearchParams(window.location.search);
                        userID = userID || params.get("userID") || "";
                        userNickname = userNickname || params.get("userNickname") || "";
                    }

                    location = `${path}${mixedSeq}?userID=${encodeURIComponent(userID)}&userNickname=${encodeURIComponent(userNickname)}`;
                } else {
                    location = `${path}${mixedSeq}`;
                }
            } else {
                // ★ mixedSeq를 못 찾으면 /main 폴백 (멈추지 않도록)
                console.warn("resolveNavigationTarget - mixedSeq not found, fallback to /main");
                location = "/main";
            }

            console.log("Mixed case:) final mixedSeq[", mixedSeq, "], final location[", location, "]");
        } else {
            // ★ 일반 라이브/클래스톡 페이지 (Live, LiveClassTalk 등)
            if (!isIntentional) {
                // 비정상 종료 → /main으로 강제 이동
                location = "/main";
            } else {
                // 의도적 종료 → 컨테이너 단에서 처리하므로 이동 생략
                // location = "/main";
            }
        }
    }

    console.log("resolveNavigationTarget - currentPageType:", currentPageType, "→ location:", location);
    return location;
}

// 260907 망이 죽은 채로 이동하면 그 페이지를 못 받는다 — 번들을 새로 받아야 하는 이동이기 때문이다.
//   실기 35차(라운드 14): 13:46:55 끊김 → 그 자리에서 /main-qrLogin 으로 이동 →
//   ERR_INTERNET_DISCONNECTED. 13:49:25 에 망이 돌아왔지만 되살아나는 것이 없었다.
//   그 뒤에 있는 조용한 재로그인도, 명단 재요청도 실행될 기회를 못 얻는다.
// ⇒ 이동 자체는 그대로 둔다(리덕스 리셋이 full reload 에 딸려 있다). 「닿을 때까지」만 미룬다.
//   서버에 HEAD 한 번이 성공하면 그때 옮긴다. navigator.onLine 은 참고만 한다 —
//   WebView 에서 믿을 수 있는지 우리가 확인한 적이 없다.
const REACHABLE_PROBE_DELAY = 3000;
const REACHABLE_PROBE_LIMIT = 200;      // 3초 x 200 = 10분

const moveToLocationWhenReachable = (location, tag) => {
    if (!location || location === "") return;

    // 260907 fetch 가 없는 셸(구형 EO.WebBrowser 등)에서는 재던 대로 바로 옮긴다.
    if (typeof fetch !== "function") {
        console.log(`moveToLocationWhenReachable(${tag}) - fetch 없음. 바로 옮긴다 => `, location);
        window.location = location;
        return;
    }

    let tries = 0;

    const move = (why) => {
        console.log(`moveToLocationWhenReachable(${tag}) - ${why}. move to location => `, location);
        window.location = location;
    }

    const schedule = () => {
        tries++;
        if (tries > REACHABLE_PROBE_LIMIT) {
            // 한도까지 안 닿으면 원래 동작대로 옮긴다. 여기 남아 있는 것보다는 낫다.
            move(`${REACHABLE_PROBE_LIMIT}회 동안 서버에 못 닿음`);
            return;
        }
        setTimeout(probe, REACHABLE_PROBE_DELAY);
    }

    const probe = () => {
        if (navigator.onLine === false) {
            console.log(`moveToLocationWhenReachable(${tag}) - navigator.onLine false. 기다린다 ... ${tries}/${REACHABLE_PROBE_LIMIT}`);
            schedule();
            return;
        }

        fetch(`${window.location.origin}/index.html?probe=${Date.now()}`, { method: "HEAD", cache: "no-store" })
            .then(() => move("서버에 닿았다"))
            .catch(() => {
                console.log(`moveToLocationWhenReachable(${tag}) - 아직 못 닿는다. 기다린다 ... ${tries}/${REACHABLE_PROBE_LIMIT}`);
                schedule();
            });
    }

    probe();   // 망이 멀쩡하면 여기서 바로 옮긴다
}

/**
 * 기존 Paho.MQTT 구조와 호환을 위한 헬퍼 함수
 * 
 * @param {Object} err - 에러 객체
 * @param {Number} fallbackCode - 에러 코드
 * @returns MQTT 에러 객체
 * @since 2026-04-06.
 */
const normalizeMqttError = (err, fallbackCode = enRbmqError.INTERNAL_ERROR) => {
    console.log("normalizeMqttError - err => ", err);

    const message = err?.message || "Unknown MQTT error";
    const rawCode = err?.code || "";

    if (isIntentionalDisconnect && /close/i.test(message)) {
        return {
            errorCode: enRbmqError.OK,
            errorMessage: message,
            rawCode,
            rawError: err,
            isIntentionalClose: true
        };
    }

    let errorCode = fallbackCode;

    if (rawCode === "ETIMEDOUT" || /timeout/i.test(message)) {
        errorCode = enRbmqError.CONNECT_TIMEOUT;
    } else if (rawCode === "ECONNREFUSED" || /connack|not authorized/i.test(message)) {
        errorCode = enRbmqError.CONNACK_RETURNCODE;
    } else if (rawCode === "ECONNRESET") {
        errorCode = enRbmqError.SOCKET_ERROR;
    } else if (/close/i.test(message)) {
        errorCode = enRbmqError.SOCKET_CLOSE;
    } else if (/invalid state/i.test(message)) {
        errorCode = enRbmqError.INVALID_STATE;
    } else if (/invalid argument/i.test(message)) {
        errorCode = enRbmqError.INVALID_ARGUMENT;
    }

    return {
        errorCode,
        errorMessage: message,
        rawCode,
        rawError: err
    };
}

const writeRbmqErrorMessage = (type, msg) => {
    let store = window.hiclasstv.store;
    let str = "";
    // let str = `인터넷 연결에 문제가 발생하였습니다. 확인을 누를 경우 로그인 화면으로 이동합니다. [Code.RB${msg.errorCode}]`;

    // location 계산
    const location = resolveNavigationTarget(false);
    // console.log(window.location);

    // 심화 학습 모드 값에 따라 설정 ... by hjkim 20260311
    const { live } = store.getState();
    const { isIntensiveControlMode } = live;
    let shouldSendIntensiveCtrlNoti = isIntensiveControlMode;   // 에러 케이스에서 알려야 함 ... by hjkim
    console.log("writeRbmqErrorMessage - isIntensiveControlMode[", isIntensiveControlMode, "]");

    // 20260311 심화 학습 모드 중이므로 종료 신호를 전송
    if (shouldSendIntensiveCtrlNoti) {
        if (isAndroidWebView()) {
            console.log("case 3:) call window.callIntensiveControlEnd().");
            window.callIntensiveControlEnd();
        } else if (isWindowsWebView()) {
            console.log("case 3:) call window.chrome.webview.postMessage({ kind: 'intensive-end' }).");
            window.chrome.webview.postMessage({
                // action: "intensiveControl",
                kind: "intensive-end"
            });
        } else {
            console.log("case 3:) intensiveControl(intensive-end) not supported ... ");
        }
    }

    if (typeof msg === "undefined") {
        str = i18n.t("인터넷_연결_오류_문구", { ns: "library", errorCode: enRbmqError.UNKNOWN_ERROR });
        console.log(str, `[${type}] Exception => [msg is undefined!]`);

        store.dispatch(rbmqServerError({ message: "msg is undefined!" }));
        store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));

        alert(str);

        // 오류 발생 후 즐겨찾기 버튼을 보이게 처리하기 위해 추가 ... by hjkim 20260320
        if (isAndroidWebView()) {
            console.log("즐겨찾기 버튼 영역 표시 요청 - call window.showBookmarkButtonArea()");
            window.showBookmarkButtonArea();
        }

        // 260907 망이 죽어 있으면 닿을 때까지 미룬다. 죽은 망으로 옮기면 페이지를 못 받는다.
        moveToLocationWhenReachable(location, "msg-undefined");

        return;
    }

    if (typeof msg === "string") {
        str = i18n.t("인터넷_연결_오류_문구", { ns: "library", errorCode: enRbmqError.ERROR });
        console.log(str, `[${type}] Exception => [${msg}]`);

        store.dispatch(rbmqServerError({ message: msg }));
        store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));

        alert(str);

        // 오류 발생 후 즐겨찾기 버튼을 보이게 처리하기 위해 추가 ... by hjkim 20260320
        if (isAndroidWebView()) {
            console.log("즐겨찾기 버튼 영역 표시 요청 - call window.showBookmarkButtonArea()");
            window.showBookmarkButtonArea();
        }

        // 260907 망이 죽어 있으면 닿을 때까지 미룬다. 죽은 망으로 옮기면 페이지를 못 받는다.
        moveToLocationWhenReachable(location, "msg-string");
    } else {
        str = i18n.t("인터넷_연결_오류_문구", { ns: "library", errorCode: msg.errorCode });

        // ★ enRbmqError.OK는 이제 writeRbmqErrorMessage로 오지 않음
        //   정상 종료는 onSuccessUnsubscribe → resolveNavigationTarget → window.location으로 처리
        switch (msg.errorCode) {
            case enRbmqError.CONNECT_TIMEOUT:
                console.log(str, `[${type}] CONNECT_TIMEOUT Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.SUBSCRIBE_TIMEOUT:
                console.log(str, `[${type}] SUBSCRIBE_TIMEOUT Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.UNSUBSCRIBE_TIMEOUT:
                console.log(str, `[${type}] UNSUBSCRIBE_TIMEOUT Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.PING_TIMEOUT:
                console.log(str, `[${type}] PING_TIMEOUT Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.INTERNAL_ERROR:
                console.log(str, `[${type}] INTERNAL_ERROR Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.CONNACK_RETURNCODE:
                console.log(str, `[${type}] CONNACK_RETURNCODE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.SOCKET_ERROR:
                console.log(str, `[${type}] SOCKET_ERROR Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.SOCKET_CLOSE:
                console.log(str, `[${type}] SOCKET_CLOSE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.MALFORMED_UTF:
                console.log(str, `[${type}] MALFORMED_UTF Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.UNSUPPORTED:
                console.log(str, `[${type}] UNSUPPORTED Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.INVALID_STATE:
                console.log(str, `[${type}] INVALID_STATE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.INVALID_TYPE:
                console.log(str, `[${type}] INVALID_TYPE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.INVALID_ARGUMENT:
                console.log(str, `[${type}] INVALID_ARGUMENT Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.UNSUPPORTED_OPERATION:
                console.log(str, `[${type}] UNSUPPORTED_OPERATION Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.INVALID_STORED_DATA:
                console.log(str, `[${type}] INVALID_STORED_DATA Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.INVALID_MQTT_MESSAGE_TYPE:
                console.log(str, `[${type}] INVALID_MQTT_MESSAGE_TYPE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.MALFORMED_UNICODE:
                console.log(str, `[${type}] MALFORMED_UNICODE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.TRANSPORT_CLOSE:
                console.log(str, `[${type}] TRANSPORT_CLOSE Exception => [${msg.errorMessage}]`);
                break;

            case enRbmqError.TRANSPORT_ERROR:
                console.log(str, `[${type}] TRANSPORT_ERROR Exception => [${msg.errorMessage}]`);
                break;

            default:
                console.log(str, `[${type}] default Exception => [${msg.errorMessage}]`);
                break;
        }

        store.dispatch(rbmqServerError({ message: msg.errorMessage }));
        store.dispatch(toggleReadyLiveConsume({ isReadyLiveConsume: false }));

        console.log("msg.isNoAlert[", msg.isNoAlert, "]");
        if (!msg.isNoAlert) {
            alert(str);
        }

        // 오류 발생 후 즐겨찾기 버튼을 보이게 처리하기 위해 추가 ... by hjkim 20260320
        if (isAndroidWebView()) {
            console.log("즐겨찾기 버튼 영역 표시 요청 - call window.showBookmarkButtonArea()");
            window.showBookmarkButtonArea();
        }

        // 260907 망이 죽어 있으면 닿을 때까지 미룬다. 죽은 망으로 옮기면 페이지를 못 받는다.
        moveToLocationWhenReachable(location, "msg-object");
    }
}
/********************************/

const arrayBufferToBase64 = (buffer) => {
    const bytes = new Uint8Array(buffer);
    let binary = "";
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}
/********************************/

/********************************/

/** rbmq ping send */
const sendPingToRbmq = () => {
    /* let message = null;
    if (myRoutingKey && myRoutingKey !== "") {
        message = new window.Paho.MQTT.Message("");
        message.destinationName = myRoutingKey;
    }

    if (rbmqClient) {
        if (message !== null) {
            // console.log("sendPingToRbmq - message => ", message);
            rbmqClient.send(message);
        }
    } */

    try {
        let sendKey;
        if (!isSmartTVMode) {
            if (!myRoutingKey || myRoutingKey === "") {
                if (!isMixedClassMember) {
                    console.log("sendPingToRbmq - myRoutingKey invalid => ", myRoutingKey);
                    return;
                } else {
                    if (!myTempBindKey || myTempBindKey === "") {
                        console.log("sendPingToRbmq - myTempBindKey invalid => ", myTempBindKey);
                        return;
                    } else {
                        sendKey = myTempBindKey;
                    }
                }
            } else {
                sendKey = myRoutingKey;
            }
        } else {
            if (!smartTVInfo.bindKey || smartTVInfo.bindKey === "") {
                console.log("sendPingToRbmq - smartTVInfo.bindKey invalid => ", smartTVInfo.bindKey);
                return;
            }

            sendKey = smartTVInfo.bindKey;
        }

        const emptyBuffer = new ArrayBuffer(0);
        sendDataToRbmq(sendKey, emptyBuffer);
    } catch (err) {
        console.log("sendPingToRbmq error => ", err);
    }
}

/** rbmq data send 처리 */
const sendDataToRbmq = (routingKey, sendData) => {
    if (isIOSWebView()) {
        try {
            const message = {
                action: "pro-sendDataToRbmq",
                data: {
                    routingKey,
                    sendData: arrayBufferToBase64(sendData)
                }
            }

            window.webkit.messageHandlers.screenShareHandler.postMessage(message);
        } catch (e) {
            console.error("sendDataToRbmq (iOS) - Exception:", e);
        }
    } else if (isAndroidWebView()) {
        // console.log("sendDataToRbmq - Android WebView Native 모드");
        // console.log("  RoutingKey:", routingKey);
        // console.log("  Data size:", sendData.byteLength || sendData.length || 0, "bytes");

        try {
            const uint8Array = sendData instanceof Uint8Array
                ? sendData
                : new Uint8Array(sendData);

            const base64Data = arrayBufferToBase64(uint8Array);

            // console.log("  Base64 encoded:", base64Data.length, "chars");

            window.sendRabbit(routingKey, base64Data);
        } catch (e) {
            console.error("sendDataToRbmq (Android) - Exception:", e);
        }
    } else {
        if (rbmqClient && rbmqClient.connected && routingKey) {
            try {
                const payload = sendData instanceof Uint8Array
                    ? sendData
                    : new Uint8Array(sendData);

                rbmqClient.publish(routingKey, payload, { qos: 1 }, (err) => {
                    if (err) {
                        console.log("sendDataToRbmq publish error => ", err);
                    } else {
                        // console.log("sendDataToRbmq publish success => ", routingKey);
                    }
                });
            } catch (err) {
                console.log("sendDataToRbmq error => ", err);
            }
        } else {
            console.log("sendDataToRbmq skipped =>", {
                hasClient: !!rbmqClient,
                connected: rbmqClient?.connected,
                routingKey
            });
        }
    }
}

export const sendCommandToRbmq = (routingKey, sendObj) => {
    // console.log("sendCommandToRbmq - routingKey[", routingKey, "], sendObj => ", sendObj);
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify(sendObj)
    }, "event_exchange");

    sendDataToRbmq(routingKey, sendData.forWeb);
}

export const sendObjectToRbmq = (sendObj) => {
    // console.log("sendObjectToRbmq - sendObj => ", sendObj);
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify(sendObj)
    }, "event_exchange");

    sendDataToRbmq(routingKey, sendData.forWeb);
}

export const sendPageGetArtifactsForAndroid = (action, tokenCmd) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userNickname, userSeq } = user;
    const { performLiveInfo } = live;
    let performLiveSeq = performLiveInfo.liveSeq;

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({ kind: "android", action, information: { tokenCmd, userSeq, liveSeq: performLiveSeq } })
    }, userNickname);

    if (myPenCamServiceKey && myPenCamServiceKey !== "") {
        sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
    }
}

export const sendStartPentalkOnScreenForIOS = (isP2PMode, configFPSKind) => {
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { performLiveInfo } = live;

    let performLiveSeq = performLiveInfo.liveSeq;
    let performLiveTeacherSeq = -1;
    let performLiveTeacherRoomSeq = -1;
    if (performLiveInfo.teacher_info) {
        let performLiveTeacherInfo = performLiveInfo.teacher_info;
        if (performLiveTeacherInfo.userSeq !== undefined && performLiveTeacherInfo.userSeq !== null) {
            performLiveTeacherSeq = performLiveTeacherInfo.userSeq;
        }

        if (performLiveTeacherInfo.teamUpSeq !== undefined && performLiveTeacherInfo.teamUpSeq !== null) {
            performLiveTeacherRoomSeq = performLiveTeacherInfo.teamUpSeq;
        }
    }

    let config = {
        tKey: myTeacherDirectKey,
        teacherSeq: performLiveTeacherSeq,
        liveSeq: performLiveSeq,
        isP2PMode,
        configFPSKind,
        isMediaSoupVersion,
        isSupportedWebRtcAudio: isMediaSoupVersion,     // 20250320 ... mediasoup 지원 버전 여부에 따라 값 바뀌도록 수정 ... by hjkim
        isSupportedAccessibilityService: true,      // 20250509 ... 혹시라도 commit 시 주석 처리 실수 방지를 위해 테스트 기간 동안 isDevVer 값에 따라 값이 바뀌도록 수정함 ... by hjkim
        userGateWay: routingKey ? routingKey : getServerDefaultRoutingKey()
    };

    const message = {
        action: "pro-startScreenShare",
        data: config
    }

    window.webkit.messageHandlers.screenShareHandler.postMessage(message);

    sendAppCreateProducerTransport();
}

export const sendStartPentalkOnScreenForAndroid = (isForSmartPen, isReconnMode, isP2PMode, isHandsUpInit, configFPSKind) => {
    console.log("sendStartPentalkOnScreenForAndroid called");
    console.log(`isForSmartPen[${isForSmartPen}], isReconnMode[${isReconnMode}], isP2PMode[${isP2PMode}], isHandsUpInit[${isHandsUpInit}], configFPSKind[${configFPSKind}]`);

    // 20251222 WebView 수정 코드 ... by hjkim
    // ========================================
    // ✅ 신 방식: ProcessComm 직접 호출
    // ========================================
    if (isAndroidWebView()) {
        console.log("✅ 신 방식: ProcessComm 사용");

        // ==========================================
        // Case 1: isForSmartPen = true → finishLive
        // ==========================================
        if (isForSmartPen) {
            console.log("📱 window.callFinishLive() 호출 (isForSmartPen = true)");
            window.callFinishLive();
            console.log("========================================");
            return;
        } else {
            // =============================================
            // Case 2: localStreamingMode에 따른 모드로 시작
            // - ct_StartP2P(1명 보기 / 학생 강의 / 스마트TV 연결 모드)
            // - ct_StartP2P(2명 보기)
            // - ct_StartP4P(4명 보기)
            // - ct_StopP2P(= Thumbnail / 전체 보기)
            // =============================================
            let localStreamingMode = getLocalStreamingMode();
            console.log("current localStreamingMode[", localStreamingMode, "]");

            const captureInfo = {
                isForSmartPen: isForSmartPen,
                isP2PMode: isP2PMode,
                isHandsUpInit: isHandsUpInit,
                configFPSKind: configFPSKind || "default",
                isReconnMode: isReconnMode,
                localStreamingMode
            };

            // Step 1: 화면 캡처 설정 정보와 함께 캡처 시작
            console.log("  → startScreenCapture 호출");
            window.startScreenCapture(captureInfo);

            if (isHandsUpInit) {
                // Step 2: 현재 화면 잠금 모드를 앱에 전달
                console.log("  → xmitCmd_AndroidTouchScreenLock 호출");
                xmitCmd_AndroidTouchScreenLock();
            }

            console.log("✅ ProcessComm 호출 완료 (P2P 모드)");
            console.log("========================================");
            return;
        }
    } else {
        // 안드로이드 기기인 경우 WebView가 지원될 수 있도록 app 다운로드 링크 호출하도록 수정 ... by hjkim 20260209
        if (getIsAndroidDevice()) {
            connectPenCamService();
        }
    }
}

export const sendGetSmartTVBindInfo = () => {
    let teacherSeq = smartTVInfo.teacherSeq;
    let userSeq = smartTVInfo.userSeq;
    let groupSeq = smartTVInfo.groupSeq;
    let liveSeq = smartTVInfo.liveSeq;
    let userNickname = smartTVInfo.userNickname;

    // console.log("sendGetSmartTVBindInfo - ", teacherSeq, liveSeq, userSeq, userNickname, smartTVTempKey);
    console.log("sendGetSmartTVBindInfo - teacherSeq[", teacherSeq, "], liveSeq[", liveSeq, "], userSeq[",
        userSeq, "], userNickname[", userNickname, "], smartTVTempKey[", smartTVTempKey, "]");

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind: "handsup",
            action: "getSmartTVBindKey",
            information: {
                liveSeq,
                userSeq,
                groupSeq,
                tempBindKey: smartTVTempKey,
                list_member: smartTVInfo.list_member
            }
        })
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    if (sendKey) {
        console.log("sendDataToRbmq called - sendKey => ", sendKey);
        sendDataToRbmq(sendKey, sendData.forWeb);
    }
}

export const sendUpdateHandsUpImage = (liveSeq, userSeq, imgData) => {
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname } = user;

    let reader = new FileReader();
    let array;
    reader.readAsArrayBuffer(imgData);
    reader.onload = () => {
        array = reader.result;

        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_UpdateHandsUpImage,
            CLASSID: liveSeq,
            PENID: userSeq,
            INT1: liveSeq,
            INT2: userSeq,
            data: array
        }, userNickname);

        if (myTeacherDirectKey && myTeacherDirectKey !== "") {
            sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
        }

        if (mySmallGroupImageSendKey && mySmallGroupImageSendKey !== "") {
            sendDataToRbmq(mySmallGroupImageSendKey, sendData.forWeb);
        }
    };
}

const sendPageJpeg = (cmd, userSeq, imgData) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userNickname } = user;
    const { performLiveInfo } = live;
    const { liveSeq } = performLiveInfo;

    const sendData = getSendToMQBytes({
        tokenCmd: cmd,
        CLASSID: liveSeq,
        PENID: userSeq,
        data: imgData
    }, userNickname);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

const sendScreenImage = (userSeq, imgData) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userNickname } = user;
    const { performLiveInfo } = live;
    const { liveSeq } = performLiveInfo;

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.page_PutArtifact,
        CLASSID: liveSeq,
        PENID: userSeq,
        data: imgData
    }, userNickname);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const getScreenImgStream = (cmd, stream) => {
    let videoEl = document.createElement("video");
    videoEl.width = ConstData.SCREEN_RATE.WIDTH;
    videoEl.height = ConstData.SCREEN_RATE.HEIGHT;
    videoEl.controls = true;
    videoEl.autoplay = true;
    videoEl.className = "fill_cover";
    videoEl.srcObject = stream;

    setTimeout((videoEl) => {
        let imgCanvasEl = document.createElement("canvas");
        imgCanvasEl.width = ConstData.SCREEN_RATE.WIDTH;
        imgCanvasEl.height = ConstData.SCREEN_RATE.HEIGHT;
        let imgContextEl = imgCanvasEl.getContext("2d");

        imgContextEl.drawImage(videoEl, 0, 0, imgCanvasEl.width, imgCanvasEl.height);

        imgCanvasEl.toBlob((blob) => {
            convertArrayBuffer(cmd, blob);
        }, "image/jpeg"/*, 1.0*/);
    }, 500, videoEl);
}

export const convertArrayBuffer = (cmd, blob) => {
    let reader = new FileReader();
    let array;
    reader.readAsArrayBuffer(blob);
    reader.onload = () => {
        array = reader.result;

        if (cmd === enTokenCMD.page_PutArtifact) {
            sendScreenImage(myUserSeq, array);
        } else {
            sendPageJpeg(cmd, myUserSeq, array);
        }
    };
}

export const sendRequestMixedClassLogin = (userSeq) => {
    if (myLocalServerBindKey && myLocalServerBindKey !== "" && localServerSendData && localServerSendData !== "") {
        let userAgent = navigator.userAgent.toLowerCase();
        let isAndroid = userAgent.indexOf("android") > -1;
        localServerSendData.localStudentUserSeq = userSeq;
        localServerSendData.isAndroidDevice = isAndroid;

        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({
                kind: "local",
                action: "login",
                information: localServerSendData
            })
        }, "event_exchange");

        sendDataToRbmq(myLocalServerBindKey, sendData.forWeb);
    }
}

export const sendRequestMixedClassLogout = (userSeq) => {
    if (myLocalServerBindKey && myLocalServerBindKey !== "" && localServerSendData && localServerSendData !== "") {
        localServerSendData.localStudentUserSeq = userSeq;

        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({
                kind: "local",
                action: "logout",
                information: localServerSendData
            })
        }, "event_exchange");

        sendDataToRbmq(myLocalServerBindKey, sendData.forWeb);
    }
}

export const xmitCmd_QuizAnswer = (kind, action, actionData) => {
    const { data, userSeq, userNickname, profileImgUrl } = actionData;

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind,
            action,
            information: {
                userSeq,
                iconSeq: profileImgUrl,
                data
            }
        })
    }, userNickname);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const xmitCmd_AndroidSmallGroupInfo = (kind, action, groupSendKey) => {
    // console.log("xmitCmd_AndroidSmallGroupInfo - ", groupSendKey);
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userNickname, userSeq } = user;
    const { performLiveInfo } = live;

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind,
            action,
            information: {
                tokenCmd: enTokenCMD.NULL,
                liveSeq: performLiveInfo.liveSeq,
                userSeq,
                groupSendKey
            }
        })
    }, userNickname);

    console.log("xmitCmd_AndroidSmallGroupInfo - myPenCamServiceKey => ", myPenCamServiceKey);

    if (myPenCamServiceKey && myPenCamServiceKey !== "") {
        sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
    }
}

export const xmitCmd_AndroidStatusMessage = (action, tokenCmd, status) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userNickname, userSeq } = user;
    const { performLiveInfo } = live;

    console.log("xmitCmd_AndroidStatusMessage - action[", action, "], tokenCmd[", tokenCmd, "], userSeq[", userSeq, "], userNickname[", userNickname, "], liveSeq[", performLiveInfo.liveSeq, "]");

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind: "android",
            action,
            information: {
                tokenCmd,
                liveSeq: performLiveInfo.liveSeq,
                userSeq,
                status
            }
        })
    }, userNickname);

    // console.log("xmitCmd_AndroidStatusMessage - myPenCamServiceKey => ", myPenCamServiceKey);

    if (myPenCamServiceKey && myPenCamServiceKey !== "") {
        sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
    }
}

export const xmitCmd_AndroidMessage = (action, tokenCmd, user_info) => {
    // console.log("xmitCmd_AndroidMessage - action[", action, "], tokenCmd[", tokenCmd, "], user_info => ", user_info);
    if (isAndroidWebView()) {
        switch (action) {
            case "ct_StartP1P":
                window.setP1PMode();
                break;

            case "ct_StartP2P":
                window.setP2PMode();
                break;

            case "ct_StartP4P":
                window.setP4PMode();
                break;

            case "ct_StopP2P":
                window.setThumbnailMode();
                break;

            case "ct_StartScreenCapture":
            case "ct_StartHandsUp":
                window.startScreenCapture({
                    isForSmartPen: false,
                    isP2PMode: false,
                    isHandsUpInit: false,
                    configFPSKind: "default",
                    isReconnMode: false,
                    localStreamingMode: getLocalStreamingMode()
                });
                break;

            case "ct_StopScreenCapture":
            case "ct_StopHandsUp":
                window.stopScreenCapture();
                break;

            case "ct_LiveOn":
                window.callLiveOn();
                break;

            case "ct_LiveOff":
                window.callLiveOff();
                break;

            case "ct_FinishLive":
                window.callFinishLive();
                break;

            case "ct_MicOn":
                window.callMicOn();
                break;

            case "ct_MicOff":
                window.callMicOff();
                break;

            case "ct_TouchScreenLock":
                window.lockTouchScreen();
                break;

            case "ct_TouchScreenUnLock":
                window.unLockTouchScreen();
                break;

            case "ct_Login":
                window.callLogin();
                break;

            case "ct_LoginResp":
                window.callLoginResp();
                break;

            case "ct_Logout":
                window.callLogout();
                break;

            case "ct_LogoutResp":
                window.callLogoutResp();
                break;

            default:
                console.log("xmitCmd_AndroidMessage - case default ... action[", action, "]");
                break;
        }
    }/*  else {
        if (getIsAlivePenCamService()) {
            let store = window.hiclasstv.store;
            const { user, live } = store.getState();
            const { userNickname, userSeq } = user;
            const { performLiveInfo } = live;

            console.log("xmitCmd_AndroidMessage - action[", action, "], tokenCmd[", tokenCmd, "], userSeq[", userSeq, "], userNickname[", userNickname, "], liveSeq[", performLiveInfo.liveSeq, "]");

            const sendData = getSendToMQBytes({
                tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
                text: JSON.stringify({
                    kind: "android",
                    action,
                    information: {
                        tokenCmd,
                        liveSeq: performLiveInfo.liveSeq,
                        userSeq: user_info ? user_info.userSeq : userSeq
                    }
                })
            }, user_info ? user_info.userNickname : userNickname);

            // console.log("xmitCmd_AndroidMessage - myPenCamServiceKey => ", myPenCamServiceKey);

            if (myPenCamServiceKey && myPenCamServiceKey !== "") {
                sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
            }
        }
    } */
}

export const xmitCmd_AndroidJsonMessage = (action, jsonData) => {
    let store = window.hiclasstv.store;
    const { user, live } = store.getState();
    const { userSeq, userNickname } = user;
    const { performLiveInfo } = live;

    console.log("xmitCmd_AndroidJsonMessage - action[", action, "], userSeq[", userSeq, "], userNickname[", userNickname, "], liveSeq[", performLiveInfo.liveSeq, "], jsonData => ", jsonData);

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind: "android",
            action,
            information: {
                ...jsonData,
                liveSeq: performLiveInfo.liveSeq,
                userSeq
            }
        })
    }, userNickname);

    // console.log("xmitCmd_AndroidMessage - myPenCamServiceKey => ", myPenCamServiceKey);

    if (myPenCamServiceKey && myPenCamServiceKey !== "") {
        sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
    }
}

export const xmitCmd_AndroidMessageForSmartTV = (kind, action, tokenCmd, userSeq, userNickname, liveSeq) => {
    console.log("xmitCmd_AndroidMessageForSmartTV - ", kind, action, tokenCmd, userSeq, userNickname, liveSeq);

    if (userSeq > -1) {
        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({
                kind,
                action,
                information: {
                    tokenCmd,
                    liveSeq,
                    userSeq,
                    smartTVTempKey
                }
            })
        }, userNickname);

        console.log("xmitCmd_AndroidMessageForSmartTV - myPenCamServiceKey => ", myPenCamServiceKey);

        if (myPenCamServiceKey && myPenCamServiceKey !== "") {
            sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
        }

        if (action === "ct_SmartTVLogout") {
            setIsAlivePenCamService(false);
        }
    } else {
        console.log(`xmitCmd_AndroidMessageForSmartTV - userSeq is ${userSeq}. Do not send message`);
    }
}

export const xmitCmd_AndroidMessageForGroupSmartTV = (kind, action, tokenCmd, list_member, liveSeq) => {
    console.log("xmitCmd_AndroidMessageForGroupSmartTV - ", kind, action, tokenCmd, list_member, liveSeq);

    for (let i = 0; i < list_member.length; i++) {
        let user_info = list_member[i];
        if (user_info.userSeq > -1) {
            const sendData = getSendToMQBytes({
                tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
                text: JSON.stringify({
                    kind,
                    action,
                    information: {
                        tokenCmd,
                        liveSeq,
                        userSeq: user_info.userSeq,
                        smartTVTempKey
                    }
                })
            }, user_info.userNickname);

            if (myPenCamServiceKeyArr && myPenCamServiceKeyArr.length > i) {
                let myPenCamServiceKey = myPenCamServiceKeyArr[i];
                console.log(`i[${i}] - myPenCamServiceKey[${myPenCamServiceKey}]`);
                sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);

                if (action === "ct_SmartTVLogout") {
                    setIsAlivePenCamService(false);
                }
            }
        } else {
            console.log(`xmitCmd_AndroidMessageForGroupSmartTV - userSeq is ${user_info.userSeq}. Do not send message`);
        }
    }
}

export const xmitCmd_MessageForSmartTV = (kind, action, tokenCmd, userSeq, userNickname, liveSeq, mode, localStreamingMode) => {
    console.log("xmitCmd_MessageForSmartTV - ", kind, action, tokenCmd, userSeq, userNickname, liveSeq, mode, localStreamingMode);

    if (userSeq > -1) {
        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
            text: JSON.stringify({
                kind,
                action,
                information: {
                    tokenCmd,
                    liveSeq,
                    userSeq,
                    mode,
                    localStreamingMode,
                    smartTVTempKey
                }
            })
        }, userNickname);

        let sendKey;

        if (kind === "android") {
            sendKey = getDefaultDirectKey(userSeq, 3);
        } else {
            sendKey = getDefaultDirectKey(userSeq, 0);
        }

        console.log("xmitCmd_MessageForSmartTV - sendKey => ", sendKey);

        sendDataToRbmq(sendKey, sendData.forWeb);
    } else {
        console.log(`xmitCmd_MessageForSmartTV - userSeq is ${userSeq}. Do not send message`);
    }
}

/**
 * android app용 HANDS_UP_INIT_DONE 메시지 보내기 메서드
 */
export const xmitCmd_AndroidInitDone = () => {
    console.log("xmitCmd_AndroidInitDone called...");
    if (getIsHandsUpStarted()) { // handsup이 시작했을 경우에만 앱 연동시 화면 캡쳐를 시작하도록 한다... by hjkim 20221025
        if (!isAndroidWebView()) {
            // android webview가 아니면 기존 로직 동작하도록 수정
            xmitCmd_AndroidMessage("ct_LiveOn", enTokenCMD.NULL); // test용 임시
            xmitCmd_AndroidMessage("ct_StartHandsUp", enTokenCMD.NULL); // test용 임시
        }
        androidHandsUpInitDone();
        console.log("xmitCmd_AndroidInitDone - case 4:) call sendMicStatus()");
        sendMicStatus(); // 20251117 ... HANDS_UP_INIT_DONE 다음으로 순서 변경 ... by hjkim

        xmitCmd_AndroidTouchScreenLock(); // test용 임시
    } else {
        console.log("xmitCmd_AndroidInitDone - handsup is not started ... ");
    }
}

export const xmitCmd_AndroidTouchScreenLock = () => {
    // 기존 코드 주석 처리
    /* if (getIsAlivePenCamService()) {
        let store = window.hiclasstv.store;
        const { live } = store.getState();
        const { isTouchScreenLocked } = live;
        if (isTouchScreenLocked) {
            if (getIsAndroidDevice()) {
                const { user } = store.getState();
                const { userNickname, userSeq } = user;
                const { performLiveInfo } = live;

                const sendData = getSendToMQBytes({
                    tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
                    text: JSON.stringify({
                        kind: "android",
                        action: "ct_TouchScreenLock",
                        information: {
                            tokenCmd: enTokenCMD.NULL,
                            liveSeq: performLiveInfo.liveSeq,
                            userSeq
                        }
                    })
                }, userNickname);

                if (myPenCamServiceKey && myPenCamServiceKey !== "") {
                    sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
                }
            } else { // ios case 는 없다고 가정 for PC
                let touchLockGuard = document.getElementById("touchLockGuard");
                if (touchLockGuard) {
                    touchLockGuard.style.display = "flex";
                    touchLockGuard.style.visibility = "visible";
                    touchLockGuard.style.zIndex = 51;
                }
            }
        }
    } */

    // 20251224 ... 여기부터 수정 코드 ... by hjkim
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { isTouchScreenLocked } = live;

    // 20251224 ... 안드로이드 WebView 전달 케이스 구분하도록 수정 ... by hjkim
    if (isAndroidWebView()) {
        console.log("Android Native WebView 모드");
        if (isTouchScreenLocked) {
            console.log("window.lockTouchScreen() 호출");
            window.lockTouchScreen();
        } else {
            console.log("window.unLockTouchScreen() 호출");
            window.unLockTouchScreen();
        }
    }/*  else {
        if (getIsAlivePenCamService()) {
            if (isTouchScreenLocked) {
                if (getIsAndroidDevice()) {
                    const { user } = store.getState();
                    const { userNickname, userSeq } = user;
                    const { performLiveInfo } = live;

                    const sendData = getSendToMQBytes({
                        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
                        text: JSON.stringify({
                            kind: "android",
                            action: "ct_TouchScreenLock",
                            information: {
                                tokenCmd: enTokenCMD.NULL,
                                liveSeq: performLiveInfo.liveSeq,
                                userSeq
                            }
                        })
                    }, userNickname);

                    if (myPenCamServiceKey && myPenCamServiceKey !== "") {
                        sendDataToRbmq(myPenCamServiceKey, sendData.forWeb);
                    }
                } else { // ios case 는 없다고 가정 for PC
                    let touchLockGuard = document.getElementById("touchLockGuard");
                    if (touchLockGuard) {
                        touchLockGuard.style.display = "flex";
                        touchLockGuard.style.visibility = "visible";
                        touchLockGuard.style.zIndex = 51;
                    }
                }
            }
        }
    } */
}

export const xmitCmd_IosMessage = (action, data) => {
    if (isIOSWebView()) {
        const message = {
            action: "pro-message",
            data: {
                action,
                data
            }
        }

        console.log("xmit ios message : ", message);

        window.webkit.messageHandlers.screenShareHandler.postMessage(message);
    }
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 HANDS_UP_ON 메시지를 보낼 때 사용하는 메서드
 * 
 * @param {Number} teacherSeq - 메시지를 받을 선생님의 사용자 시퀀스
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 * @param {String|undefined} senderName - 전달할 사용자 닉네임
 */
export const sendHandsUpOn = (teacherSeq, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.HANDS_UP_ON
    }, senderName);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 HANDS_UP_OFF 메시지를 보낼 때 사용하는 메서드
 * 
 * @param {Number} teacherSeq - 메시지를 받을 선생님의 사용자 시퀀스
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 * @param {String|undefined} senderName - 전달할 사용자 닉네임
 */
export const sendHandsUpOff = (teacherSeq, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.HANDS_UP_OFF
    }, senderName);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 HANDS_UP_INIT_DONE/HANDS_UP_INIT_DONE_MIXED 메시지를 보낼 때
 * 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 */
export const sendHandsUpInitDone = (liveSeq, userSeq) => {
    console.log("sendHandsUpInitDone - liveSeq[" + liveSeq + "], userSeq[" + userSeq + "]");
    if (liveSeq === -1 || userSeq === -1) return;

    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    store.dispatch(changeHandsUpStatusInfo({ kind: "connect" }));

    const { user, live } = store.getState();
    const { userNickname } = user;
    const { isMixedClassMember } = live;
    let BYTE1 = isMixedClassMember ? ConstCode.HANDS_UP_INIT_DONE_MIXED : ConstCode.HANDS_UP_INIT_DONE;
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);

    console.log("sendHandsUpInitDone - before window.isHandsUpInit[", window.isHandsUpInit, "]");

    // 20251124 ... init done 메시지 보낸 후, 다시 false로 변경
    window.isHandsUpInit = false;
    console.log("sendHandsUpInitDone - after window.isHandsUpInit[", window.isHandsUpInit, "]");
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 MIC_ON 메시지를 보낼 때 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 */
export const sendP2PSoundOn = (liveSeq, userSeq) => {
    console.log("sendP2PSoundOn - liveSeq[", liveSeq, "], userSeq[", userSeq, "]");
    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname } = user;
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.MIC_ON
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 MIC_OFF 메시지를 보낼 때 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 */
export const sendP2PSoundOff = (liveSeq, userSeq) => {
    console.log("sendP2PSoundOff - liveSeq[", liveSeq, "], userSeq[", userSeq, "]");
    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname } = user;
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.MIC_OFF
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 LOCAL_MIC_READY 메시지를 보낼 때 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 */
export const sendP2PSoundReadyLocal = (liveSeq, userSeq) => {
    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname } = user;
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.LOCAL_MIC_READY
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 GROUP_SMART_TV_USER_MAX 메시지를 보낼 때 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 */
export const sendGroupSmartTVMax = (liveSeq, userSeq) => {
    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname } = user;
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.GROUP_SMART_TV_USER_MAX
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * 260728 학생 강의 화면 확대를 교사에게 승인 요청한다.
 */
export const sendPresentationStudentRequest = (liveSeq, userSeq) => {
    const teacherSeq = rcvUserSeq;
    const store = window.hiclasstv.store;
    const { userNickname } = store.getState().user;
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: ConstCode.PRESENTATION_STUDENT_REQUEST
    }, userNickname);

    sendDataToRbmq(getDefaultDirectKey(teacherSeq, 1), sendData.forWeb);
}

/**
 * 260803 학생이 Class Monitor에 자신의 화면 최대화/최소화 목표 상태를 JSON으로 요청한다.
 */
export const sendClassMonitorUserScreenMode = (liveSeq, userSeq, isMaximized) => {
    const store = window.hiclasstv.store;
    const { userNickname } = store.getState().user;
    const sendKey = getDefaultDirectKey(rcvUserSeq, 1);
    const sendObject = {
        kind: "handsup", // 260803 학생 C#에서도 상태 회신이 웹으로 전달되도록 기존 허용 kind를 사용한다.
        action: "setUserScreenMode",
        information: { liveSeq, userSeq, isMaximized }
    };
    // 260803 기존 SmartTV 연결 요청과 동일한 학생 정보 포함 JSON 패킷으로 교사에게 전달한다.
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify(sendObject)
    }, userNickname);
    console.log(`sendClassMonitorUserScreenMode - sendKey[${sendKey}]`, sendObject);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * 261015 iOS Pro 소리 설정(마이크/시스템 소리 포함)을 앱이 직접 처리할 수 있도록
 * 교사 회신 키(myTeacherDirectKey)와 내 userSeq/닉네임을 iOS 앱에 등록(또는 해제)한다.
 * 앱은 교사의 audioSourceSettings 요청을 받아 적용 후 이 키로 audioSourceSettingsResult를 바로 회신한다(백그라운드 대응).
 */
export const syncIOSAudioSourceContext = () => {
    if (!isIOSWebView()) return;
    try {
        if (!myTeacherDirectKey) {
            window.webkit.messageHandlers.screenShareHandler.postMessage({ action: "pro-clearAudioSourceContext", data: {} });
            return;
        }
        const store = window.hiclasstv.store;
        const { userNickname } = store.getState().user;
        console.log(`syncIOSAudioSourceContext - routingKey[${myTeacherDirectKey}] userSeq[${myUserSeq}]`);
        window.webkit.messageHandlers.screenShareHandler.postMessage({
            action: "pro-registerAudioSourceContext",
            data: { routingKey: myTeacherDirectKey, userSeq: myUserSeq, userNickname: userNickname || "" }
        });
    } catch (e) {
        console.error("syncIOSAudioSourceContext - Exception:", e);
    }
}

/**
 * 261006 iOS 앱(Pro) 카메라 모드 전용 - 앱이 백그라운드로 가면 웹뷰 카메라와 JS가 모두 멈추므로,
 * 선생님(client_new handsup)에게 보낼 "카메라 중단/재개" JSON 패킷을 미리 만들어 iOS 네이티브에 맡긴다.
 * 네이티브는 백그라운드 진입 시 pausedPacket, 다시 활성화될 때 resumedPacket을 그대로 RBMQ로 보낸다.
 * isCameraMode=false(스크린 모드 전환/HandsUp 종료)면 맡겨둔 패킷을 해제한다(중단 상태였다면 네이티브가 stoppedPacket 전송).
 * 신호: { kind:"handsup", action:"studentCameraState", information:{ liveSeq, userSeq, paused, reason } }
 * (kind "handsup"은 교사 C#이 SEND_JSON_FROM_RBMQ로 그대로 handsup 페이지에 전달하는 기존 허용 kind)
 *
 * @param {Number} liveSeq - 라이브 시퀀스
 * @param {Number} userSeq - 학생 사용자 시퀀스
 * @param {Boolean} isCameraMode - 현재 카메라 모드 여부
 */
export const syncIOSCameraStatePackets = (liveSeq, userSeq, isCameraMode) => {
    if (!isIOSWebView()) return;
    try {
        if (!isCameraMode || typeof liveSeq !== "number" || liveSeq <= 0 || typeof userSeq !== "number" || rcvUserSeq === undefined) {
            window.webkit.messageHandlers.screenShareHandler.postMessage({ action: "pro-clearCameraStatePackets", data: {} });
            return;
        }
        const store = window.hiclasstv.store;
        const { userNickname } = store.getState().user;
        const sendKey = getDefaultDirectKey(rcvUserSeq, 1);
        const makePacket = (paused, reason) => {
            const sendObject = {
                kind: "handsup",
                action: "studentCameraState",
                information: { liveSeq, userSeq, paused, reason }
            };
            const sendData = getSendToMQBytes({
                tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
                text: JSON.stringify(sendObject)
            }, userNickname);
            return arrayBufferToBase64(sendData.forWeb);
        };
        console.log(`syncIOSCameraStatePackets - register sendKey[${sendKey}] liveSeq[${liveSeq}] userSeq[${userSeq}]`);
        window.webkit.messageHandlers.screenShareHandler.postMessage({
            action: "pro-registerCameraStatePackets",
            data: {
                routingKey: sendKey,
                pausedPacket: makePacket(true, "background"),
                resumedPacket: makePacket(false, "resumed"),
                stoppedPacket: makePacket(false, "camera_stopped")
            }
        });
    } catch (e) {
        console.error("syncIOSCameraStatePackets - Exception:", e);
    }
}

/**
 * 260803 Class Monitor의 현재 확대 학생을 전체 학생에게 JSON으로 알려 버튼 상태를 동기화한다.
 */
export const sendClassMonitorScreenState = (liveSeq, screenSeq, maximizedUserSeq, listMember) => {
    const sendData = {
        kind: "handsup", // 260803 교사 C#의 기존 SEND_JSON_FROM_RBMQ 전달 허용 kind를 사용한다.
        action: "screenStateChanged",
        information: { liveSeq, screenSeq, maximizedUserSeq }
    };
    (listMember || []).forEach(member => {
        if (member && member.userSeq > -1) sendCommandToRbmq(getDefaultDirectKey(member.userSeq, 0), sendData);
    });
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보 중
 * 선생님에게 마이크 볼륨 레벨 변화를 알리기 위해 메시지를 보낼 때 사용하는
 * 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 * @param {Number} soundLevel - 전달할 사운드 레벨
 */
export const sendMicVolumeLevel = (liveSeq, userSeq, soundLevel) => {
    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userNickname } = user;

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: soundLevel,
    }, userNickname);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 user login status 유형의 메시지 정보를
 * 보내기 위해 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 * @param {Number} userStatus - 전달할 사용자 상태값
 * @param {String|undefined} senderName - 전달할 사용자 닉네임
 */
export const sendUserLoginStatus = (liveSeq, userSeq, userStatus, senderName) => {
    console.log("sendUserLoginStatus - ", "liveSeq => ", liveSeq, ", userSeq => ", userSeq, ", userStatus => ", userStatus);
    console.log("teacherSeq => ", rcvUserSeq);

    if (rcvUserSeq === undefined || rcvUserSeq === null || rcvUserSeq < 0) return;

    let teacherSeq = rcvUserSeq;
    let finalSenderName = senderName ? senderName : "";
    if (finalSenderName === "") {
        let store = window.hiclasstv.store;
        const { user } = store.getState();
        const { userNickname } = user;
        console.log("userNickname => ", userNickname);
        finalSenderName = userNickname;
    }
    console.log("sendUserLoginStatus - finalSenderName => ", finalSenderName);

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_UserLoginInfo,
        CLASSID: liveSeq,
        PENID: userSeq,
        INT1: liveSeq,
        INT2: userSeq,
        BYTE1: userStatus
    }, finalSenderName);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk Pro에서 RBMQ 메시지로 선생님에게 Json 유형의 메시지 정보를
 * 보내기 위해 사용하는 메서드
 * 
 * @param {Number} liveSeq - 전달할 라이브 시퀀스 (= 클래스 시퀀스)
 * @param {Number} userSeq - 전달할 사용자 시퀀스
 * @param {Object} data - 전달할 데이터 (대부분 { kind, action, information } 구조)
 * @param {String|undefined} senderName - 전달할 사용자 닉네임
 * @since 2026-02-19.
 */
export const sendJsonData = (data, senderName) => {
    console.log("sendJsonData - data => " + data);

    let finalSenderName = senderName ? senderName : "";
    if (finalSenderName === "") {
        let store = window.hiclasstv.store;
        const { user } = store.getState();
        const { userNickname } = user;
        console.log("userNickname => ", userNickname);
        finalSenderName = userNickname;
    }
    console.log("sendJsonData - finalSenderName => ", finalSenderName);

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify(data)
    }, finalSenderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

/**
 * Pentalk WiFi에서 받은 JSON 유형의 데이터를
 * Pentalk Pro에 RBMQ 메시지로 전달해야 하는 경우
 * Pro 형식에 맞게 변환해서 보내기 위해 사용하는 메서드
 * 
 * @param {String} kind - 전달할 메시지 유형
 * @param {String} action - 전달할 메시지 액션
 * @param {JSON} information - 전달할 메시지 정보
 * @param {String|undefined} senderName - 전달할 사용자 닉네임
 * @since 2025-07-15.
 */
export const sendJsonInfoForPbl = (kind, action, information, senderName) => {
    console.log("sendJsonInfoForPbl - ", "kind[", kind, "], action[", action, "], information => ", information);
    console.log("teacherSeq[", rcvUserSeq, "]");

    if (rcvUserSeq === undefined || rcvUserSeq === null || rcvUserSeq < 0) return;

    let teacherSeq = rcvUserSeq;
    let finalSenderName = senderName ? senderName : "";
    if (finalSenderName === "") {
        let store = window.hiclasstv.store;
        const { user } = store.getState();
        const { userNickname } = user;
        console.log("userNickname => ", userNickname);
        finalSenderName = userNickname;
    }
    console.log("sendJsonInfoForPbl - finalSenderName[", finalSenderName, "]");

    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind,
            action,
            information
        })
    }, finalSenderName);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/**
 * Pentalk WiFi에서 받은 Token 유형의 데이터를
 * Pentalk Pro에 RBMQ 메시지로 전달해야 하는 경우
 * Pro 형식에 맞게 변환해서 보내기 위해 사용하는 메서드
 * 
 * @param {ArrayBuffer} tokenBuffer - 전달할 Token 데이터
 * @param {String} nickname - 전달할 사용자 닉네임
 * @since 2025-07-23.
 */
export const sendTokenDataForPbl = (tokenData, senderName) => {
    console.log("sendTokenDataForPbl - senderName[", senderName, "], tokenData => ", tokenData);
    console.log("teacherSeq[", rcvUserSeq, "]");

    if (rcvUserSeq === undefined || rcvUserSeq === null || rcvUserSeq < 0) return;

    let teacherSeq = rcvUserSeq;
    const sendData = getSendToEncodeBytes(tokenData, senderName);
    console.log("sendTokenDataForPbl - sendData => ", sendData);

    let sendKey = getDefaultDirectKey(teacherSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

/* export const sendNotifyMixedClassMember = (liveSeq, userSeq) => {
    let teacherSeq = rcvUserSeq;
    let store = window.hiclasstv.store;
    const { live } = store.getState();
    const { isMixedClassMember } = live;
    if (isMixedClassMember) {
        const { user } = store.getState();
        const { userNickname } = user;

        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.ct_UserLoginInfo,
            CLASSID: liveSeq,
            PENID: userSeq,
            INT1: liveSeq,
            INT2: userSeq,
            BYTE1: ConstCode.NOTIFY_MIXED_CLASS_MEMBER
        }, userNickname);
    
        let sendKey = getDefaultDirectKey(teacherSeq, 1);
        sendDataToRbmq(sendKey, sendData.forWeb);
    }
} */

export const sendChatMsg = (mode, textValue, emoMIDno, senderName, sendKey) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.chat_Text,
        emoGIDno: 0,   /* 0번 고정 */
        emoMIDno: emoMIDno,
        text: textValue
    }, senderName);

    if (mode === "whisper") {
        if (myTeacherDirectKey && myTeacherDirectKey !== "") {
            sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
        }
    } else {
        if (mySmallGroupSendKey && mySmallGroupSendKey !== "") {
            sendDataToRbmq(mySmallGroupSendKey, sendData.forWeb);
        } else {
            if (myHandsUpSendKey && myHandsUpSendKey !== "") {
                sendDataToRbmq(myHandsUpSendKey, sendData.forWeb);
            }

            // 20250716 추가 for pbl-class ... by hjkim
            if (sendKey && sendKey !== "") {
                sendDataToRbmq(sendKey, sendData.forWeb);
            }
        }
    }
}

export const sendChatInkMemo = (mode, imgData, liveSeq, userSeq, senderName, sendKey) => {
    let reader = new FileReader();
    let array;
    reader.readAsArrayBuffer(imgData);
    reader.onload = () => {
        array = reader.result;

        const sendData = getSendToMQBytes({
            tokenCmd: enTokenCMD.chat_Memo,
            CLASSID: liveSeq,
            PENID: userSeq,
            data: array
        }, senderName);

        if (mode === "whisper") {
            if (myTeacherDirectKey && myTeacherDirectKey !== "") {
                sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
            }
        } else {            
            if (mySmallGroupSendKey && mySmallGroupSendKey !== "") {
                sendDataToRbmq(mySmallGroupSendKey, sendData.forWeb);
            } else {
                if (myHandsUpSendKey && myHandsUpSendKey !== "") {
                    sendDataToRbmq(myHandsUpSendKey, sendData.forWeb);
                }

                // 20250716 추가 for pbl-class ... by hjkim
                if (sendKey && sendKey !== "") {
                    sendDataToRbmq(sendKey, sendData.forWeb);
                }
            }
        }
    };
}

/**
 * 20261015 음성메모 전송 실패 시 말풍선 실패 표시를 위한 콜백(onFail) 파라미터 추가
 * (학생 화면은 alert이 mqtt 재연결 타이머를 막을 수 있어 알림 없이 말풍선 표시만 처리)
 */
export const sendChatVoiceMemo = (mode, voiceData, liveSeq, userSeq, senderName, sendKey, onFail) => {
    // 20261015 음성메모 전송 실패 처리
    const handleVoiceMemoSendFail = (err) => {
        console.log("sendChatVoiceMemo - send fail => ", err);
        if (typeof onFail === "function") {
            onFail();
        }
    };

    let reader = new FileReader();
    let array;
    reader.readAsArrayBuffer(voiceData);
    // 20261015 파일 읽기 실패 처리 추가
    reader.onerror = () => {
        handleVoiceMemoSendFail(reader.error);
    };
    reader.onload = () => {
        // 20261015 변환/전송 중 예외 처리 추가
        try {
            array = reader.result;

            const sendData = getSendToMQBytes({
                tokenCmd: enTokenCMD.chat_Voice,
                CLASSID: liveSeq,
                PENID: userSeq,
                data: array
            }, senderName);

            if (mode === "whisper") {
                if (myTeacherDirectKey && myTeacherDirectKey !== "") {
                    sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
                }
            } else {      
                if (mySmallGroupSendKey && mySmallGroupSendKey !== "") {
                    sendDataToRbmq(mySmallGroupSendKey, sendData.forWeb);
                } else {
                    if (myHandsUpSendKey && myHandsUpSendKey !== "") {
                        sendDataToRbmq(myHandsUpSendKey, sendData.forWeb);
                    }

                    // 20250716 추가 for pbl-class ... by hjkim
                    if (sendKey && sendKey !== "") {
                        sendDataToRbmq(sendKey, sendData.forWeb);
                    }
                }
            }
        } catch (err) {
            handleVoiceMemoSendFail(err);
        }
    };
}

export const sendChangeInkMode = (mode, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_Mode,
        CLASSID: liveSeq,
        PENID: userSeq,
        byte1: mode
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const sendChangeInkColor = (color, liveSeq, userSeq, senderName) => {
    /** javascript와 c#의 rgba값 차이로 인해 값을 꼭 변환해서 보내야함 by hjkim 200704 */
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_Color,
        CLASSID: liveSeq,
        PENID: userSeq,
        byte1: color.R,
        byte2: color.G,
        byte3: color.B,
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const sendChangeInkTipSize = (width, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_Tip,
        CLASSID: liveSeq,
        PENID: userSeq,
        double1: width / 2,
        double2: width / 2,
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const sendClearInkStroke = (liveSeq, userSeq, senderName, sendKey) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_Clear,
        CLASSID: liveSeq,
        PENID: userSeq
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }

    if (mySmallGroupSendKey && mySmallGroupSendKey !== "") {
        sendDataToRbmq(mySmallGroupSendKey, sendData.forWeb);
    }

    // 20250716 추가 for pbl-class ... by hjkim
    if (sendKey && sendKey !== "") {
        sendDataToRbmq(sendKey, sendData.forWeb);
    }
}

export const sendEraseStroke = (spoint, epoint, liveSeq, userSeq, senderName, sendKey) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_Erase1,
        CLASSID: liveSeq,
        PENID: userSeq,
        SPT: spoint,
        EPT: epoint
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }

    if (mySmallGroupSendKey && mySmallGroupSendKey !== "") {
        sendDataToRbmq(mySmallGroupSendKey, sendData.forWeb);
    }

    // 20250716 추가 for pbl-class ... by hjkim
    if (sendKey && sendKey !== "") {
        sendDataToRbmq(sendKey, sendData.forWeb);
    }
}

export const sendInkStroke = (stroke, liveSeq, userSeq, senderName, sendKey) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_SingleStroke,
        CLASSID: liveSeq,
        PENID: userSeq,
        stroke: stroke,
        mode: stroke.mode,
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }

    if (mySmallGroupSendKey && mySmallGroupSendKey !== "") {
        sendDataToRbmq(mySmallGroupSendKey, sendData.forWeb);
    }

    // 20250716 추가 for pbl-class ... by hjkim
    if (sendKey && sendKey !== "") {
        sendDataToRbmq(sendKey, sendData.forWeb);
    }
}

export const sendInkStrokeDown = (point, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_SDn,
        CLASSID: liveSeq,
        PENID: userSeq,
        SPT: point,
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const sendInkStrokeMove = (point, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_SM,
        CLASSID: liveSeq,
        PENID: userSeq,
        SPT: point,
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}

export const sendInkStrokeUp = (point, liveSeq, userSeq, senderName) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.Ink_SUp,
        CLASSID: liveSeq,
        PENID: userSeq,
        SPT: point,
    }, senderName);

    if (myTeacherDirectKey && myTeacherDirectKey !== "") {
        sendDataToRbmq(myTeacherDirectKey, sendData.forWeb);
    }
}
/********************************/

/** p2p 정보 보내기용 */
export const sendCandidate = (candidate, liveSeq, userSeq) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind: "handsup",
            action: "candidate",
            information: {
                candidate,
                liveSeq,
                userSeq
            }
        })
    }, "handsup_signaling");

    let sendKey = getDefaultDirectKey(rcvUserSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}

export const sendDescription = (description, liveSeq, userSeq, isp2pCreate) => {
    const sendData = getSendToMQBytes({
        tokenCmd: enTokenCMD.ct_SendToWebJSonInfo,
        text: JSON.stringify({
            kind: "handsup",
            action: "description",
            information: {
                sdp: description,
                liveSeq,
                userSeq,
                isp2pCreate
            }
        })
    }, "handsup_signaling");

    let sendKey = getDefaultDirectKey(rcvUserSeq, 1);
    sendDataToRbmq(sendKey, sendData.forWeb);
}
/********************************/

/** Android Pro 앱용 */
// const connectPenCamService = (userSeq, teacherSeq, liveSeq, chatRoomSeq, host, isMixedClassMember, isReconnMode, isP2PMode) => {
// const connectPenCamService = ({ userSeq, teacherSeq, localTeacherSeq, liveSeq, localLiveSeq, chatRoomSeq, host, isP2PMode, isMixedClassMember, configFPSKind, isSupportedAccessibilityService }) => {
const connectPenCamService = (info) => {
    /**
     * intent:
     *      HOST/URI-path // Optional host
     *      #Intent;
     *          package=\[string\];
     *          action=\[string\];
     *          category=\[string\];
     *          component=\[string\];
     *          scheme=\[string\];
     *      end;
     * 
     * //pentalkcapture.service-web/websocket
     * intent:
     *      #Intent;
     *          package=com.easy.pentalkcapture;
     *          scheme=easy-web;
     *      end;
     */

    console.log("connectPenCamService - ", info);

    let packageName = "com.easy.pentalkcapture.pro";    // 20250416 ... pro 용 앱 호출 추가 ... by hjkim

    let url = `https://play.google.com/store/apps/details?id=${packageName}`;

    // let link = document.createElement("a");
    // link.href = url;
    // link.target = "_blank";
    // link.click();
    window.location.href = url;

    // 20260310 기존 코드 주석 처리
    /* // 20250509 ... 혹시라도 commit 시 주석 처리 실수 방지를 위해 테스트 기간 동안 isDevVer 와 isMediaSoupVersion 값에 따라 호출 앱이 바뀌도록 수정함 ... by hjkim
    let packageName = "com.easy.pentalkcapture";        // 기존 통합 앱 호출 방식
    if (isDevVer && isMediaSoupVersion) {
        packageName = "com.easy.pentalkcapture.pro";    // 20250416 ... pro 용 앱 호출 추가 ... by hjkim

        let url = `https://play.google.com/store/apps/details?id=${packageName}`;

        // let link = document.createElement("a");
        // link.href = url;
        // link.target = "_blank";
        // link.click();
        window.location.href = url;
    } else {
        if (!getIsAlivePenCamService()) {
            // console.log("connectPenCamService-case1");
            let url = `intent://pentalkcapture.service?`;
            url += `userSeq=${info.userSeq}`;
            url += `&teacherSeq=${info.teacherSeq}&liveSeq=${info.liveSeq}`;
            url += `&chatRoomSeq=${info.chatRoomSeq}`;
            url += `&rbmqHost=${info.host}&rbmqPort=${info.port}`; // 20250321 ... rbmqPort(5673) 바뀐 버전인지 판단하는 값 ... by hjkim
            url += `&isP2PMode=${info.isP2PMode}`;
            url += `&isMixedClassMember=${info.isMixedClassMember}`;
            if (info.isMixedClassMember) {
                url += `&localTeacherSeq=${info.localTeacherSeq}&localLiveSeq=${info.localLiveSeq}`;
            }
            url += `&isGuestMember=${info.isGuestMember}`; // 20241128 ... 앱에서 게스트 멤버인지 아닌지를 판단하는 값 ... by hjkim (왜 전달하는 부분이 빠졌지..?ㅁ? 다시 추가..)
            url += `&configFPSKind=${info.configFPSKind}`;
            url += `&isMediaSoupVersion=${info.isMediaSoupVersion}`; // 20250320 ... mediasoup 지원 버전인지 체크하는 값 ... by hjkim
            url += `&isSupportedWebRtcAudio=${info.isSupportedWebRtcAudio}`; // 20241128 ... 앱에서 WebRtc 지원해야하는 버전인지 판단하는 값. 마이크 권한 확인 다이얼로그를 띄우기 위해 전달 ... by hjkim
            url += `&isSupportedAccessibilityService=${info.isSupportedAccessibilityService}`; // 20241118 ... 접근성 서비스 지원해야하는 버전인지 판단하는 값 ... by hjkim
            if (isDevVer && isMediaSoupVersion) { // 20250509 ... 혹시라도 commit 시 주석 처리 실수 방지를 위해 테스트 기간 동안 isDevVer 와 isMediaSoupVersion 값에 따라 바뀌도록 수정함 ... by hjkim
                url += `&userGateWay=${info.userGateWay}`;  // 20250320 ... mediasoup 서버 게이트 웨이 값 ... by hjkim
            }
            url += `#Intent;scheme=easy;action=android.intent.action.VIEW;`;
            url += `category=android.intent.category.BROWSABLE;`;
            url += `package=${packageName};end`;
            // url += `package=com.easy.pentalkcapture;end`;

            // let link = document.createElement("a");
            // link.href = url;
            // link.target = "_blank";
            // link.click();
            window.location.href = url;
        } else {
            // console.log("connectPenCamService-case2");
            // alert("Already Connected PenCamService");
            // 이미 Pentalk OnScreen 앱과 연결되어 있습니다.
            // It is already connected to the Pentalk OnScreen app.
            console.log("Already Connected to the Pentalk OnScreen app.");
            let str = "이미 Pentalk OnScreen 앱과 연결되어 있습니다.";
            alert(str);
        }
    } */
}

/**
 * Android에서 전달되는 메시지를 처리합니다.
 * WebViewActivity에서 이 함수를 호출합니다.
 * 
 * @param {Object} message 수신된 메시지
 * @param {String} message.action 액션 타입
 * @param {Object} message.data 데이터 (action에 따라 다름)
 * @since 2025-12-18.
 */
window.handleAndroidScreenShareMessage = function (message) {
    const { action, data } = message;
    console.log("📨 Android ScreenShare Message: ", action, data);

    let store = window.hiclasstv.store;

    switch (action) {
        case "audioSourceSettingsResult":
            // 20261001 CapturePro의 실제 mixed audio 적용 결과를 공통 frontend 소리 설정 UI에 전달한다.
            window.dispatchEvent(new CustomEvent("handsUpAudioSourceSettingsResult", { detail: data }));
            break;

        case "ct_Login":
            console.log("Login response: ", data.status, data.message);
            // Connected 또는 Already
            if (data.status === enTabStatus.Connected) {
                // 새로운 연결 성공
                rcvCmd_AndroidLogin(myUserSeq);
            } else if (data.status === enTabStatus.Already) {
                // 이미 연결되어 있음
                console.log(`already connected pencam service`);
            }
            break;

        case "ct_LoginResp":
            console.log("Login response: ", data.status, data.message);
            // Connected 또는 Already
            if (data.status === enTabStatus.Connected) {
                // 새로운 연결 성공
                rcvCmd_AndroidLoginResp(myUserSeq)
            } else if (data.status === enTabStatus.Already) {
                // 이미 연결되어 있음
                console.log(`already connected pencam service`);
            }
            break;

        case "ct_Logout":
            console.log("Logout response: ", data.status, data.message);
            // NotConnected
            // 로그아웃 완료 처리
            if (data.status === enTabStatus.Disconnected) {
                // 로그아웃 성공
                rcvCmd_AndroidLogout(myUserSeq)
            } else if (data.status === enTabStatus.Already) {
                // 이미 연결 해제되어 있음
                console.log(`already disconnected pencam service`);
            }
            break;

        case "ct_LogoutResp":
            console.log("Logout response: ", data.status, data.message);
            // NotConnected
            // 로그아웃 완료 처리
            if (data.status === enTabStatus.Disconnected) {
                // 로그아웃 성공
                rcvCmd_AndroidLogoutResp(myUserSeq)
            } else if (data.status === enTabStatus.Already) {
                // 이미 연결 해제되어 있음
                console.log(`already disconnected pencam service`);
            }
            break;

        case "ct_ReconnModeResp":
            console.log("Reconnect response: ", data.status, data.message);
            // Connected
            // 재연결 성공 처리
            if (data.status === enTabStatus.Connected) {
                // 재연결 성공
                rcvCmd_AndroidLoginResp(myUserSeq)
            } else {
                console.log(`already connected pencam service`);

                // 새로운 연결 성공
                rcvCmd_AndroidReconnResp(myUserSeq)
            }
            break;

        case "ct_MicOn":
            console.log("mic on response: ", action, data.status);
            rcvCmd_AndroidMicStatus(myUserSeq, data.status);
            break;

        case "ct_MicOff":
            console.log("mic off response: ", action, data.status);
            rcvCmd_AndroidMicStatus(myUserSeq, data.status);
            break;

        // ========================================
        // RabbitMQ 연결 성공
        // ========================================
        case "pro-connectedRbmq":
            // 20260106 ... 믹스드 클래스를 위해 connection 관련만 정리되도록 수정
            if (data.kind === "mixed-class") {
                console.log("🔌 RabbitMQ 연결 성공 - call onSuccessConnectForMixedClass().");
                onSuccessConnectForMixedClass();
            } else {
                console.log("🔌 RabbitMQ 연결 성공 - call onSuccessConnect().");
                onSuccessConnect();
            }
            break;

        // ========================================
        // RabbitMQ 연결 해제
        // ========================================
        case "pro-disconnectedRbmq":
            // 20260106 ... 믹스드 클래스를 위해 disconnect 관련만 정리되도록 수정
            console.log("🔌 RabbitMQ 연결 해제 성공!");

            // isConnectedAndroidApp = false;
            setIsAlivePenCamService(false, myUserSeq);
            isIntentionalDisconnect = true; // PC mqtt 라이브러리 변경으로 인해 정상 동작을 위한 처리 추가 ... by hjkim 20260413
            console.log("call onConnectionLost({ errorCode: enRbmqError.OK }).");
            onConnectionLost({ errorCode: enRbmqError.OK });    // 다음 로그인을 위한 처리 추가
            break;

        // ========================================
        // RabbitMQ 연결 실패 처리
        // ========================================
        case "pro-failureConnectRbmq":
            console.log("❌ RabbitMQ 연결 실패!");
            onFailureConnect(normalizeMqttError(data, enRbmqError.CONNACK_RETURNCODE));
            break;

        case "pro-unsupportedVersionRbmq":
            console.log("❌ RabbitMQ 연결 실패! - MQTT 지원하지 않는 버전의 서버 사용");
            onFailureConnect({ errorCode: data.code, errorMessage: data.message, isNoAlert: true });
            break;

        // ========================================
        // RabbitMQ 메시지 수신 (가장 중요!)
        // ========================================
        case "pro-rcvRbmqMessage":
            // console.log("📬 RabbitMQ 메시지 수신 - routingKey[" + data.routingKey + "]");

            // ✅ data 구조:
            // {
            //   routingKey: string,
            //   bodyBase64: string,
            //   bodySize: number
            // }

            try {
                // ========================================
                // 자기 자신이 보낸 메시지는 무시
                // ========================================
                if (myHandsUpSendKey === data.routingKey ||
                    mySmallGroupSendKey === data.routingKey ||
                    mySmallGroupImageSendKey === data.routingKey) {
                    console.log("자신이 보낸 메시지 무시:", data.routingKey);
                    return;
                }

                // Base64 디코딩
                const binaryString = atob(data.bodyBase64);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                // console.log("✅ Base64 디코딩 완료:", bytes.length, "bytes");

                // ✅ 기존 rawDataWithRoutingKey 함수 호출
                // (rcvMsgFromRbmq.js에 정의된 함수)
                rawDataWithRoutingKey(bytes.buffer, data.routingKey);

                // console.log("✅ 메시지 처리 완료");
            } catch (e) {
                console.error("❌ RabbitMQ 메시지 처리 실패:", e);
            }
            break;

        // ========================================
        // 화면 공유 시작됨
        // ========================================
        case "pro-startedScreenShare":
            console.log("🔌 화면 공유 시작됨");
            console.log("isHandsupInit:", window.isHandsUpInit);

            setScreenModeImage("connect");
            relayLive.nativeStarted(); // 20261026 R-187 새 native 송출에 현재 전체 소리 ON/OFF 재적용
            if (!window.isHandsUpInit) relayLive.rejoin(); // 20261022 같은 페이지 재시작(끊김 복구)이면 입장 기록 복원 (web-relay R-173)

            if (window.isHandsUpInit) {
                console.log("sendHandsUpInitDone called ... case 12");
                // sendHandsUpInitDone(getHandsUpLiveSeq(), getHandsUpUserSeq());
                // sendP2PSoundOff(getHandsUpLiveSeq(), getHandsUpUserSeq());
                const { live } = store.getState();
                const { performLiveInfo } = live;
                let liveSeq = performLiveInfo.liveSeq;
                sendHandsUpInitDone(liveSeq, myUserSeq);
                sendP2PSoundOff(liveSeq, myUserSeq);
            }
            break;

        // ========================================
        // 화면 공유 중지됨
        // ========================================
        case "pro-stoppedScreenShare":
            console.log("🔌 화면 공유 중지됨");
            // 필요한 처리 추가 가능
            rcvCmd_AndroidCaptureStatus("pro-stoppedScreenShare", myUserSeq, false);
            break;

        // ========================================
        // 화면 이미지 프레임 수신 (현재 미사용)
        // ========================================
        case "pro-screenImageFrame":
            console.log("📸 화면 이미지 프레임 수신:", data);
            // Android는 WebRTC를 사용하므로 이미지는 직접 전송 안 함
            // 필요시 구현
            break;

        // ========================================
        // MediaSoup 재연결 요청
        // ========================================
        case "pro-reconnectMediasoup":
            console.log("🔄 MediaSoup 재연결 요청");
            unsubscribe(false, true);
            break;

        // ========================================
        // 260930 네이티브 송출 transport 상태 (ICE 재시작 판단용)
        // data: { state: "connected" | "disconnected" | "failed" | "closed", transportId }
        // (프론트·Android 합의 09-30 — web-frontend-native-producer-restart-recheck-20260930.md §3)
        // ========================================
        case "pro-producerTransportState":
            console.log("pro-producerTransportState - ", data);
            if (data) producerTransportStateFromNative(data.state, data.transportId);
            break;

        // ========================================
        // 261027 네이티브가 MQ 를 새 clientId 로 스스로 되살렸다(구독 복구 뒤). 첫 접속(pro-connectedRbmq)과 다르다.
        // data: { reason: "self-reconnect", connLostReported }
        // (Android android-answer-pro-round98-and-frontend-signals-20261027.md §2)
        // ========================================
        case "pro-rbmqRevived":
            rbmqRevivedFromNative(data);
            break;

        // ========================================
        // 261027 네이티브가 MQ 가 닫혀 메시지를 보내지 못하고 버렸다. 다시 보내지는 않는다 — 그 판단은 웹 몫이고
        // 송출 재생성은 pro-rbmqRevived · 재생성 감시가 맡는다. 여기서는 기록만 한다.
        // data: { routingKey, size, reason: "mq-closed" } (Android 98차 답 §4)
        // ========================================
        case "pro-rbmqSendDropped":
            console.log(`⚠ pro-rbmqSendDropped - 네이티브가 보내지 못하고 버렸다. routingKey[${data && data.routingKey}], size[${data && data.size}], reason[${data && data.reason}]`);
            break;

        // ========================================
        // ViewKind 변경 (카메라/화면)
        // ========================================
        case "changedViewKind":
            console.log("🔄 ViewKind 변경:", getViewKind());

            if (getViewKind() === "CAMERA") {
                setUpVideoStream(false);
            } else {
                setScreenModeImage("connect");
            }
            break;

        // ========================================
        // 에러 발생
        // ========================================
        case "error":
            console.error("❌ Android 에러:", data);
            alert("❌ Android 에러: " + data);

            // 에러 처리 (필요시 추가)
            break;

        case "rbmqError": {
            // Android에서 전달된 RabbitMQ 에러 → writeRbmqErrorMessage로 위임
            const { errorCode, errorMessage } = data;
            writeRbmqErrorMessage("Android", { errorCode, errorMessage });
        } break;

        // ========================================
        // 알 수 없는 액션
        // ========================================
        default:
            console.log("❓ 알 수 없는 Android 메시지 액션:", action);
            break;
    }
}

/**
 * RabbitMQ 바인딩 결과 수신 콜백
 * Android에서 호출됨
 *
 * @param {Object} result - 결과 객체
 * @param {String} result.action - 작업 타입 (subscribeLive, unsubscribeLive 등)
 * @param {boolean} result.success - 성공 여부
 * @param {Array<String>} result.bindKeys - 바인딩 키 배열
 * @param {String} [result.error] - 에러 메시지 (실패 시)
 * @since 2025-12-30.
 */
window.onRbmqBindingResultFromAndroid = function (result) {
    if (isEmptyObj(result)) return;

    console.log("========================================");
    console.log("RabbitMQ 바인딩 결과 수신");
    console.log("   - Action: ", result.action);
    console.log("   - Success: ", result.success);
    console.log("   - BindKeys: ", result.bindKeys);
    console.log("   - ErrorCode: ", result.code);

    if (result.message) {
        console.error("   - ErrorMessage: ", result.message);
    }
    console.log("========================================");

    // 성공/실패에 따른 처리
    if (result.success) {
        console.log(`✅ ${result.action} 성공`);

        // 각 작업별 처리
        switch (result.action) {
            case "pro-subscribeWeb":
                console.log("웹 바인딩 완료:", result.bindKeys);
                if (result.success) {
                    // 웹 구독 완료 처리
                    if (isMixedClassMember) {
                        console.log("✅ 웹 구독 성공 - 믹스드 클래스 멤버인 경우");
                        onSuccessSubscribeForMixedClass();
                    } else {
                        console.log("✅ 웹 구독 성공");
                        onSuccessSubscribe();
                    }
                } else {
                    // 웹 구독 실패 처리
                    console.log("✅ 웹 구독 실패 - ", result.code, result.message);
                    // onFailureSubscribe();
                    onFailureSubscribe({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-unsubscribeWeb":
                console.log("웹 바인딩 해제 완료:", result.bindKeys);
                if (result.success) {
                    // 웹 구독 해제 완료 처리
                    console.log("✅ 웹 구독 해제 성공");
                    onSuccessUnsubscribe();
                } else {
                    // 웹 구독 해제 실패 처리di
                    console.log("✅ 웹 구독 해제 실패 - ", result.code, result.message);
                    // onFailureUnsubscribe();
                    onFailureUnsubscribe({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-subscribeLive":
                console.log("Live 바인딩 완료:", result.bindKeys);
                if (result.success) {
                    // Live 구독 완료 처리
                    console.log("✅ Live 구독 성공");
                    onSuccessSubscribeLive();
                } else {
                    // Live 구독 실패 처리
                    console.log("✅ Live 구독 실패 - ", result.code, result.message);
                    // onFailureSubscribeLive();
                    onFailureSubscribeLive({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-unsubscribeLive":
                console.log("Live 바인딩 해제 완료:", result.bindKeys);
                if (result.success) {
                    // Live 구독 해제 완료 처리
                    console.log("✅ Live 구독 해제 성공");
                    onSuccessUnsubscribeLive();
                } else {
                    // Live 구독 해제 실패 처리
                    console.log("✅ Live 구독 해제 실패 - ", result.code, result.message);
                    // onFailureUnsubscribeLive();
                    onFailureUnsubscribeLive({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-subscribeSmallGroup":
                console.log("SmallGroup 바인딩 완료:", result.bindKeys);
                if (result.success) {
                    // SmallGroup 구독 완료 처리
                    console.log("✅ SmallGroup 구독 성공");
                    onSuccessSubscribeSmallGroup();
                } else {
                    // SmallGroup 구독 실패 처리
                    console.log("✅ SmallGroup 구독 실패 - ", result.code, result.message);
                    // onFailureSubscribeSmallGroup();
                    onFailureSubscribeSmallGroup({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-unsubscribeSmallGroup":
                console.log("SmallGroup 바인딩 해제 완료:", result.bindKeys);
                if (result.success) {
                    // SmallGroup 구독 해제 완료 처리
                    console.log("✅ SmallGroup 구독 해제 성공");
                    onSuccessUnsubscribeSmallGroup();
                } else {
                    // SmallGroup 구독 해제 실패 처리
                    console.log("✅ SmallGroup 구독 해제 실패 - ", result.code, result.message);
                    // onFailureUnsubscribeSmallGroup();
                    onFailureUnsubscribeSmallGroup({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-subscribeTempKey":
                console.log("Temp 키 구독 완료:", result.bindKeys);
                if (result.success) {
                    // Temp 키 구독 완료 처리
                    console.log("✅ 믹스드 클래스 임시 키 구독 성공");
                    onSuccessSubscribeTempKeyForMixedClass();
                } else {
                    // Temp 키 구독 실패 처리
                    console.log("✅ 믹스드 클래스 임시 키 구독 실패 - ", result.code, result.message);
                    // onFailureSubscribe();
                    onFailureSubscribe({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            case "pro-unsubscribeTempKey":
                console.log("Temp 키 구독 해제 완료:", result.bindKeys);
                if (result.success) {
                    // Temp 키 구독 해제 완료 처리
                    console.log("✅ 믹스드 클래스 임시 키 구독 해제 성공");
                    onSuccessUnsubscribeTempKeyForMixedClass();
                } else {
                    // Temp 키 구독 해제 실패 처리
                    console.log("✅ 믹스드 클래스 임시 키 구독 해제 실패 - ", result.code, result.message);
                    // onFailureUnsubscribe();
                    onFailureUnsubscribe({ errorCode: result.code, errorMessage: result.message });
                }
                break;

            // ========================================
            // 알 수 없는 액션
            // ========================================
            default:
                console.log("❓ 알 수 없는 Android 메시지 액션:", result.action, result.code, result.message);
                break;
        }
    } else {
        console.error(`❌ ${result.action} 실패:`, result.code, result.message);

        // 실패 처리
        // 예: 재시도, 에러 메시지 표시 등
        // writeRbmqErrorMessage("onRbmqBindingResultFromAndroid", { errorCode: result.error });
    }
}
/********************************/

/**
 * [C# WebView → JS 호출용]
 * intensiveControl content-send-ack 메시지를 선생님께 RabbitMQ로 전송합니다.
 *
 * 학생 기기(EoBrowser)가 선생님의 콘텐츠 전송(url-start / app-start / file-upload)에 대해
 * 처리 결과를 선생님께 응답할 때 사용합니다.
 *
 * ▶ 내부 동작:
 *   1. Redux store에서 현재 학생의 userSeq, userNickname을 읽어옵니다.
 *   2. { kind, action, information } 구조의 JSON 데이터를 구성합니다.
 *   3. sendJsonData()를 통해 myTeacherDirectKey로 RBMQ 메시지를 전송합니다.
 * 
 * @param {string} action
 *   메시지의 유형
 *  - "intensiveControl" : 집중 제어(콘텐츠 일괄 전송) 관련 메시지
 *  - "whisper-intensiveControl" : 귓속말 집중 제어 관련 메시지
 *
 * @param {string} contentType
 *   전송된 콘텐츠의 종류
 *   - "url-start"   : 웹 URL 열기 명령
 *   - "app-start"   : 앱 실행 명령
 *   - "file-upload" : 파일 다운로드/실행 명령
 *
 * @param {number} contentSeq
 *   선생님이 전송한 콘텐츠의 고유 시퀀스 번호
 *   (선생님 측에서 어떤 항목에 대한 응답인지 식별하는 데 사용됨)
 *
 * @param {string} status
 *   기기의 처리 결과 상태값
 *   - "received"         : 명령을 정상 수신 및 처리 완료
 *   - "executed"         : 앱/URL이 실행됨 (launched)
 *   - "downloaded"       : 파일 다운로드 완료
 *   - "not_installed"    : 앱이 설치되어 있지 않음
 *   - "not_support"      : 해당 기능을 지원하지 않는 기기/OS
 *   - "permission_denied": 권한 거부로 실행 불가
 *
 * @example
 *   // C# 호출 예시
 *   await webView.CoreWebView2.ExecuteScriptAsync(
 *       "window.sendContentSendAck('url-start', 42, 'received')"
 *   );
 *
 *   // 앱 미설치 응답 예시
 *   await webView.CoreWebView2.ExecuteScriptAsync(
 *       "window.sendContentSendAck('app-start', 7, 'not_installed')"
 *   );
 *
 * @since 2026-06-12
 */
window.sendContentSendAck = function (action, contentType, contentSeq, status) {
    console.log("window.sendContentSendAck - action[", action, "], contentType[", contentType, "], contentSeq[", contentSeq, "], status[", status, "]");

    // ── 1. 매개변수 유효성 검사 ──────────────────────────────────────────
    //   contentType이 지원하는 값인지 체크합니다.
    const validContentTypes = ["url-start", "app-start", "file-upload"];
    if (!validContentTypes.includes(contentType)) {
        console.warn("window.sendContentSendAck - 유효하지 않은 contentType:", contentType);
        return;
    }

    //   status가 지원하는 값인지 체크합니다.
    const validStatuses = ["received", "executed", "downloaded", "not_installed", "not_support", "permission_denied"];
    if (!validStatuses.includes(status)) {
        console.warn("window.sendContentSendAck - 유효하지 않은 status:", status);
        return;
    }

    //   contentSeq는 정수여야 합니다.
    const parsedContentSeq = parseInt(contentSeq, 10);
    if (isNaN(parsedContentSeq)) {
        console.warn("window.sendContentSendAck - 유효하지 않은 contentSeq:", contentSeq);
        return;
    }

    // ── 2. Redux store에서 현재 학생 정보 취득 ───────────────────────────
    //   userSeq  : 메시지 수신자(선생님)가 누가 보낸 것인지 식별하는 학생 고유 번호
    //   userNickname : sendJsonData()의 senderName 파라미터로 사용
    let store = window.hiclasstv.store;
    const { user } = store.getState();
    const { userSeq, userNickname } = user;

    // ── 3. intensiveControl content-send-ack 메시지 JSON 구성 ────────────
    //   rcvMsgFromRbmq.js의 기존 패턴과 동일한 구조를 유지합니다.
    const data = {
        kind: "live",                   // 라이브 수업 관련 메시지
        // action: "intensiveControl",     // 집중 제어(콘텐츠 일괄 전송) 응답
        action: action ?? "intensiveControl", // action이 전달되지 않으면 기본값으로 "intensiveControl" 사용
        information: {
            kind: "content-send-ack",   // 콘텐츠 전송에 대한 수신 확인(ACK)
            contentType,                // 어떤 종류의 콘텐츠였는지
            contentSeq: parsedContentSeq, // 어떤 콘텐츠 항목에 대한 응답인지
            userSeq,                    // 응답을 보내는 학생의 userSeq
            status,                     // 처리 결과
        }
    };

    console.log("window.sendContentSendAck - 전송할 data => ", data);

    // ── 4. RBMQ 전송 ──────────────────────────────────────────────────────
    //   sendJsonData()는 myTeacherDirectKey를 사용해 선생님의 큐로 직접 전송합니다.
    //   myTeacherDirectKey가 null이면 전송이 스킵되므로,
    //   라이브 수업 중(HandsUp 연결 후)에만 유효합니다.
    sendJsonData(data, userNickname);

    console.log("window.sendContentSendAck - 전송 완료");
}

/** etc */
export const alertErrMsg = (err) => {
    alert(err);
}

// 260728 ClassMonitor는 서버 발급 receiverSeq/CM routing key를 SmartTV 화면 번호로 덮어쓰지 않는다.
export const connectLiveForClassMonitor = (bindKeyArr, startSeqOfSmartTV, userGateWay) => {
    try {
        smartTVInfo.seq = startSeqOfSmartTV;
        smartTVInfo.bindKeyArr = bindKeyArr;
        smartTVInfo.bindKey = bindKeyArr[1];
        if (pingInterval === null) pingInterval = setInterval(() => { sendPingToRbmq(); }, 25000);
        routingKey = userGateWay && userGateWay !== "" ? userGateWay : getServerDefaultRoutingKey();
        if (rbmqClient && smartTVTempKey) {
            unsubscribeTopics([smartTVTempKey], {
                timeoutSec: 3,
                onSuccess: onSuccessUnsubscribeTempKeyForSmartTV,
                onFailure: onFailureUnsubscribeTempKeyForSmartTV,
                failureCode: enRbmqError.INTERNAL_ERROR
            });
        }
    } catch (err) {
        console.log("connectLiveForClassMonitor error => ", err);
    }
}

// 260728 ClassMonitor bindInfo의 사용자 인덱스를 전용 전체 학생 목록에 매핑한다.
export const getSmartTVListMember = () => smartTVInfo.list_member || [];

// 260728 공용 학생/교사 키와 모니터 고유 생명주기 키를 함께 구독한다.
export const setRbmqInfoForClassMonitor = async ({ receiverSeq, monitorSessionId, monitorBindKey, list_member, rbmq_info, tempKey, live_info }) => {
    initStateValue();
    isSmartTVMode = true;
    smartTVTempKey = tempKey;
    smartTVInfo.liveSeq = live_info.liveSeq;
    smartTVInfo.teacherSeq = live_info.teacher_info.userSeq;
    smartTVInfo.teacher_info = live_info.teacher_info;
    smartTVInfo.groupSeq = -1;
    smartTVInfo.userSeq = receiverSeq;
    smartTVInfo.userNickname = "ClassMonitor";
    smartTVInfo.list_member = list_member || [];
    smartTVInfo.isSend = false;
    myUserSeq = receiverSeq;
    myGroupSeq = -1;
    routingIdx = -1;
    rbmqInfo = rbmq_info;
    currentPageType = enWebPage.ClassMonitor;
    rememberLoginRecoveryPath(); // 20261020 R-126 새로고침 복귀 경로 저장

    smartTVInfo.list_member.forEach(member => {
        myPenCamServiceKeyArr.push(getDefaultDirectKey(member.userSeq, 3));
    });
    // 260728 교사/수업 공용 명령은 T.liveSeq.0으로 받고, 응답과 서버 정리는 CM 고유 키를 사용한다.
    myRoutingKeyArr.push(`T.${live_info.liveSeq}.0`);
    // 260728 학생별 C.0.userSeq.4 binding은 만들지 않아 불필요한 구독 증가를 막는다.
    myRoutingKeyArr.push(monitorBindKey);
    initClientInfoForClassMonitor(receiverSeq, monitorSessionId, monitorBindKey, smartTVInfo.list_member);
    await initLiveInfo(live_info.liveSeq, live_info.teacher_info.userSeq, live_info.teacher_info);
    await connectRbmqForClassMonitor();
}
